(function() {
//     Underscore.js 1.8.2
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.2';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var isArrayLike = function(collection) {
    var length = collection && collection.length;
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given value (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, target, fromIndex) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    return _.indexOf(obj, target, typeof fromIndex == 'number' && fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = input && input.length; i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (array == null) return [];
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = array.length; i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    if (array == null) return [];
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = array.length; i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, 'length').length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = list && list.length; i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = function(array, item, isSorted) {
    var i = 0, length = array && array.length;
    if (typeof isSorted == 'number') {
      i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
    } else if (isSorted && length) {
      i = _.sortedIndex(array, item);
      return array[i] === item ? i : -1;
    }
    if (item !== item) {
      return _.findIndex(slice.call(array, i), _.isNaN);
    }
    for (; i < length; i++) if (array[i] === item) return i;
    return -1;
  };

  _.lastIndexOf = function(array, item, from) {
    var idx = array ? array.length : 0;
    if (typeof from == 'number') {
      idx = from < 0 ? idx + from + 1 : Math.min(idx, from + 1);
    }
    if (item !== item) {
      return _.findLastIndex(slice.call(array, 0, idx), _.isNaN);
    }
    while (--idx >= 0) if (array[idx] === item) return idx;
    return -1;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = array != null && array.length;
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createIndexFinder(1);

  _.findLastIndex = createIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = array.length;
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (arguments.length <= 1) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of 
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
  
  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define === 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}.call(this));
define('jquery',[], function () {
  return jQuery;
});
//     Backbone.js 1.2.3

//     (c) 2010-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self == self && self) ||
            (typeof global == 'object' && global.global == global && global);

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (typeof define === 'function' && define.amd) {
    define('backbone',['underscore', 'jquery', 'exports'], function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    });

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch(e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.2.3';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Proxy Backbone class methods to Underscore functions, wrapping the model's
  // `attributes` object or collection's `models` array behind the scenes.
  //
  // collection.filter(function(model) { return model.get('age') > 10 });
  // collection.each(this.addView);
  //
  // `Function#apply` can be slow so we use the method's arg count, if we know it.
  var addMethod = function(length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return _[method](this[attribute]);
      };
      case 2: return function(value) {
        return _[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return _[method](this[attribute], cb(iteratee, this), context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return _[method].apply(_, args);
      };
    }
  };
  var addUnderscoreMethods = function(Class, methods, attribute) {
    _.each(methods, function(length, method) {
      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
    });
  };

  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
  var cb = function(iteratee, instance) {
    if (_.isFunction(iteratee)) return iteratee;
    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
    return iteratee;
  };
  var modelMatcher = function(attrs) {
    var matcher = _.matches(attrs);
    return function(model) {
      return matcher(model.attributes);
    };
  };

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // Guard the `listening` argument from the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
        context: context,
        ctx: obj,
        listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo =  function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({ callback: callback, context: context, ctx: context || ctx, listening: listening });
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off =  function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
        context: context,
        listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening =  function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }
    if (_.isEmpty(listeningTo)) this._listeningTo = void 0;

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = _.keys(listeners);
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    if (_.size(events)) return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once =  function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
    return this.on(events, void 0, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce =  function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger =  function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, cb, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Update the `id`.
      this.id = this.get(this.idAttribute);

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
      }
      return _.size(changed) ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.defaults({validate: true}, options));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model, mapped to the
  // number of arguments they take.
  var modelMethods = { keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
      omit: 0, chain: 1, isEmpty: 1 };

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  addUnderscoreMethods(Model, modelMethods, 'attributes');

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Splices `insert` into `array` at index `at`.
  var splice = function(array, insert, at) {
    at = Math.min(Math.max(at, 0), array.length);
    var tail = Array(array.length - at);
    var length = insert.length;
    for (var i = 0; i < tail.length; i++) tail[i] = array[i + at];
    for (i = 0; i < length; i++) array[i + at] = insert[i];
    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
  };

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set. `models` may be Backbone
    // Models or raw JavaScript objects to be converted to Models, or any
    // combination of the two.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      var removed = this._removeModels(models, options);
      if (!options.silent && removed) this.trigger('update', this, options);
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      if (models == null) return;

      options = _.defaults({}, options, setOptions);
      if (options.parse && !this._isModel(models)) models = this.parse(models, options);

      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();

      var at = options.at;
      if (at != null) at = +at;
      if (at < 0) at += this.length + 1;

      var set = [];
      var toAdd = [];
      var toRemove = [];
      var modelMap = {};

      var add = options.add;
      var merge = options.merge;
      var remove = options.remove;

      var sort = false;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      var model;
      for (var i = 0; i < models.length; i++) {
        model = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        var existing = this.get(model);
        if (existing) {
          if (merge && model !== existing) {
            var attrs = this._isModel(model) ? model.attributes : model;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
          }
          if (!modelMap[existing.cid]) {
            modelMap[existing.cid] = true;
            set.push(existing);
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(model, options);
          if (model) {
            toAdd.push(model);
            this._addReference(model, options);
            modelMap[model.cid] = true;
            set.push(model);
          }
        }
      }

      // Remove stale models.
      if (remove) {
        for (i = 0; i < this.length; i++) {
          model = this.models[i];
          if (!modelMap[model.cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      var orderChanged = false;
      var replace = !sortable && add && remove;
      if (set.length && replace) {
        orderChanged = this.length != set.length || _.some(this.models, function(model, index) {
          return model !== set[index];
        });
        this.models.length = 0;
        splice(this.models, set, 0);
        this.length = this.models.length;
      } else if (toAdd.length) {
        if (sortable) sort = true;
        splice(this.models, toAdd, at == null ? this.length : at);
        this.length = this.models.length;
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        for (i = 0; i < toAdd.length; i++) {
          if (at != null) options.index = at + i;
          model = toAdd[i];
          model.trigger('add', model, this, options);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length) this.trigger('update', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      var id = this.modelId(this._isModel(obj) ? obj.attributes : obj);
      return this._byId[obj] || this._byId[id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      return this[first ? 'find' : 'filter'](attrs);
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      var comparator = this.comparator;
      if (!comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      var length = comparator.length;
      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);

      // Run sort based on type of `comparator`.
      if (length === 1 || _.isString(comparator)) {
        this.models = this.sortBy(comparator);
      } else {
        this.models.sort(comparator);
      }
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp, callbackOpts) {
        if (wait) collection.add(model, callbackOpts);
        if (success) success.call(callbackOpts.context, model, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function (attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed.length ? removed : false;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function (model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (event === 'change') {
        var prevId = this.modelId(model.previousAttributes());
        var id = this.modelId(model.attributes);
        if (prevId !== id) {
          if (prevId != null) delete this._byId[prevId];
          if (id != null) this._byId[id] = model;
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = { forEach: 3, each: 3, map: 3, collect: 3, reduce: 4,
      foldl: 4, inject: 4, reduceRight: 4, foldr: 4, find: 3, detect: 3, filter: 3,
      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
      sortBy: 3, indexBy: 3};

  // Mix in each Underscore method as a proxy to `Collection#models`.
  addUnderscoreMethods(Collection, collectionMethods, 'models');

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], _.bind(method, this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    this.checkUrl = _.bind(this.checkUrl, this);

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var root = path.slice(0, this.root.length - 1) + '/';
      return root === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var root = this.root.slice(0, -1) || '/';
          this.location.replace(root + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function (eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function (eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.some(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var root = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        root = root.slice(0, -1) || '/';
      }
      var url = root + fragment;

      // Strip the hash and decode for matching.
      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getHash(this.iframe.contentWindow))) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent` constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));
// 1R global
ORW.responsiveSizes = {
    'medium' : 768,
    'large' : 1024,
    'xlarge' : 1200,
    'xxlarge' : 1440
}
ORW.utilities = {
    'isMobile' : function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    },
    'isTouchEnabled' : function() {
        return 'ontouchstart' in document.documentElement;
    },
    'getUrlParam' : function(url, sParam, value) {
        var sPageURL = url != undefined ? url : decodeURIComponent(window.location.search.substring(1));
        if (sPageURL.indexOf("?") >= 0) { sPageURL = sPageURL.replace("?", "&"); }
        var sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                if (value && sParameterName[1] !== undefined) {
                    var st1 = sParameterName[0] + '=' + sParameterName[1];
                    var st2 = sParameterName[0] + '=' + value;
                    return url.replace(st1, st2);
                } else {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            }
        }
    },
    'updateUrlParam' : function(url, sParam, value) {
        url = url ? url : window.location.href;
        var newurl = url;
        var currentParams = window.location.search;
        var currentHandle = ORW.utilities.getUrlParam(url,sParam);
        if (currentHandle) {
            // Replace
            newurl = ORW.utilities.getUrlParam(url,sParam,value);
        } else {
            // Create new depends on current params and url structure
            if (currentParams) {
                newurl += '&' + sParam + '=' + value;
            }
        }
        return newurl;
    },
    'setCookie' : function(name,value,days,domain) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        } else {
            var expires = "";
        }
        if (domain) {
            document.cookie = name+"="+value+expires+"; path=/; domain=" + domain;
        } else {
            document.cookie = name+"="+value+expires+"; path=/";
        }
    },
    'getCookie' : function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },
    'deleteCookie' : function(name) {
        ORW.setCookie(name,"",-1);
    },
    'searchCookie' : function(term) {
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            var s = c.split('=');
            if (s.length > 0 && s[0].indexOf(term) > -1) return s[0];
        }
        return null;
    }
}

// Config for requireJs
require.config({

    waitSeconds: 0,
    baseUrl: '.',
    paths: {
        // Core
        "underscore": "underscore",
        "backbone": "backbone",
        "jquery": "jquery.noconflict",

        // Libraries
        "jquery.easing": "jquery.easing",
        "jquery.transit": "jquery.transit",
        "jquery.actual": "jquery.actual",
        "jquery.hoverintent": "jquery.hoverintent",
        "jquery.scrollLock": "jquery.scrollLock",
        "jquery.scrolltofixed": "jquery.scrolltofixed",
        "jquery.doubletap": "jquery.doubletap",
        "jquery.panzoom": "jquery.panzoom",
        "jquery.fullpage": "jquery.fullpage",
        "jquery.fullpage.extensions": "jquery.fullpage.extensions.min",
        "jquery.waypoints": "jquery.waypoints",
        "jquery.viewport": "jquery.viewport",
        "jquery.panelsnap": "jquery.panelsnap",
        "slick": "slick",
        "scrolloverflow": "scrolloverflow",
        "vimeo": "player",

        // Main
        "router": "app-router",

        // Modules
        "module-oneModal": "app-module-oneModal",
        "module-oneCookie": "app-module-oneCookie",
        "module-oneSwatches": "app-module-oneSwatches",
        "module-oneZoom": "app-module-oneZoom",
        "module-oneSocial": "app-module-oneSocial",
        "module-oneExpand": "app-module-oneExpand",
        "module-oneTab": "app-module-oneTab",
        "module-oneSizeChart": "app-module-oneSizeChart",
        "module-oneSubscribe": "app-module-oneSubscribe",
        "module-oneContact": "app-module-oneContact",
        "module-oneVideo": "app-module-oneVideo",
        "module-oneCustomScroll": "app-module-oneCustomScroll",
        "module-oneDrawer": "app-module-oneDrawer",
        "module-oneMobileMenu": "app-module-oneMobileMenu",
        "module-oneGoogleForm": "app-module-oneGoogleForm",

        // Pages
        "page-collection": "app-page-collection",
        "page-styleGuide": "app-page-styleGuide",
        "page-product": "app-page-product",
        "page-cms": "app-page-cms",
        "page-lookbook": "app-page-lookbook",
        "page-home": "app-page-home",
        "page-login": "app-page-login",
        "page-account": "app-page-account",
        "page-article": "app-page-article",
        "page-about": "app-page-about",
        "page-stores": "app-page-stores",
        "page-cart": "app-page-cart",
        "page-iwish": "app-page-iwish",
        "page-appointment": "app-page-appointment",

        // Views
        "view-header": "app-view-header",
        "view-collection": "app-view-collection",
        "view-collectionNav": "app-view-collectionNav",
        "view-lookbook": "app-view-lookbook",
        "view-product": "app-view-product",
        "view-cms": "app-view-cms",
        "view-styleGuide": "app-view-styleGuide",
        "view-home": "app-view-home",
        "view-login": "app-view-login",
        "view-account": "app-view-account",
        "view-article": "app-view-article",
        "view-about": "app-view-about",
        "view-stores": "app-view-stores",
        "view-cart": "app-view-cart",
        "view-iwish": "app-view-iwish",
        "view-appointment": "app-view-appointment"

        // Templates
    },

    shim: {
        'underscore': { exports: "_" },
        'backbone': { deps: ["jquery", "underscore"], exports: "Backbone" },
        'jquery.easing': ["jquery"],
        'jquery.transit': { deps: ["jquery", "jquery.easing"] },
        'jquery.actual': ["jquery"],
        "jquery.hoverintent": ["jquery"],
        "jquery.scrollLock": ["jquery"],
        "jquery.scrolltofixed": ["jquery"],
        "jquery.doubletap": ["jquery"],
        "jquery.panzoom": ["jquery"],
        "jquery.fullpage": ["jquery","scrolloverflow"],
        "jquery.fullpage.extensions": ["jquery","scrolloverflow","jquery.fullpage"],
        "jquery.waypoints": ["jquery"],
        "jquery.viewport": ["jquery"],
        "jquery.panelsnap": ["jquery"],
        "scrolloverflow": ["jquery"],
        "slick": ["jquery"]
    },

    config: {
        text: {
            useXhr: function (url, protocol, hostname, port) {
                //Override function for determining if XHR should be used.
                //url: the URL being requested
                //protocol: protocol of page text.js is running on
                //hostname: hostname of page text.js is running on
                //port: port of page text.js is running on
                //Use protocol, hostname, and port to compare against the url
                //being requested.
                //Return true or false. true means "use xhr", false means
                //"fetch the .js version of this resource".
                return true;
            }
        }
    }

});

require([
    'underscore',
    'backbone'
], function () {
    console.log('Main JS loaded!');

    require(["router"]);

});

define("app-min", function(){});

define('module-oneDrawer',[
	"jquery",

	], function ($) {

	"use strict";

	/*
		OneDrawer 1.0.0 Usage
		Yang @onerockwell

        var drawerCtl = OneDrawer.init({
            el: self.$body,                 // Make sure this scope covers all your trigger element and the Drawer, usually we use body
            drawerElem: '#drawer',          // Your drawer class or id
            triggerEvent: 'click',          // Trigger event
            triggerElem: '.drawer-toggle',  // Your drawer trigger id
            openCallback: function(){ alert('opened!'); }        // You can add drawer open
            closeCallback: function(){ alert('opened!'); }        // You can add drawer close callback function here
            events: {                       // Accept events key pairs
                'click form button' : function(e){
                    e.preventDefault();
                    var $form = $(e.currentTarget).parent('form');
                    if ($form.find('input').val()) {
                        // Note: 'this' represent the OneDrawer object not the current view, coloseDrawer() is an native member function of OneDrawer
                        this.closeDrawer();
                        $form.submit();
                    }
                }
            }
        });
  	*/

  	var OneDrawerView = Backbone.View.extend({

		initialize: function (settings) {
            var self = this;

            self.drawerElem = settings.drawerElem;
            self.triggerEvent = settings.triggerEvent;
            self.triggerElem = settings.triggerElem;
            self.openCallback = settings.openCallback ? settings.openCallback : function(){ console.log('open call back') };
            self.closeCallback = settings.closeCallback ? settings.closeCallback : false;
            self.eventsAdditional = settings.events ? settings.events : {};

            self.$body = self.$el;
            self.$drawer = $(self.drawerElem);
            self.events = {};

            // Global events
            $(document).on(self.triggerEvent + ' keyup', function (e) {
                console.log('click on window');
                if ( e.type == self.triggerEvent || (e.type == 'keyup' && e.keyCode == 27) ) {
                    self.closeDrawer();
                }

                // If the body has the class template-collection, control back to top appearance based on number of results
                if (self.$body.hasClass('template-collection')) {
                  let bttThreshold = window.innerWidth > 1100 ? 8 : 5;
                  setTimeout(() => {
                    const ssResults = document.querySelectorAll('.ss__result--item');
                    if (ssResults.length <= bttThreshold) {
                        document.querySelector('.back-to-top').classList.add('inactive');
                    } else {
                        document.querySelector('.back-to-top').classList.remove('inactive');
                    }
                  }, 750);
                }

                // if the target has the class iWishAddColl, add the product to iWish
                // if ($(e.target).hasClass('icon-love')) {
                //   e.preventDefault();
                //   //get the product id from data-product, then use the shopify api to get its availability
                //   var productID = $(e.target).parent().data('product');
                //   var productURL = '/products/' + productID + '.js';
                //   $.getJSON(productURL, function(product) {
                //     if (product.available) {
                //       console.log('yes');
                //     } else {
                //       console.log('no');
                //     }
                //   });
                // }
            });

            // Trigger event
            var eventKey = self.triggerEvent + ' ' + self.triggerElem;
            console.log('Add this event: ', eventKey);
			self.events[eventKey] = function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.openCallback();
                self.drawerCtl();
            };

            // Drawer event
            var eventKey = self.triggerEvent + ' ' + self.drawerElem;
			self.events[eventKey] = function(e) {
                e.stopPropagation();
            };
            var eventKey = self.triggerEvent + ' ' + self.drawerElem + ' .drawer-close';
            self.events[eventKey] = function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.closeDrawer();
            };

            _.extend(self.events, self.eventsAdditional);
            self.delegateEvents();
            // console.log(self.events);
		},

		events: {
            // Using dynamic event trigger to make the module configurable
		},
        drawerCtl: function(forceClose){
            var self = this;
            // self.$body.toggleClass('minicart-open');
            if (forceClose) {
                self.$body.removeClass('show-overlay drawer-opt minicart-open');
                self.$drawer.removeClass('opened');
            } else {
                self.$body.trigger('drawer-opt');
                self.$drawer.toggleClass('opened');
            }
        },

        openDrawer: function() {
            var self = this;
            self.$body.trigger('drawer-opt');
            self.$drawer.addClass('opened');
        },

        closeDrawer: function() {
            var self = this;
            self.$body.trigger('drawer-closed');
            self.$body.removeClass('menu-opt');
            if(self.closeCallback){
                self.closeCallback();
            }
            self.drawerCtl(true);
        },

		destroy: function() {
            var self = this;
            self.undelegateEvents();
        }

	});

	var OneDrawer = {
		init: function (settings) {
			return new OneDrawerView(settings);
		}
	}

	return OneDrawer;

});
/*!
 * jQuery onMutate plugin v1.4
 * http://jquery.com/
 *
 * Copyright 2016 CROmetrics
 * Released under the MIT license
 * https://github.com/eclecto/jQuery-onCreate/blob/master/LICENSE
 *
 * Date: 2016-08-23T13:12Z
 */

 !function(t){"use strict";"function"==typeof define&&define.amd?define('jquery.onmutate',["jquery"],t):"undefined"!=typeof exports?module.exports=t:t(jQuery)}(function(t,e){function s(t){var i;this.observe=function(a,n){e?(i=i||new e(t),i.observe(a,n)):i=setInterval(t,50)},this.disconnect=function(){i&&(e?i.disconnect():clearInterval(i))}}function c(e,a,n){this.callback=e,this.conditions=a,this.multi=n||!1,this.cbid=i++,this.processed=t([])}function l(e){var i={};return e.attributes&&t.each(e.attributes,function(t,e){i[e.name]=e.value}),i}function f(e,i){var a=[];return t.each(e,function(t,e){("undefined"==typeof i[t]||e!==i[t])&&a.push({attributeName:t})}),t.each(i,function(t){"undefined"==typeof e[t]&&a.push({attributeName:t})}),a}function o(t,e,i){var a=t.attributeName,n=e.attr(a),r=i.conditions||!1,s=r?r[0]:!1,c=r&&r[1]?r[1]:!1;return!s||s.indexOf(a)>-1?c?n.search(c)>=0:!0:!1}t||(t=t.fn.jquery?t:jQuery),e||(e=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver||!1);var i=0,a="create",n="modify",r="text",u={attach:function(i){var u=i.type,h=i.callback,d=i.multi||!1,p=i.conditions;this.data("onMutate")||this.data("onMutate",{create:{callbacks:[],ignore:!1},modify:{callbacks:[],ignore:!1},text:{callbacks:[],ignore:!1}});var b=this.data("onMutate")[u],y=b.callbacks,v=new c(h,p,d);y.unshift(v),e||u!==n||(b.attributeMap=l(this[0])),u===r&&(b.text=this.text());var k,m,g=this,x=b.mutcallback=b.mutcallback||function(i){if(y=b.callbacks,!b.ignore){b.ignore=!0;var s=u===a?t(p,g):g;if(s.length>0){var c,h;for(u===n&&(c=l(g[0])),u===r&&(h=g.text()),k=y.length-1;k>=0;k--){var d=y[k].processed,v=s.not(d);if(u===n){m=!1,e||(i=f(c,b.attributeMap));for(var x=0;x<i.length;x++)m=m||o(i[x],g,y[k])}if(u===r){m=!1;var w=y[k].conditions;h!==b.text&&(m=w?h.search(w)>-1:!0)}v.length>0&&(u===a||m)&&(u===a&&(d=d.add(v)),y[k].processed=d,y[k].callback.call(g,v),y[k].multi||y.splice(k,1))}u===n&&(b.attributeMap=l(g[0])),u===r&&(b.text=g.text())}if(b.ignore&&setTimeout(function(){b.ignore=!1},1),0===y.length){if(!M)return!0;M.disconnect()}}};if(u===a&&x())return this;var w,M=b.observer=b.observer||new s(x);switch(u){case a:w={childList:!0,subtree:!0};break;case n:w={attributes:!0},p&&(w.attributeFilter=p[0].split(" "));break;case r:w={childList:!0,characterData:!0,subtree:!0}}return M.observe(g[0],w),this},detach:function(t){if(!this.data("onMutate"))return this;var e=t.type,i=this.data("onMutate")[e],a=i.callbacks,n=t.callback;if(n)for(var r=a.length-1;r>=0;r--)a[r].callback.prototype.cbid===n.prototype.cbid&&a.splice(r,r+1);else i.callbacks=[];return a.length||i.observer.disconnect(),this}};t.fn.extend({onCreate:function(){var t=Array.prototype.slice.call(arguments);return"string"!=typeof t[0]?this:"detach"===t[0]?u.detach.call(this,{type:a,callback:t[1]}):"string"==typeof t[0]&&"function"==typeof t[1]?u.attach.call(this,{type:a,conditions:t[0],callback:t[1],multi:t[2]}):this},onModify:function(){var e,t=Array.prototype.slice.call(arguments);if(e=u[t[0]]?t.shift():"attach","function"==typeof t[0])return u[e].call(this,{type:n,callback:t[0],multi:t[1]});if("string"==typeof t[0]){if("function"==typeof t[1])return u[e].call(this,{type:n,conditions:[t[0]],callback:t[1],multi:t[2]});if("string"==typeof t[1]||t[1]instanceof RegExp)return u[e].call(this,{type:n,conditions:[t[0],t[1]],callback:t[2],multi:t[3]})}else{if("attach"===e)return this;u[e].call(this,{type:n})}},onText:function(){if(0===this.length)return this;var e,t=Array.prototype.slice.call(arguments);return e=u[t[0]]?t.shift():"attach","function"==typeof t[0]?u[e].call(this,{type:r,callback:t[0],multi:t[1]}):"string"==typeof t[0]||t[0]instanceof RegExp&&"function"==typeof t[1]?u[e].call(this,{type:r,conditions:t[0],callback:t[1],multi:t[2]}):"attach"===e?this:void u[e].call(this,{type:r})}}),t.onCreate=function(e,i,a){t(document).onCreate(e,i,a)}});
 
define('module-oneCookie',[
  "jquery",
  "underscore",
  "module-oneDrawer",
  "jquery.onmutate",
], function ($, OneDrawer) {

	"use strict";

	/*
		OneCookie 1.1.0 Usage
    Patrick @onerockwell
    Ezra @onerockwell

    var cookieAgreement = $('.cookie-agreement-modal');
    OneCookie.init({
      cookie: 'acceptcookieterm',
      el: cookieAgreement,
      delay: cookieAgreement.data('delay'),
      days: cookieAgreement.data('days'),
      closeCallback: function () {
        // fires after modal close
      },
      openCallback: function () {
        // fires after modal open
      },
      cookieIsSetCallback: function () {
        // fires if cookie is already set (aka if modal is already hidden)
      }
    });

  	*/

  /**
   * @class DeferredJQuery
   *
   * make sure we have all the normal methods of a jquery object,
   * but wait until $(this.selector) actually exists until
   * calling any method on it
   *
   * dependencies: jquery, jquery.onmutate, underscore
   **/
  var DeferredJQuery = function DeferredJQuery (selector) {
    this._deferred = $.Deferred();

    $.onCreate(selector, (function ($el) {
      this._deferred.resolve($el);
    }).bind(this));
  };

  _(Object.keys($.fn)).each(function (key) {
    DeferredJQuery.prototype[key] = function () {
      const args = Array.from(arguments);

      this._deferred.done(function ($el) {
        $.fn[key].apply($el, args);
      });
    };
  });

  var OneCookieView = Backbone.View.extend({

    initialize: function (settings) {
      console.log('init cookie banner');

      this.$help = new DeferredJQuery('#launcher');

      this.settings = $.extend({
        closeCallback: function () {},
        cookieIsSetCallback: function () {},
        cookieName: 'acceptcookieterm',
        days: this.$el.data('days') || 0,
        delay: this.$el.data('delay') || 0,
        openCallback: function () {},
      }, settings);

      this.initModal();
    },

    events: {
      'click .accept': 'close'
    },

    _adjustHelpPosition: function () {
      if ('_adjustmentTimeout' in this) clearTimeout(this._adjustmentTimeout);

      var visibleHeight = this._getVisibleHeight();
      this.$help.css('margin-bottom', visibleHeight + 10);

      this._adjustmentTimeout = setTimeout((function (visibleHeight) {
        if (this._getVisibleHeight() !== visibleHeight) this._adjustHelpPosition();
      }).bind(this), 1000 / 60, visibleHeight);
    },

    _getVisibleHeight: function () {
      return Math.max(0, window.innerHeight - this.el.getBoundingClientRect().top);
    },

    initModal: function () {
      if (!ORW.utilities.getCookie(this.settings.cookieName)) {
        setTimeout(this.open.bind(this), this.settings.delay);
      } else {
        this.settings.cookieIsSetCallback(this.$el);
      }
    },

    open: function () {
      this.$el.addClass('opened');
      setTimeout(this._adjustHelpPosition.bind(this), 1000 / 60);

      this.$help.onModify('style', this._adjustHelpPosition.bind(this), true);
      $(window).on('resize.one-cookie', this._adjustHelpPosition.bind(this));

      this.settings.openCallback(this.$el);
    },

    close: function (e) {
      e.preventDefault();

      ORW.utilities.setCookie(this.settings.cookieName, true, this.settings.days);

      this.$el.removeClass('opened');
      setTimeout(this._adjustHelpPosition.bind(this), 1000 / 60);

      this.$help.onModify('detach');
      $(window).off('resize.one-cookie');

      this.settings.closeCallback(this.$el);
    },

    destroy: function () {
      this.$el.removeClass('opened');
      this.undelegateEvents();

      this.$help.onModify('detach');
      $(window).off('resize.one-cookie');
    },

  });

	var OneCookie = {
		init: function (settings) {
			return new OneCookieView(settings);
		}
	}

	return OneCookie;

});

define('module-oneContact',[
	"jquery",

	], function ($) {

	"use strict";

	/*
		OneContact 1.0.0 Usage
		Yang @onerockwell

        OneContact.init({
            el: $('.contact-form-container'),
            submitType: 'json' || 'default',
            errorMsg: 'Oops, something wrong happened, please try again later',
            successMsg: 'Thank you and welcome to Safiyaa. You will receive an email to confirm your subscription shortly.',
            requiredMsg: 'Error: required field',
            errorEmail: 'Error: please ensure formatting is correct',
            successCallback: function(d){},
            errorCallback: function(err){}
        });

  	*/

  	var OneContactView = Backbone.View.extend({

		initialize: function (settings) {
			var self = this;
            self.$form = self.$el.find('form');

            self.submitType = settings.submitType || 'default';
            self.errorMsg = settings.errorMsg || 'Oops, something wrong happened, please try again later';
            self.successMsg = settings.successMsg || 'Thank you for your interest! We will be in touch soon.';
            self.errorRequired = settings.requiredMsg || 'Error: required field';
            self.errorEmail = settings.errorEmail || 'Error: please ensure formatting is correct';
            self.successCallback = settings.successCallback ? settings.successCallback : function(d){ alert(d) };
            self.errorCallback = settings.errorCallback ? settings.errorCallback : function(err){ alert(err) };
		},

		events: {
            'submit form' : function(e){
                e.preventDefault();
                var self = this;
                if (self.validation(e)) {
                    if (self.submitType == 'json') {
                        self.formSubmitJSON(e);
                    } else {
                        self.formSubmit(e);
                    }
                }
            },
            'blur input.required' : 'validation'
		},

        validation: function(e) {
            var self = this;
            var passValidation = true;
			var $curr = $(e.currentTarget);
            var $requiredFields = self.$form.find('input.required');
            var errorHandling = function($container,msg){
                if ($container.find('.error-msg').length) {
                    $container.find('.error-msg').text(msg);
                } else {
                    $container.append('<span class="error-msg">' + msg + '</span>');
                }
            }

			if ($curr.hasClass('required')) {
				$requiredFields = $curr;
			}

            _.each($requiredFields,function(input){
                var $input = $(input);
                var $parent = $input.parent();
                var value = $input.val();
                var isEmailField = $input.attr('type') == 'email' ? true : false;
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

                if (value == '') {
                    passValidation = false;
                    $parent.addClass('error');
                    errorHandling($parent,self.errorRequired);
                } else if (isEmailField) {
                    var resutl = regex.test(value);
                    if (!resutl) {
                        passValidation = false;
                        errorHandling($parent,self.errorEmail);
                    } else {
                        $parent.removeClass('error');
                    }
                } else {
                    $parent.removeClass('error');
                }

            });

            return passValidation;
        },

        formSubmit: function(e) {
            var self = this;
            var $form = self.$form;
            $.ajax({
                async: true,
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                cache       : false,
                error       : function(err) {
                    self.errorCallback(err);
                },
                success     : function(data) {
                    e.preventDefault();
                    self.successCallback(data);
                }
            });
        },

        formSubmitJSON: function(e) {
            var self = this;
            var $form = self.$form;
            var data = {
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                cache       : false,
                dataType    : 'json',
                contentType: "application/json; charset=utf-8",
                error       : function(err) {
                    self.errorCallback(err);
                },
                success     : function(data) {
                    self.successCallback(data);
                }
            };
            console.log('FORM DATA: ', JSON.stringify(data, null, 2));
            $.ajax(data);
        },

		destroy: function() {
            var self = this;
            self.undelegateEvents();
        }

	});

	var OneContact = {
		init: function (settings) {
			return new OneContactView(settings);
		}
	}

	return OneContact;

});
define('module-oneSubscribe',[
	"jquery",
	'module-oneContact'
], function ($, OneContact) {

	"use strict";

	/*
		OneSubscribe 1.0.0 Usage
		Yang @onerockwell

        OneSubscribe.init({
            el: $('.subscribe-modal'),
            delay: 2000,
            errorMsg: 'Oops, something wrong happened, please try again later',
            successMsg: 'Thank you and welcome to Safiyaa. You will receive an email to confirm your subscription shortly.',
            requiredMsg: 'Error: required field',
            errorEmail: 'Error: please ensure formatting is correct',
            cookieEnabled: false,
            cookieDays: 1
        });

  	*/

  	var OneSubscribeView = Backbone.View.extend({

		initialize: function (settings) {
			var self = this;
			if (!self.$el.length) {
				return false;
			}

			self.$modal = self.$el;
			self.$body = $('body');
            self.errorMsg = settings.errorMsg || self.$modal.data('errormsg');
            self.successMsg = settings.successMsg || self.$modal.data('successmsg');
            self.errorRequired = settings.requiredMsg || self.$modal.data('requiredmsg');
            self.errorEmail = settings.errorEmail || self.$modal.data('erroremail');
            self.delay = settings.delay || self.$modal.data('delay');
            self.days = settings.cookieDays || self.$modal.data('cookiedays');
			self.enabled = settings.errorMsg || self.$modal.data('enabled');
            self.cookieEnabled = settings.cookieEnabled || self.$modal.data('cookieenabled');

			if (!self.enabled) {
				return false;
			}

            self.$form = self.$modal.find('form');

            if (!ORW.utilities.getCookie('hidesubscriptionmodal') || !self.cookieEnabled) {
                setTimeout(function(){
                    self.open();
                }, self.delay);
            }

			OneContact.init({
	            el: self.$modal,
	            submitType: 'json',
	            errorMsg: self.errorMsg,
	            successMsg: self.successMsg,
	            requiredMsg: self.errorRequired,
	            errorEmail: self.errorEmail,
	            successCallback: function(data) {
                    self.submitCallBack(true,data);
                },
	            errorCallback: function(err) {
                    self.submitCallBack(false,err);
                }
	        });

			console.log('Subscribe Modal Init');

		},

		events: {
            'click .close' : function(e){
                e.preventDefault();
                var self = this;
                self.close(true);
            },
			'click .global-message a' : function(e){
				e.preventDefault();
				var $curr = $(e.currentTarget);
				if ($curr.attr('href')) {
					window.open($curr.attr('href'));
				}
			},
			'click .global-message' : function(e){
				var self = this;
				self.$form.parent().removeClass('submitted error success');
			}
		},

        open: function() {
            var self = this;
			self.$modal.addClass('opened');
			self.$body.addClass('show-overlay');
        },

        close: function(setCookie) {
            var self = this;
			self.$modal.removeClass('opened');
			self.$body.removeClass('show-overlay');
            if (setCookie && self.cookieEnabled) {
                ORW.utilities.setCookie('hidesubscriptionmodal',true,self.days);
            }
        },

        submitCallBack: function(isSuccess,data){
            var self = this;

            var errorHandling = function( $form, msg, flag ){
				var $container = $form.parent();
				var $globalMsg = $container.find('.global-message');
				msg = '<span>' + msg + '</span>';

				if ($globalMsg.length) {
					$globalMsg.html(msg);
				} else {
					$container.append('<p class="global-message">' + msg + '</span>');
					$globalMsg = $container.find('.global-message');
				}

				$container.removeClass('submitted error success');

				if (flag == 'success') {
					// Clear up the form
					_.each($form.find('.group input'), function(input){
						var $input = $(input);
						if ($input.attr('type') != 'checkbox' && $input.attr('type') != 'radio') {
							$input.val('');
						} else if ($input.attr('type') == 'checkbox') {
							$input.removeAttr('checked');
						}
					});
					$container.addClass('submitted success');
				} else if (flag == 'error') {
					$container.addClass('submitted error');
				}
            };

            errorHandling(self.$form, '', '');

            if (isSuccess) {
                console.log(data);
                if (data.result != "success") {
					errorHandling(self.$form, data.msg, 'error');
                } else {
                    // Successed!
					errorHandling(self.$form, self.successMsg, 'success');
					var delay = self.delay > 3000 ? self.delay : 3000;
                    setTimeout(function(){
                        self.close(true);
                    }, delay);
                }
            } else {
				errorHandling(self.$form, self.errorMsg, 'error');
            }
        },

		destroy: function() {
            var self = this;
            self.undelegateEvents();
        }

	});

	var OneSubscribe = {
		init: function (settings) {
			return new OneSubscribeView(settings);
		}
	}

	return OneSubscribe;


});
define('module-oneMobileMenu',[
	"jquery",

	], function ($) {

	"use strict";

	/*
		OneMobileMenu 1.0.0 Usage
		yang @onerockwell



  	*/

  	var OneMobileMenuView = Backbone.View.extend({

		initialize: function (settings) {
			var self = this;
            self.$mobileNav = self.$el;
		},

		events: {
			'click [data-trigger]' : function(e){
				e.preventDefault();
				var self = this;
				var $trigger = $(e.currentTarget);
				var target = $trigger.data('trigger');
				var $target = self.$mobileNav.find('[data-target="' + target + '"]');
				var activeClass = 'active';

				if ( $target.length ) {
					$trigger.toggleClass(activeClass);
					$target.toggleClass(activeClass);

					// var $activeNavItems = $trigger.closest('[class*="level-"]').siblings().find('.nav-link.active');
					// if ($activeNavItems.length) $activeNavItems.removeClass(activeClass);
				}
			},
			'click .back-to' : function(e){
				e.preventDefault();
				var self = this;
				var $backToBtn = $(e.currentTarget);
				var $target = $backToBtn.parent();
				var trigger = $target.data('target');
				var $trigger = self.$mobileNav.find('[data-trigger="' + trigger + '"]');

				self.$mobileNav.removeClass('slide-menu-opened');
				$target.removeClass('active');
				$trigger.removeClass('active');
			}
		},

		destroy: function() {
            var self = this;
            self.undelegateEvents();
        }

	});

	var OneMobileMenu = {
		init: function (settings) {
			return new OneMobileMenuView(settings);
		}
	}

	return OneMobileMenu;

});
define('module-oneCustomScroll',[], function ($) {

	"use strict";

    /*

		CustomScroll 1.0.0 Usage
        ezra@onerockwell & patrick@onerockwell.com

        No dependencies.
        Adapted from https://stackoverflow.com/questions/27322881/how-can-i-create-a-simple-page-vertical-scroll-bar-without-using-jquery

        Initialization:
        CustomScroll.init({
            el: child // HTML object (required), not a jQuery object,
            margin: 40 // Number (optional), margin off of the containers bounds.
        });

        HTML:
        <div class="scrollable [scrollable-x|scrollable-y]">
            <div>
                // Scrollable content goes here
            </div>
        </div>

  	*/

  	var CustomScrollView = Backbone.View.extend({

		initialize: function (settings) {

            var self = this;
            var scrollDirection = 'vertical';

            if(self.el.className.indexOf('scrollable-x') > -1){
                scrollDirection = 'horizontal';
            }

            var offsetDimension = scrollDirection === 'vertical' ? 'offsetHeight' : 'offsetWidth',
                scrollDimension = scrollDirection === 'vertical' ? 'scrollHeight' : 'scrollWidth',
                scrollEdge = scrollDirection === 'vertical' ? 'scrollTop' : 'scrollLeft',
                page = scrollDirection === 'vertical' ? 'pageY' : 'pageX';

            var scrollContainer = self.el,
                scrollContentWrapper = self.el.children[0],
                contentPosition = 0,
                margin = settings.margin > -1 ? settings.margin : 20,
                scrollerBeingDragged = false,
                track,
                scroller,
                normalizedPosition,
                scrollerDimension,
                visibleRatio = scrollContainer[offsetDimension] / scrollContentWrapper[scrollDimension];

                if (window.innerWidth < 768) {
                  margin = 20;
                }

                // on resize, recalculate scroller dimension
                window.addEventListener('resize', function(evt) {
                  if (window.innerWidth < 768) {
                      margin = 20;
                  }
                });

                

            if(scrollDirection == 'vertical'){
                margin = 0;
            }

            // calculation of how tall scroller should be
            var calculateScrollerDimension = function calculateScrollerDimension() {
                var offset = 0;
                if(scrollDirection == 'horizontal'){
                    offset = margin * 2;
                }
                return (visibleRatio * scrollContainer[offsetDimension]) - (offset);
            };

            // move scroll bar to top offset
            var moveScroller = function moveScroller(evt) {
                var scrollPercentage = evt.target[scrollEdge] / scrollContentWrapper[scrollDimension]; // 5px arbitrary offset so scroll bar doesn't move too far beyond content wrapper bounding box
                var position = (scrollPercentage * scrollContainer[offsetDimension]) + margin;
                scroller.style[scrollDirection === 'vertical' ? 'top' : 'left'] = "".concat(position, "px");
            };

            var startDrag = function startDrag(evt) {
                normalizedPosition = evt[page];
                contentPosition = scrollContentWrapper[scrollEdge];
                scrollerBeingDragged = true;
            };

            var stopDrag = function stopDrag() {
                scrollerBeingDragged = false;
            };

            var scrollBarScroll = function scrollBarScroll(evt) {
                if (scrollerBeingDragged !== true) return;
                var mouseDifferential = evt[page] - normalizedPosition;
                var scrollEquivalent = mouseDifferential * (scrollContentWrapper[scrollDimension] / scrollContainer[offsetDimension]);
                scrollContentWrapper[scrollEdge] = contentPosition + scrollEquivalent;
            };

            // creates scroller element and appends to '.scrollable' div
            var createScroller = function createScroller() {
                // create scroller element
                scroller = document.createElement('div');
                scroller.className = 'scroller'; // determine how big scroller should be based on content
                track = document.createElement('div');
                track.className = 'track'; // determine how big scroller should be based on content
                scrollerDimension = calculateScrollerDimension();
                if (visibleRatio < 1) {
                    // if there is a need to have scroll bar based on content size
                    scroller.style[scrollDirection === 'vertical' ? 'height' : 'width'] = "".concat(scrollerDimension, "px"); // append scroller to scrollContainer div
                    if(scrollDirection == 'horizontal'){
                        scroller.style.left = "".concat(margin, "px");
                        track.style.left = "".concat(margin, "px");
                        track.style.right = "".concat(margin, "px");
                    }else{
                        scroller.style.top = "".concat(margin, "px");
                        track.style.top = "".concat(margin, "px");
                        track.style.bottom = "".concat(margin, "px");
                    }
                    scrollContainer.appendChild(track); // show scroll path div
                    scrollContainer.appendChild(scroller); // show scroll path div
                    
                    scrollContainer.className += ' showScroll'; // attach related draggable listeners
                    scroller.addEventListener('mousedown', startDrag);
                    window.addEventListener('mouseup', stopDrag);
                    window.addEventListener('mousemove', scrollBarScroll);
                }
            };
            createScroller();
            scrollContentWrapper.addEventListener('scroll', moveScroller);

            // Debounce function to delay execution
            function debounce(func, delay) {
              let timer;
              return function () {
                clearTimeout(timer);
                timer = setTimeout(func, delay);
              };
            }

            // Function to remove elements with classes "track" and "scroller"
            function removeElements() {
              var trackElements = document.querySelectorAll('.track');
              trackElements.forEach(function(element) {
                element.parentNode.removeChild(element);
              });

              var scrollerElements = document.querySelectorAll('.scroller');
              scrollerElements.forEach(function(element) {
                element.parentNode.removeChild(element);
              });

              window.removeEventListener('mouseup', stopDrag);
              window.removeEventListener('mousemove', scrollBarScroll);

              setTimeout(() => {
                createScroller();                
              }, 1000);
            }

            var dwidth = window.innerWidth;

            window.addEventListener('resize', function() {
              var wwidth = window.innerWidth;
              if (dwidth !== wwidth) {
                dwidth = window.innerWidth;
                removeElements();
              }
            });
            

		},

		events: {

        },

        isDesktop: function () {
            var self = this;
            var w = window.innerWidth;
            if (w > ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        },

        isMobile: function () {
            var self = this;
            var w = window.innerWidth;
            if (w <= ORW.responsiveSizes.medium) {
              return true;
            }
            return false;
        },

		destroy: function() {
            var self = this;
            self.undelegateEvents();
        }

	});

	var CustomScroll = {
		init: function (settings) {
			return new CustomScrollView(settings);
		}
	}

	return CustomScroll;

});


/*!
 * hoverIntent v1.8.1 // 2014.08.11 // jQuery v1.9.1+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007, 2014 Brian Cherne
 */

/* hoverIntent is similar to jQuery's built-in "hover" method except that
 * instead of firing the handlerIn function immediately, hoverIntent checks
 * to see if the user's mouse has slowed down (beneath the sensitivity
 * threshold) before firing the event. The handlerOut function is only
 * called after a matching handlerIn.
 *
 * // basic usage ... just like .hover()
 * .hoverIntent( handlerIn, handlerOut )
 * .hoverIntent( handlerInOut )
 *
 * // basic usage ... with event delegation!
 * .hoverIntent( handlerIn, handlerOut, selector )
 * .hoverIntent( handlerInOut, selector )
 *
 * // using a basic configuration object
 * .hoverIntent( config )
 *
 * @param  handlerIn   function OR configuration object
 * @param  handlerOut  function OR selector for delegation OR undefined
 * @param  selector    selector OR undefined
 * @author Brian Cherne <brian(at)cherne(dot)net>
 */

;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define('jquery.hoverintent',['jquery'], factory);
    } else if (jQuery && !jQuery.fn.hoverIntent) {
        factory(jQuery);
    }
})(function($) {
    'use strict';

    // default configuration values
    var _cfg = {
        interval: 100,
        sensitivity: 6,
        timeout: 0
    };

    // counter used to generate an ID for each instance
    var INSTANCE_COUNT = 0;

    // current X and Y position of mouse, updated during mousemove tracking (shared across instances)
    var cX, cY;

    // saves the current pointer position coordinates based on the given mousemove event
    var track = function(ev) {
        cX = ev.pageX;
        cY = ev.pageY;
    };

    // compares current and previous mouse positions
    var compare = function(ev,$el,s,cfg) {
        // compare mouse positions to see if pointer has slowed enough to trigger `over` function
        if ( Math.sqrt( (s.pX-cX)*(s.pX-cX) + (s.pY-cY)*(s.pY-cY) ) < cfg.sensitivity ) {
            $el.off(s.event,track);
            delete s.timeoutId;
            // set hoverIntent state as active for this element (permits `out` handler to trigger)
            s.isActive = true;
            // overwrite old mouseenter event coordinates with most recent pointer position
            ev.pageX = cX; ev.pageY = cY;
            // clear coordinate data from state object
            delete s.pX; delete s.pY;
            return cfg.over.apply($el[0],[ev]);
        } else {
            // set previous coordinates for next comparison
            s.pX = cX; s.pY = cY;
            // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
            s.timeoutId = setTimeout( function(){compare(ev, $el, s, cfg);} , cfg.interval );
        }
    };

    // triggers given `out` function at configured `timeout` after a mouseleave and clears state
    var delay = function(ev,$el,s,out) {
        delete $el.data('hoverIntent')[s.id];
        return out.apply($el[0],[ev]);
    };

    $.fn.hoverIntent = function(handlerIn,handlerOut,selector) {
        // instance ID, used as a key to store and retrieve state information on an element
        var instanceId = INSTANCE_COUNT++;

        // extend the default configuration and parse parameters
        var cfg = $.extend({}, _cfg);
        if ( $.isPlainObject(handlerIn) ) {
            cfg = $.extend(cfg, handlerIn);
            if ( !$.isFunction(cfg.out) ) {
                cfg.out = cfg.over;
            }
        } else if ( $.isFunction(handlerOut) ) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector } );
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut } );
        }

        // A private function for handling mouse 'hovering'
        var handleHover = function(e) {
            // cloned event to pass to handlers (copy required for event object to be passed in IE)
            var ev = $.extend({},e);

            // the current target of the mouse event, wrapped in a jQuery object
            var $el = $(this);

            // read hoverIntent data from element (or initialize if not present)
            var hoverIntentData = $el.data('hoverIntent');
            if (!hoverIntentData) { $el.data('hoverIntent', (hoverIntentData = {})); }

            // read per-instance state from element (or initialize if not present)
            var state = hoverIntentData[instanceId];
            if (!state) { hoverIntentData[instanceId] = state = { id: instanceId }; }

            // state properties:
            // id = instance ID, used to clean up data
            // timeoutId = timeout ID, reused for tracking mouse position and delaying "out" handler
            // isActive = plugin state, true after `over` is called just until `out` is called
            // pX, pY = previously-measured pointer coordinates, updated at each polling interval
            // event = string representing the namespaced event used for mouse tracking

            // clear any existing timeout
            if (state.timeoutId) { state.timeoutId = clearTimeout(state.timeoutId); }

            // namespaced event used to register and unregister mousemove tracking
            var mousemove = state.event = 'mousemove.hoverIntent.hoverIntent'+instanceId;

            // handle the event, based on its type
            if (e.type === 'mouseenter') {
                // do nothing if already active
                if (state.isActive) { return; }
                // set "previous" X and Y position based on initial entry point
                state.pX = ev.pageX; state.pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $el.off(mousemove,track).on(mousemove,track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                state.timeoutId = setTimeout( function(){compare(ev,$el,state,cfg);} , cfg.interval );
            } else { // "mouseleave"
                // do nothing if not already active
                if (!state.isActive) { return; }
                // unbind expensive mousemove event
                $el.off(mousemove,track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                state.timeoutId = setTimeout( function(){delay(ev,$el,state,cfg.out);} , cfg.timeout );
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({'mouseenter.hoverIntent':handleHover,'mouseleave.hoverIntent':handleHover}, cfg.selector);
    };
});
/*
 * ScrollToFixed
 * https://github.com/bigspotteddog/ScrollToFixed
 *
 * Copyright (c) 2011 Joseph Cava-Lynch
 * MIT license
 */
(function($) {
    $.isScrollToFixed = function(el) {
        return !!$(el).data('ScrollToFixed');
    };

    $.ScrollToFixed = function(el, options) {
        // To avoid scope issues, use 'base' instead of 'this' to reference this
        // class from internal events and functions.
        var base = this;

        // Access to jQuery and DOM versions of element.
        base.$el = $(el);
        base.el = el;

        // Add a reverse reference to the DOM object.
        base.$el.data('ScrollToFixed', base);

        // A flag so we know if the scroll has been reset.
        var isReset = false;

        // The element that was given to us to fix if scrolled above the top of
        // the page.
        var target = base.$el;

        var position;
        var originalPosition;
        var originalFloat;
        var originalOffsetTop;
        var originalZIndex;

        // The offset top of the element when resetScroll was called. This is
        // used to determine if we have scrolled past the top of the element.
        var offsetTop = 0;

        // The offset left of the element when resetScroll was called. This is
        // used to move the element left or right relative to the horizontal
        // scroll.
        var offsetLeft = 0;
        var originalOffsetLeft = -1;

        // This last offset used to move the element horizontally. This is used
        // to determine if we need to move the element because we would not want
        // to do that for no reason.
        var lastOffsetLeft = -1;

        // This is the element used to fill the void left by the target element
        // when it goes fixed; otherwise, everything below it moves up the page.
        var spacer = null;

        var spacerClass;

        var className;

        // Capture the original offsets for the target element. This needs to be
        // called whenever the page size changes or when the page is first
        // scrolled. For some reason, calling this before the page is first
        // scrolled causes the element to become fixed too late.
        function resetScroll() {
            // Set the element to it original positioning.
            target.trigger('preUnfixed.ScrollToFixed');
            setUnfixed();
            target.trigger('unfixed.ScrollToFixed');

            // Reset the last offset used to determine if the page has moved
            // horizontally.
            lastOffsetLeft = -1;

            // Capture the offset top of the target element.
            offsetTop = target.offset().top;

            // Capture the offset left of the target element.
            offsetLeft = target.offset().left;

            // If the offsets option is on, alter the left offset.
            if (base.options.offsets) {
                offsetLeft += (target.offset().left - target.position().left);
            }

            if (originalOffsetLeft == -1) {
                originalOffsetLeft = offsetLeft;
            }

            position = target.css('position');

            // Set that this has been called at least once.
            isReset = true;

            if (base.options.bottom != -1) {
                target.trigger('preFixed.ScrollToFixed');
                setFixed();
                target.trigger('fixed.ScrollToFixed');
            }
        }

        function getLimit() {
            var limit = base.options.limit;
            if (!limit) return 0;

            if (typeof(limit) === 'function') {
                return limit.apply(target);
            }
            return limit;
        }

        // Returns whether the target element is fixed or not.
        function isFixed() {
            return position === 'fixed';
        }

        // Returns whether the target element is absolute or not.
        function isAbsolute() {
            return position === 'absolute';
        }

        function isUnfixed() {
            return !(isFixed() || isAbsolute());
        }

        // Sets the target element to fixed. Also, sets the spacer to fill the
        // void left by the target element.
        function setFixed() {
            // Only fix the target element and the spacer if we need to.
            if (!isFixed()) {
                //get REAL dimensions (decimal fix)
                //Ref. http://stackoverflow.com/questions/3603065/how-to-make-jquery-to-not-round-value-returned-by-width
                var dimensions = target[0].getBoundingClientRect();

                // Set the spacer to fill the height and width of the target
                // element, then display it.
                spacer.css({
                    'display' : target.css('display'),
                    'width' : dimensions.width,
                    'height' : dimensions.height,
                    'float' : target.css('float')
                });

                // Set the target element to fixed and set its width so it does
                // not fill the rest of the page horizontally. Also, set its top
                // to the margin top specified in the options.

                cssOptions={
                    'z-index' : base.options.zIndex,
                    'position' : 'fixed',
                    'top' : base.options.bottom == -1?getMarginTop():'',
                    'bottom' : base.options.bottom == -1?'':base.options.bottom,
                    'margin-left' : '0px'
                }
                if (!base.options.dontSetWidth){ cssOptions['width']=target.css('width'); };

                target.css(cssOptions);

                target.addClass(base.options.baseClassName);

                if (base.options.className) {
                    target.addClass(base.options.className);
                }

                position = 'fixed';
            }
        }

        function setAbsolute() {

            var top = getLimit();
            var left = offsetLeft;

            if (base.options.removeOffsets) {
                left = '';
                top = top - offsetTop;
            }

            cssOptions={
              'position' : 'absolute',
              'top' : top,
              'left' : left,
              'margin-left' : '0px',
              'bottom' : ''
            }
            if (!base.options.dontSetWidth){ cssOptions['width']=target.css('width'); };

            target.css(cssOptions);

            position = 'absolute';
        }

        // Sets the target element back to unfixed. Also, hides the spacer.
        function setUnfixed() {
            // Only unfix the target element and the spacer if we need to.
            if (!isUnfixed()) {
                lastOffsetLeft = -1;

                // Hide the spacer now that the target element will fill the
                // space.
                spacer.css('display', 'none');

                // Remove the style attributes that were added to the target.
                // This will reverse the target back to the its original style.
                target.css({
                    'z-index' : originalZIndex,
                    'width' : '',
                    'position' : originalPosition,
                    'left' : '',
                    'top' : originalOffsetTop,
                    'margin-left' : ''
                });

                target.removeClass('scroll-to-fixed-fixed');

                if (base.options.className) {
                    target.removeClass(base.options.className);
                }

                position = null;
            }
        }

        // Moves the target element left or right relative to the horizontal
        // scroll position.
        function setLeft(x) {
            // Only if the scroll is not what it was last time we did this.
            if (x != lastOffsetLeft) {
                // Move the target element horizontally relative to its original
                // horizontal position.
                target.css('left', offsetLeft - x);

                // Hold the last horizontal position set.
                lastOffsetLeft = x;
            }
        }

        function getMarginTop() {
            var marginTop = base.options.marginTop;
            if (!marginTop) return 0;

            if (typeof(marginTop) === 'function') {
                return marginTop.apply(target);
            }
            return marginTop;
        }

        // Checks to see if we need to do something based on new scroll position
        // of the page.
        function checkScroll() {
            if (!$.isScrollToFixed(target) || target.is(':hidden')) return;
            var wasReset = isReset;
            var wasUnfixed = isUnfixed();

            // If resetScroll has not yet been called, call it. This only
            // happens once.
            if (!isReset) {
                resetScroll();
            } else if (isUnfixed()) {
                // if the offset has changed since the last scroll,
                // we need to get it again.

                // Capture the offset top of the target element.
                offsetTop = target.offset().top;

                // Capture the offset left of the target element.
                offsetLeft = target.offset().left;
            }

            // Grab the current horizontal scroll position.
            var x = $(window).scrollLeft();

            // Grab the current vertical scroll position.
            var y = $(window).scrollTop();

            // Get the limit, if there is one.
            var limit = getLimit();

            // If the vertical scroll position, plus the optional margin, would
            // put the target element at the specified limit, set the target
            // element to absolute.
            if (base.options.minWidth && $(window).width() < base.options.minWidth) {
                if (!isUnfixed() || !wasReset) {
                    postPosition();
                    target.trigger('preUnfixed.ScrollToFixed');
                    setUnfixed();
                    target.trigger('unfixed.ScrollToFixed');
                }
            } else if (base.options.maxWidth && $(window).width() > base.options.maxWidth) {
                if (!isUnfixed() || !wasReset) {
                    postPosition();
                    target.trigger('preUnfixed.ScrollToFixed');
                    setUnfixed();
                    target.trigger('unfixed.ScrollToFixed');
                }
            } else if (base.options.bottom == -1) {
                // If the vertical scroll position, plus the optional margin, would
                // put the target element at the specified limit, set the target
                // element to absolute.
                if (limit > 0 && y >= limit - getMarginTop()) {
                    if (!wasUnfixed && (!isAbsolute() || !wasReset)) {
                        postPosition();
                        target.trigger('preAbsolute.ScrollToFixed');
                        setAbsolute();
                        target.trigger('unfixed.ScrollToFixed');
                    }
                // If the vertical scroll position, plus the optional margin, would
                // put the target element above the top of the page, set the target
                // element to fixed.
                } else if (y >= offsetTop - getMarginTop()) {
                    if (!isFixed() || !wasReset) {
                        postPosition();
                        target.trigger('preFixed.ScrollToFixed');

                        // Set the target element to fixed.
                        setFixed();

                        // Reset the last offset left because we just went fixed.
                        lastOffsetLeft = -1;

                        target.trigger('fixed.ScrollToFixed');
                    }
                    // If the page has been scrolled horizontally as well, move the
                    // target element accordingly.
                    setLeft(x);
                } else {
                    // Set the target element to unfixed, placing it where it was
                    // before.
                    if (!isUnfixed() || !wasReset) {
                        postPosition();
                        target.trigger('preUnfixed.ScrollToFixed');
                        setUnfixed();
                        target.trigger('unfixed.ScrollToFixed');
                    }
                }
            } else {
                if (limit > 0) {
                    if (y + $(window).height() - target.outerHeight(true) >= limit - (getMarginTop() || -getBottom())) {
                        if (isFixed()) {
                            postPosition();
                            target.trigger('preUnfixed.ScrollToFixed');

                            if (originalPosition === 'absolute') {
                                setAbsolute();
                            } else {
                                setUnfixed();
                            }

                            target.trigger('unfixed.ScrollToFixed');
                        }
                    } else {
                        if (!isFixed()) {
                            postPosition();
                            target.trigger('preFixed.ScrollToFixed');
                            setFixed();
                        }
                        setLeft(x);
                        target.trigger('fixed.ScrollToFixed');
                    }
                } else {
                    setLeft(x);
                }
            }
        }

        function getBottom() {
            if (!base.options.bottom) return 0;
            return base.options.bottom;
        }

        function postPosition() {
            var position = target.css('position');

            if (position == 'absolute') {
                target.trigger('postAbsolute.ScrollToFixed');
            } else if (position == 'fixed') {
                target.trigger('postFixed.ScrollToFixed');
            } else {
                target.trigger('postUnfixed.ScrollToFixed');
            }
        }

        var windowResize = function(event) {
            // Check if the element is visible before updating it's position, which
            // improves behavior with responsive designs where this element is hidden.
            if(target.is(':visible')) {
                isReset = false;
                checkScroll();
            } else {
              // Ensure the spacer is hidden
              setUnfixed();
            }
        }

        var windowScroll = function(event) {
            (!!window.requestAnimationFrame) ? requestAnimationFrame(checkScroll) : checkScroll();
        }

        // From: http://kangax.github.com/cft/#IS_POSITION_FIXED_SUPPORTED
        var isPositionFixedSupported = function() {
            var container = document.body;

            if (document.createElement && container && container.appendChild && container.removeChild) {
                var el = document.createElement('div');

                if (!el.getBoundingClientRect) return null;

                el.innerHTML = 'x';
                el.style.cssText = 'position:fixed;top:100px;';
                container.appendChild(el);

                var originalHeight = container.style.height,
                originalScrollTop = container.scrollTop;

                container.style.height = '3000px';
                container.scrollTop = 500;

                var elementTop = el.getBoundingClientRect().top;
                container.style.height = originalHeight;

                var isSupported = (elementTop === 100);
                container.removeChild(el);
                container.scrollTop = originalScrollTop;

                return isSupported;
            }

            return null;
        }

        var preventDefault = function(e) {
            e = e || window.event;
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.returnValue = false;
        }

        // Initializes this plugin. Captures the options passed in, turns this
        // off for devices that do not support fixed position, adds the spacer,
        // and binds to the window scroll and resize events.
        base.init = function() {
            // Capture the options for this plugin.
            base.options = $.extend({}, $.ScrollToFixed.defaultOptions, options);

            originalZIndex = target.css('z-index')

            // Turn off this functionality for devices that do not support it.
            // if (!(base.options && base.options.dontCheckForPositionFixedSupport)) {
            //     var fixedSupported = isPositionFixedSupported();
            //     if (!fixedSupported) return;
            // }

            // Put the target element on top of everything that could be below
            // it. This reduces flicker when the target element is transitioning
            // to fixed.
            base.$el.css('z-index', base.options.zIndex);

            // Create a spacer element to fill the void left by the target
            // element when it goes fixed.
            spacer = $('<div />');

            position = target.css('position');
            originalPosition = target.css('position');
            originalFloat = target.css('float');
            originalOffsetTop = target.css('top');

            // Place the spacer right after the target element.
            if (isUnfixed()) base.$el.after(spacer);

            // Reset the target element offsets when the window is resized, then
            // check to see if we need to fix or unfix the target element.
            $(window).bind('resize.ScrollToFixed', windowResize);

            // When the window scrolls, check to see if we need to fix or unfix
            // the target element.
            $(window).bind('scroll.ScrollToFixed', windowScroll);

            // For touch devices, call checkScroll directlly rather than
            // rAF wrapped windowScroll to animate the element
            if ('ontouchmove' in window) {
              $(window).bind('touchmove.ScrollToFixed', checkScroll);
            }

            if (base.options.preFixed) {
                target.bind('preFixed.ScrollToFixed', base.options.preFixed);
            }
            if (base.options.postFixed) {
                target.bind('postFixed.ScrollToFixed', base.options.postFixed);
            }
            if (base.options.preUnfixed) {
                target.bind('preUnfixed.ScrollToFixed', base.options.preUnfixed);
            }
            if (base.options.postUnfixed) {
                target.bind('postUnfixed.ScrollToFixed', base.options.postUnfixed);
            }
            if (base.options.preAbsolute) {
                target.bind('preAbsolute.ScrollToFixed', base.options.preAbsolute);
            }
            if (base.options.postAbsolute) {
                target.bind('postAbsolute.ScrollToFixed', base.options.postAbsolute);
            }
            if (base.options.fixed) {
                target.bind('fixed.ScrollToFixed', base.options.fixed);
            }
            if (base.options.unfixed) {
                target.bind('unfixed.ScrollToFixed', base.options.unfixed);
            }

            if (base.options.spacerClass) {
                spacer.addClass(base.options.spacerClass);
            }

            target.bind('resize.ScrollToFixed', function() {
                spacer.height(target.height());
            });

            target.bind('scroll.ScrollToFixed', function() {
                target.trigger('preUnfixed.ScrollToFixed');
                setUnfixed();
                target.trigger('unfixed.ScrollToFixed');
                checkScroll();
            });

            target.bind('detach.ScrollToFixed', function(ev) {
                preventDefault(ev);

                target.trigger('preUnfixed.ScrollToFixed');
                setUnfixed();
                target.trigger('unfixed.ScrollToFixed');

                $(window).unbind('resize.ScrollToFixed', windowResize);
                $(window).unbind('scroll.ScrollToFixed', windowScroll);

                target.unbind('.ScrollToFixed');

                //remove spacer from dom
                spacer.remove();

                base.$el.removeData('ScrollToFixed');
            });

            // Reset everything.
            windowResize();
        };

        // Initialize the plugin.
        base.init();
    };

    // Sets the option defaults.
    $.ScrollToFixed.defaultOptions = {
        marginTop : 0,
        limit : 0,
        bottom : -1,
        zIndex : 1000,
        baseClassName: 'scroll-to-fixed-fixed'
    };

    // Returns enhanced elements that will fix to the top of the page when the
    // page is scrolled.
    $.fn.scrollToFixed = function(options) {
        return this.each(function() {
            (new $.ScrollToFixed(this, options));
        });
    };
})(jQuery);
define("jquery.scrolltofixed", ["jquery"], function(){});

/*!
 * Scroll Lock v3.0.0
 * https://github.com/MohammadYounes/jquery-scrollLock
 *
 * Copyright (c) 2016 Mohammad Younes
 * Licensed under the MIT license.
 */
;(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define('jquery.scrollLock',['jquery'], factory)
  } else {
    // Browser globals
    factory(jQuery)
  }
}(function ($) {
  'use strict'
  var keys = { space: 32, pageup: 33, pagedown: 34, end: 35, home: 36,  up: 38, down: 40 }
  var ScrollLock = function ($element, options) {
    this.$element = $element
    this.options = $.extend({}, ScrollLock.DEFAULTS, this.$element.data(), options)
    this.enabled = true
    this.startClientY = 0
    this.$element.on(ScrollLock.CORE.wheelEventName + ScrollLock.NAMESPACE, this.options.selector, $.proxy(ScrollLock.CORE.handler, this))
    if (this.options.touch) {
      this.$element.on('touchstart' + ScrollLock.NAMESPACE, this.options.selector, $.proxy(ScrollLock.CORE.touchHandler, this))
      this.$element.on('touchmove' + ScrollLock.NAMESPACE, this.options.selector, $.proxy(ScrollLock.CORE.handler, this))
    }
    if (this.options.keyboard) {
      this.$element.attr('tabindex', this.options.keyboard.tabindex || 0)
      this.$element.on('keydown' + ScrollLock.NAMESPACE, this.options.selector, $.proxy(ScrollLock.CORE.keyboardHandler, this))
    }
  }
  ScrollLock.NAME = 'ScrollLock'
  ScrollLock.VERSION = '3.0.0'
  ScrollLock.NAMESPACE = '.scrollLock'
  ScrollLock.ANIMATION_NAMESPACE = ScrollLock.NAMESPACE + '.effect'
  ScrollLock.DEFAULTS = {
    strict: false,
    strictFn: function ($element) {
      return $element.prop('scrollHeight') > $element.prop('clientHeight')
    },
    selector: false,
    animation: false,
    touch: 'ontouchstart' in window,
    keyboard: false
  }
  ScrollLock.CORE = {
    wheelEventName: 'onwheel' in document.createElement('div') ? 'wheel' : // Modern browsers support "wheel"
      document.onmousewheel !== undefined ? 'mousewheel' : // Webkit and IE support at least "mousewheel"
        'DOMMouseScroll', // let's assume that remaining browsers are older Firefox,
    animationEventName: [
        'webkitAnimationEnd',
        'mozAnimationEnd',
        'MSAnimationEnd',
        'oanimationend',
        'animationend'
      ].join(ScrollLock.ANIMATION_NAMESPACE + ' ') + ScrollLock.ANIMATION_NAMESPACE,
    handler: function (event) {
      // allow zooming
      if (this.enabled && !event.ctrlKey) {
        var $this = $(event.currentTarget)
        if (this.options.strict !== true || this.options.strictFn($this)) {
          // Support for nested scrollable blocks (see https://github.com/MohammadYounes/jquery-scrollLock/issues/4)
          event.stopPropagation()
          var scrollTop = $this.scrollTop(),
            scrollHeight = $this.prop('scrollHeight'),
            clientHeight = $this.prop('clientHeight'),
            delta = event.originalEvent.wheelDelta || (-1 * event.originalEvent.detail) || (-1 * event.originalEvent.deltaY),
            deltaY = 0
          if (event.type === 'wheel') {
            var ratio = $this.height() / $(window).height()
            deltaY = event.originalEvent.deltaY * ratio
          } else if (this.options.touch && event.type === 'touchmove') {
            delta = event.originalEvent.changedTouches[0].clientY - this.startClientY
          }
          var top
          if ((top = delta > 0 && scrollTop + deltaY <= 0) || delta < 0 && scrollTop + deltaY >= scrollHeight - clientHeight) {
            event.preventDefault()
            if (deltaY) {
              $this.scrollTop(scrollTop + deltaY)
            }
            var key = top ? 'top' : 'bottom'
            if (this.options.animation) {
              setTimeout(ScrollLock.CORE.animationHandler.bind(this, $this, key), 0)
            }
            $this.trigger($.Event(key + ScrollLock.NAMESPACE))
          }
        }
      }
    },
    touchHandler: function (event) {
      this.startClientY = event.originalEvent.touches[0].clientY
    },
    animationHandler: function ($element, key) {
      var css = this.options.animation[key],
        all = this.options.animation.top + ' ' + this.options.animation.bottom
      $element.off(ScrollLock.ANIMATION_NAMESPACE)
        .removeClass(all)
        .addClass(css)
        .one(ScrollLock.CORE.animationEventName,
          function () {
            $element.removeClass(css)
          })
    },
    keyboardHandler: function (event) {
      var $this = $(event.currentTarget),
        scrollTop = $this.scrollTop()

      if (scrollTop === 0 && (event.keyCode === keys.pageup || event.keyCode === keys.home || event.keyCode === keys.up)) {
        $this.trigger($.Event('top' + ScrollLock.NAMESPACE))
        if (this.options.animation) {
          setTimeout(ScrollLock.CORE.animationHandler.bind(this, $this, 'top'), 0)
        }
        return false
      } else {
        var scrollHeight = $this.prop('scrollHeight'),
          clientHeight = $this.prop('clientHeight')

        if (scrollHeight === scrollTop + clientHeight && (event.keyCode === keys.space || event.keyCode === keys.pagedown || event.keyCode === keys.end || event.keyCode === keys.down)) {
          $this.trigger($.Event('bottom' + ScrollLock.NAMESPACE))
          if (this.options.animation) {
            setTimeout(ScrollLock.CORE.animationHandler.bind(this, $this, 'bottom'), 0)
          }
          return false
        }
      }
    }
  }
  ScrollLock.prototype.toggleStrict = function () {
    this.options.strict = !this.options.strict
  }
  ScrollLock.prototype.enable = function () {
    this.enabled = true
  }
  ScrollLock.prototype.disable = function () {
    this.enabled = false
  }
  ScrollLock.prototype.destroy = function () {
    this.disable()
    this.$element.off(ScrollLock.NAMESPACE)
    this.$element = null
    this.options = null
  }
  // plugin defintion.
  var old = $.fn.scrollLock
  $.fn.scrollLock = function (option) {
    return this.each(function () {
      var $this = $(this)
      var options = typeof option == 'object' && option
      var data = $this.data(ScrollLock.NAME)
      if (!data && 'destroy' === option) return
      if (!data) $this.data(ScrollLock.NAME, (data = new ScrollLock($this, options)))
      if (typeof option == 'string') data[option]()
    })
  }
  $.fn.scrollLock.defaults = ScrollLock.DEFAULTS
  // no conflict
  $.fn.scrollLock.noConflict = function () {
    $.fn.scrollLock = old
    return this
  }
}));

define('view-header',[
    'jquery',
    'module-oneCookie',
    'module-oneDrawer',
    'module-oneSubscribe',
    'module-oneMobileMenu',
    'module-oneCustomScroll',
    'jquery.hoverintent',
    'jquery.scrolltofixed',
    'jquery.scrollLock'
], function ($, OneCookie, OneDrawer, OneSubscribe, OneMobileMenu, CustomScroll) {

    "use strict";

    var ViewHeader = Backbone.View.extend({

        initialize: function (opts) {

            console.log('init header');

			var self = this;
			self.$body = self.$el;
            self.$header = $('header.site-header');
            self.$utilities = self.$header.find('.header-utilities');
            self.$miniCart = $('#MiniCart');
            self.$mobileNav = $('#MobileNav');
            self.$searchBar = $('#SearchBar');
            self.$footer = $('footer.site-footer');
            self.$backToTop = self.$body.find('.back-to-top');
            self.$promoBanner = self.$header.find('.promo-banner');
            self.$navi = self.$header.find('nav');
            self.$menuToggle = self.$header.find('.menu-toggle');
            self.$scrollable = self.$el.find('.scrollable');
            self.$customChatToggles = self.$el.find('.custom-chat-toggle');
            self.$wishlistBlock = self.$el.find('.block-wishlist');

            // if the first element with class ".hero-banner__container" has class "white", then add class "initial-white" to body
            const heroBanners = document.querySelectorAll('.hero-banner__container, .large-slider');
            const collectionBanner = document.querySelector('.collection-header.white');
            const heroSection = document.querySelector('.hero-section[data-index="1"]');
            
            if (((!heroBanners.length > 0 || heroBanners[0]?.classList.contains('white')) && !collectionBanner) || heroSection) {
              self.$body.addClass('initial-white');
              $('.header').css('background', '#ffffff');
              $('.header-content').css('background', '#ffffff').css('color', '#000000').css('opacity', 1);
              $('.site-logo svg').css('color', '#d61a3c');
            } else {
              $('.header-content').css("background", "linear-gradient(180deg, rgba(0,0,0,0.8295693277310925) 9%, rgba(0,0,0,0) 100%)");
              $('.header-content').css('opacity', 1);
            }

            if (heroSection) {
              $('body').removeClass('header-gradient')
            }

            self.initPromoBanner();
            // self.initFixedHeader();
            self.onScroll();
            _.each(self.$scrollable, function(child){
                CustomScroll.init({
                    el: child,
                    margin: 60
                });
            });
            self.initUtilities();
            self.initSearch();
            self.initMiniCart();
            self.initMobileMenu();
            // self.initSubscirbe();
            self.backToTop();
            self.devTools();
            self.wishlistCount();
            window.iWishAddFn = () => self.wishlistCount();
            window.iWishRemoveFn = () => self.wishlistCount();

            if(!self.isDesktop()){
                self.footerCollapse();
            }

            OneCookie.init({
                cookieName: 'hidecookiemodal',
                el: '.cookie-agreement-modal',
            });

		},

		events: {
            'drawer-opt' : 'bodyClassCtl',
            'menu-opt' : 'bodyClassCtl'
		},

        bodyClassCtl : function(e){
            // Please prevent operation on more then one drawer at the same time
            var self = this;
            var type = e.type;
            if (type == 'drawer-opt') {
                self.$body.toggleClass('drawer-opt');
                self.$body.toggleClass('show-overlay');
            } else {
                // console.log('toggle body class');
                self.$body.toggleClass('show-overlay');
            }
        },

        initPromoBanner: function(){
            var self = this;
            var cookieEnabled = self.$promoBanner.data('cookieenabled');
            var cookieDays = self.$promoBanner.data('days');

            if(self.$promoBanner.length > 0){
                if(!ORW.utilities.getCookie('promo_banner')){
                    self.$body.addClass('promo-banner-active');
                    self.$promoBanner.addClass('activate');
                }
            }

            var events = {
                'click .close-promo' : function(e){
                    self.$promoBanner.slideUp(200);
                    self.$body.removeClass('promo-banner-active');
                    self.$promoBanner.removeClass('activate');

                    if(!ORW.utilities.getCookie('promo_banner') && cookieEnabled ){
                        ORW.utilities.setCookie('promo_banner','shown', cookieDays);
                    }
                }
            }

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        initFixedHeader: function() {
            var self = this;
            self.$header.scrollToFixed({
                dontSetWidth : true
            });
        },

        onScroll: function(){
            // performant scroll event listening as shown here: http://joji.me/en-us/blog/how-to-develop-high-performance-onscroll-event

            var self = this;

            var scroll = function () {
                var lastScrollTop = $(window).scrollTop();
                if(lastScrollTop > 0){
                    self.$body.addClass('is-scrolled');
                    if(lastScrollTop > 400){
                        self.$backToTop.addClass('active');
                    }else{
                        self.$backToTop.removeClass('active');
                    }
                }else{
                    self.$body.removeClass('is-scrolled');
                    self.$backToTop.removeClass('active');
                }
            };

            var waiting = false, endScrollHandle;
            $(window).scroll(function () {
                if (waiting) {
                    return;
                }
                waiting = true;

                clearTimeout(endScrollHandle);

                scroll();

                setTimeout(function () {
                    waiting = false;
                }, 100);

                // schedule an extra execution of scroll() after 200ms
                // in case the scrolling stops in next 100ms
                endScrollHandle = setTimeout(function () {
                    scroll();
                }, 200);
            });

            scroll();
        },
        initUtilities: function() {
            var self = this;

            // // Header hover control
            self.$header.hoverIntent({
                over: function(e){
                    if (!e.target.closest('.site-nav-item').classList.contains('no-child') && !e.target.classList.contains('nav-bar') ) {
                        self.$body.addClass('show-overlay');
                    }
                },
                out: function(){
                    self.$body.removeClass('show-overlay');
                },
                sensitivity: 100,
                selector: '#shopify-section-navigation'
            });

            self.$header.hoverIntent({
              over: function(e){
                  if (!e.target.closest('.site-nav-item').classList.contains('no-child')) {
                      self.$body.addClass('show-overlay');
                  } else {
                      self.$body.removeClass('show-overlay');
                  }
              },
              out: function(){
              },
              sensitivity: 100,
              selector: '.site-nav-item'
            });

            self.$utilities.find('.header-block').hoverIntent({
                over: function(){
                    $(this).addClass("hover");
                },
                out: function(){
                    $(this).removeClass("hover");
                },
                sensitivity: 100
            });

            // Only show zendesk custom toggles when zendesk is active and initialized
            // https://api.zopim.com/files/meshim/widget/controllers/liveChatAPI/Window-js.html
            if(typeof $zopim !== "undefined"){
                self.$customChatToggles.removeClass("hide");

                var events = {
                    'click .custom-chat-toggle' : function(e){
                        $zopim.livechat.window.show();
                        $(e.currentTarget).closest('.header-block').removeClass("hover");
                        self.$body.removeClass('show-overlay');
                    }
                };

                // Update and delegate adding events
                _.extend(self.events, events);
                self.delegateEvents();
            }

        },

        initSearch: function(){
            var self = this;

            self.searchCtl = OneDrawer.init({
                el: self.$body,
                drawerElem: '#' + self.$searchBar.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .search-toggle',
                openCallback: function(){
                    setTimeout(function(){ self.$searchBar.find('input').focus(); },100);
                },
                events: {
                    'click .search-form button' : function(e){
                        e.preventDefault();
                        var $form = $(e.currentTarget).parent('form');
                        if ($form.find('input').val()) {
                            this.closeDrawer();
                            $form.submit();
                        } else {
                            // May be show error message ...
                        }
                    }
                }
            });
        },

        initMobileMenu: function(){
            var self = this;

            self.mobileMenuCtl = OneDrawer.init({
                el: self.$body,
                drawerElem: '#' + self.$mobileNav.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .menu-toggle',
                openCallback: function(e){

                    self.$menuToggle.find('.animated-hamburger').toggleClass('open');
                },
                closeCallback: function(e){
                    self.$menuToggle.find('.animated-hamburger').removeClass('open');
                }
            });

            self.mobileInnerMenuCtl = OneMobileMenu.init({
                el: self.$mobileNav
            });
        },

        initMiniCart: function() {
          var self = this;

          $('.close-cart').on("click",function() {
            $('#MiniCart').removeClass("opened");
            self.$body.removeClass("show-overlay minicart-open");
          });

          self.miniCartCtl = OneDrawer.init({
            el: self.$body,
            drawerElem: '#' + self.$miniCart.attr('id'),
            triggerEvent: 'click',
            triggerElem: 'header .block-minicart',
            openCallback: function(e){
              if (self.isMobile()) {
                self.$body.addClass("minicart-open");
              } else {
                // window.location.href = $('header .block-minicart').data("href");
              }
            },
            closeCallback: function(e) {
              self.$body.removeClass("minicart-open");
            }
          });

          ajaxCart.init({
            formSelector: '.add-to-cart-form',
            addToCartSelector: '.add-to-cart-btn',
            cartContainer: '#CartContainer',
            cartCountSelector: '.minicart-count',
            cartCostSelector: '#CartCost',
            moneyFormat: theme.moneyFormat
          });

          $(document).on('afterAddToCart.ajaxCart', function(evt, cart) {
            self.miniCartCtl.openDrawer();
          });
        },

        initSubscirbe: function() {
            var self = this;
            var oneSub = OneSubscribe.init({
                el: $('.subscribe-modal'),
                // delay: 2000,
                // errorMsg: 'Oops, something wrong happened, please try again later',
                // successMsg: 'Thank you and welcome to Safiyaa. You will receive an email to confirm your subscription shortly.',
                // requiredMsg: 'Error: required field',
                // errorEmail: 'Error: please ensure formatting is correct',
                cookieEnabled: false,
                // cookieDays: 1
            });

            oneSub.$el.on('click', function (e) {
                e.stopPropagation();
            });
        },

        backToTop: function(){
            var self = this;
            var events = {
                'click .back-to-top': function(e){
                    e.preventDefault();
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            };

            _.extend(self.events, events);
            self.delegateEvents();
        },

        footerCollapse: function(){
            var self = this;
            var $collapseToggle = self.$footer.find('.collapsible-toggle span');
            var $collapse = self.$footer.find('.collapsible');
            var height = $collapse.outerHeight();
            $collapse.css('height', 0);

            var events = {
                'click .site-footer .collapsible-toggle': function(e){
                    $(e.currentTarget).toggleClass('active');
                    if($(e.currentTarget).hasClass('active')){
                        $collapse.css('height', height);
                        $collapseToggle.html('-');
                    }else{
                        $collapse.css('height', 0);
                        $collapseToggle.html('+');
                    }
                }
            };

            _.extend(self.events, events);
            self.delegateEvents();
        },

        devTools: function(){
            //these tools should only be used during the development phase of a new build
            var self = this;
            var $indicator = $('#responsive-indicator');
            var $previewBar = $('#preview-bar-iframe');

            // console.log($indicator.length);
            // console.log($previewBar.length);

            if(Shopify.PreviewBarInjector !== undefined){
                if($indicator.length > 0 && $previewBar.length > 0 && Shopify.PreviewBarInjector.length == 1){
                    $indicator.text("Preview: " + Shopify.theme.name).removeClass("hide");
                    var events = {
                        'click #responsive-indicator': function(e){
                            $indicator.toggleClass('active');
                            $previewBar.toggleClass('active');
                        }
                    };

                    _.extend(self.events, events);
                    self.delegateEvents();
                }else{
                    $indicator.addClass("hide");
                }
            }
        },

        wishlistCount: function () {
            var count = window.iWishCnt;
            var self = this;
            var $wishlistCount = self.$wishlistBlock.find('.wishlist-count');

            if (count > 0) {
                if ($wishlistCount.length) {
                    $wishlistCount.html(count);
                } else {
                    self.$wishlistBlock.append('<span class="wishlist-count">' + count + '</span>');
                }
            } else {
                $wishlistCount.remove();
            }
        },

        updateWishlistCount: function () {
            var self = this;
            $('.iWishAdd, .iwishRemoveBtn').click(function () {
                setTimeout(function () {
                    self.wishlistCount();
                }, 500);
            });
        },

        isDesktop: function () {
            var self = this;
            var w = $(window).width();
            if (w > ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        },

        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        }

    });

    return ViewHeader;

});

/**
 * @license RequireJS domReady 2.0.1 Copyright (c) 2010-2012, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/requirejs/domReady for details
 */
/*jslint */
/*global require: false, define: false, requirejs: false,
  window: false, clearInterval: false, document: false,
  self: false, setInterval: false */


define('domReady',[],function () {
    'use strict';

    var isTop, testDiv, scrollIntervalId,
        isBrowser = typeof window !== "undefined" && window.document,
        isPageLoaded = !isBrowser,
        doc = isBrowser ? document : null,
        readyCalls = [];

    function runCallbacks(callbacks) {
        var i;
        for (i = 0; i < callbacks.length; i += 1) {
            callbacks[i](doc);
        }
    }

    function callReady() {
        var callbacks = readyCalls;

        if (isPageLoaded) {
            //Call the DOM ready callbacks
            if (callbacks.length) {
                readyCalls = [];
                runCallbacks(callbacks);
            }
        }
    }

    /**
     * Sets the page as loaded.
     */
    function pageLoaded() {
        if (!isPageLoaded) {
            isPageLoaded = true;
            if (scrollIntervalId) {
                clearInterval(scrollIntervalId);
            }

            callReady();
        }
    }

    if (isBrowser) {
        if (document.addEventListener) {
            //Standards. Hooray! Assumption here that if standards based,
            //it knows about DOMContentLoaded.
            document.addEventListener("DOMContentLoaded", pageLoaded, false);
            window.addEventListener("load", pageLoaded, false);
        } else if (window.attachEvent) {
            window.attachEvent("onload", pageLoaded);

            testDiv = document.createElement('div');
            try {
                isTop = window.frameElement === null;
            } catch (e) {}

            //DOMContentLoaded approximation that uses a doScroll, as found by
            //Diego Perini: http://javascript.nwbox.com/IEContentLoaded/,
            //but modified by other contributors, including jdalton
            if (testDiv.doScroll && isTop && window.external) {
                scrollIntervalId = setInterval(function () {
                    try {
                        testDiv.doScroll();
                        pageLoaded();
                    } catch (e) {}
                }, 30);
            }
        }

        //Check if document already complete, and if so, just trigger page load
        //listeners. Latest webkit browsers also use "interactive", and
        //will fire the onDOMContentLoaded before "interactive" but not after
        //entering "interactive" or "complete". More details:
        //http://dev.w3.org/html5/spec/the-end.html#the-end
        //http://stackoverflow.com/questions/3665561/document-readystate-of-interactive-vs-ondomcontentloaded
        //Hmm, this is more complicated on further use, see "firing too early"
        //bug: https://github.com/requirejs/domReady/issues/1
        //so removing the || document.readyState === "interactive" test.
        //There is still a window.onload binding that should get fired if
        //DOMContentLoaded is missed.
        if (document.readyState === "complete") {
            pageLoaded();
        }
    }

    /** START OF PUBLIC API **/

    /**
     * Registers a callback for DOM ready. If DOM is already ready, the
     * callback is called immediately.
     * @param {Function} callback
     */
    function domReady(callback) {
        if (isPageLoaded) {
            callback(doc);
        } else {
            readyCalls.push(callback);
        }
        return domReady;
    }

    domReady.version = '2.0.1';

    /**
     * Loader Plugin API method
     */
    domReady.load = function (name, req, onLoad, config) {
        if (config.isBuild) {
            onLoad(null);
        } else {
            domReady(onLoad);
        }
    };

    /** END OF PUBLIC API **/

    return domReady;
});
/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
*/
jQuery.easing.jswing=jQuery.easing.swing;jQuery.extend(jQuery.easing,{def:"easeOutQuad",swing:function(e,f,a,h,g){return jQuery.easing[jQuery.easing.def](e,f,a,h,g)},easeInQuad:function(e,f,a,h,g){return h*(f/=g)*f+a},easeOutQuad:function(e,f,a,h,g){return -h*(f/=g)*(f-2)+a},easeInOutQuad:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f+a}return -h/2*((--f)*(f-2)-1)+a},easeInCubic:function(e,f,a,h,g){return h*(f/=g)*f*f+a},easeOutCubic:function(e,f,a,h,g){return h*((f=f/g-1)*f*f+1)+a},easeInOutCubic:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f+a}return h/2*((f-=2)*f*f+2)+a},easeInQuart:function(e,f,a,h,g){return h*(f/=g)*f*f*f+a},easeOutQuart:function(e,f,a,h,g){return -h*((f=f/g-1)*f*f*f-1)+a},easeInOutQuart:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f*f+a}return -h/2*((f-=2)*f*f*f-2)+a},easeInQuint:function(e,f,a,h,g){return h*(f/=g)*f*f*f*f+a},easeOutQuint:function(e,f,a,h,g){return h*((f=f/g-1)*f*f*f*f+1)+a},easeInOutQuint:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f*f*f+a}return h/2*((f-=2)*f*f*f*f+2)+a},easeInSine:function(e,f,a,h,g){return -h*Math.cos(f/g*(Math.PI/2))+h+a},easeOutSine:function(e,f,a,h,g){return h*Math.sin(f/g*(Math.PI/2))+a},easeInOutSine:function(e,f,a,h,g){return -h/2*(Math.cos(Math.PI*f/g)-1)+a},easeInExpo:function(e,f,a,h,g){return(f==0)?a:h*Math.pow(2,10*(f/g-1))+a},easeOutExpo:function(e,f,a,h,g){return(f==g)?a+h:h*(-Math.pow(2,-10*f/g)+1)+a},easeInOutExpo:function(e,f,a,h,g){if(f==0){return a}if(f==g){return a+h}if((f/=g/2)<1){return h/2*Math.pow(2,10*(f-1))+a}return h/2*(-Math.pow(2,-10*--f)+2)+a},easeInCirc:function(e,f,a,h,g){return -h*(Math.sqrt(1-(f/=g)*f)-1)+a},easeOutCirc:function(e,f,a,h,g){return h*Math.sqrt(1-(f=f/g-1)*f)+a},easeInOutCirc:function(e,f,a,h,g){if((f/=g/2)<1){return -h/2*(Math.sqrt(1-f*f)-1)+a}return h/2*(Math.sqrt(1-(f-=2)*f)+1)+a},easeInElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k)==1){return e+l}if(!j){j=k*0.3}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}return -(g*Math.pow(2,10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j))+e},easeOutElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k)==1){return e+l}if(!j){j=k*0.3}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}return g*Math.pow(2,-10*h)*Math.sin((h*k-i)*(2*Math.PI)/j)+l+e},easeInOutElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k/2)==2){return e+l}if(!j){j=k*(0.3*1.5)}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}if(h<1){return -0.5*(g*Math.pow(2,10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j))+e}return g*Math.pow(2,-10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j)*0.5+l+e},easeInBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}return i*(f/=h)*f*((g+1)*f-g)+a},easeOutBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}return i*((f=f/h-1)*f*((g+1)*f+g)+1)+a},easeInOutBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}if((f/=h/2)<1){return i/2*(f*f*(((g*=(1.525))+1)*f-g))+a}return i/2*((f-=2)*f*(((g*=(1.525))+1)*f+g)+2)+a},easeInBounce:function(e,f,a,h,g){return h-jQuery.easing.easeOutBounce(e,g-f,0,h,g)+a},easeOutBounce:function(e,f,a,h,g){if((f/=g)<(1/2.75)){return h*(7.5625*f*f)+a}else{if(f<(2/2.75)){return h*(7.5625*(f-=(1.5/2.75))*f+0.75)+a}else{if(f<(2.5/2.75)){return h*(7.5625*(f-=(2.25/2.75))*f+0.9375)+a}else{return h*(7.5625*(f-=(2.625/2.75))*f+0.984375)+a}}}},easeInOutBounce:function(e,f,a,h,g){if(f<g/2){return jQuery.easing.easeInBounce(e,f*2,0,h,g)*0.5+a}return jQuery.easing.easeOutBounce(e,f*2-g,0,h,g)*0.5+h*0.5+a}});
define("jquery.easing", ["jquery"], function(){});

(function(t,e){if(typeof define==="function"&&define.amd){define('jquery.transit',["jquery"],e)}else if(typeof exports==="object"){module.exports=e(require("jquery"))}else{e(t.jQuery)}})(this,function(t){t.transit={version:"0.9.12",propertyMap:{marginLeft:"margin",marginRight:"margin",marginBottom:"margin",marginTop:"margin",paddingLeft:"padding",paddingRight:"padding",paddingBottom:"padding",paddingTop:"padding"},enabled:true,useTransitionEnd:false};var e=document.createElement("div");var n={};function i(t){if(t in e.style)return t;var n=["Moz","Webkit","O","ms"];var i=t.charAt(0).toUpperCase()+t.substr(1);for(var r=0;r<n.length;++r){var s=n[r]+i;if(s in e.style){return s}}}function r(){e.style[n.transform]="";e.style[n.transform]="rotateY(90deg)";return e.style[n.transform]!==""}var s=navigator.userAgent.toLowerCase().indexOf("chrome")>-1;n.transition=i("transition");n.transitionDelay=i("transitionDelay");n.transform=i("transform");n.transformOrigin=i("transformOrigin");n.filter=i("Filter");n.transform3d=r();var a={transition:"transitionend",MozTransition:"transitionend",OTransition:"oTransitionEnd",WebkitTransition:"webkitTransitionEnd",msTransition:"MSTransitionEnd"};var o=n.transitionEnd=a[n.transition]||null;for(var u in n){if(n.hasOwnProperty(u)&&typeof t.support[u]==="undefined"){t.support[u]=n[u]}}e=null;t.cssEase={_default:"ease","in":"ease-in",out:"ease-out","in-out":"ease-in-out",snap:"cubic-bezier(0,1,.5,1)",easeInCubic:"cubic-bezier(.550,.055,.675,.190)",easeOutCubic:"cubic-bezier(.215,.61,.355,1)",easeInOutCubic:"cubic-bezier(.645,.045,.355,1)",easeInCirc:"cubic-bezier(.6,.04,.98,.335)",easeOutCirc:"cubic-bezier(.075,.82,.165,1)",easeInOutCirc:"cubic-bezier(.785,.135,.15,.86)",easeInExpo:"cubic-bezier(.95,.05,.795,.035)",easeOutExpo:"cubic-bezier(.19,1,.22,1)",easeInOutExpo:"cubic-bezier(1,0,0,1)",easeInQuad:"cubic-bezier(.55,.085,.68,.53)",easeOutQuad:"cubic-bezier(.25,.46,.45,.94)",easeInOutQuad:"cubic-bezier(.455,.03,.515,.955)",easeInQuart:"cubic-bezier(.895,.03,.685,.22)",easeOutQuart:"cubic-bezier(.165,.84,.44,1)",easeInOutQuart:"cubic-bezier(.77,0,.175,1)",easeInQuint:"cubic-bezier(.755,.05,.855,.06)",easeOutQuint:"cubic-bezier(.23,1,.32,1)",easeInOutQuint:"cubic-bezier(.86,0,.07,1)",easeInSine:"cubic-bezier(.47,0,.745,.715)",easeOutSine:"cubic-bezier(.39,.575,.565,1)",easeInOutSine:"cubic-bezier(.445,.05,.55,.95)",easeInBack:"cubic-bezier(.6,-.28,.735,.045)",easeOutBack:"cubic-bezier(.175, .885,.32,1.275)",easeInOutBack:"cubic-bezier(.68,-.55,.265,1.55)"};t.cssHooks["transit:transform"]={get:function(e){return t(e).data("transform")||new f},set:function(e,i){var r=i;if(!(r instanceof f)){r=new f(r)}if(n.transform==="WebkitTransform"&&!s){e.style[n.transform]=r.toString(true)}else{e.style[n.transform]=r.toString()}t(e).data("transform",r)}};t.cssHooks.transform={set:t.cssHooks["transit:transform"].set};t.cssHooks.filter={get:function(t){return t.style[n.filter]},set:function(t,e){t.style[n.filter]=e}};if(t.fn.jquery<"1.8"){t.cssHooks.transformOrigin={get:function(t){return t.style[n.transformOrigin]},set:function(t,e){t.style[n.transformOrigin]=e}};t.cssHooks.transition={get:function(t){return t.style[n.transition]},set:function(t,e){t.style[n.transition]=e}}}p("scale");p("scaleX");p("scaleY");p("translate");p("rotate");p("rotateX");p("rotateY");p("rotate3d");p("perspective");p("skewX");p("skewY");p("x",true);p("y",true);function f(t){if(typeof t==="string"){this.parse(t)}return this}f.prototype={setFromString:function(t,e){var n=typeof e==="string"?e.split(","):e.constructor===Array?e:[e];n.unshift(t);f.prototype.set.apply(this,n)},set:function(t){var e=Array.prototype.slice.apply(arguments,[1]);if(this.setter[t]){this.setter[t].apply(this,e)}else{this[t]=e.join(",")}},get:function(t){if(this.getter[t]){return this.getter[t].apply(this)}else{return this[t]||0}},setter:{rotate:function(t){this.rotate=b(t,"deg")},rotateX:function(t){this.rotateX=b(t,"deg")},rotateY:function(t){this.rotateY=b(t,"deg")},scale:function(t,e){if(e===undefined){e=t}this.scale=t+","+e},skewX:function(t){this.skewX=b(t,"deg")},skewY:function(t){this.skewY=b(t,"deg")},perspective:function(t){this.perspective=b(t,"px")},x:function(t){this.set("translate",t,null)},y:function(t){this.set("translate",null,t)},translate:function(t,e){if(this._translateX===undefined){this._translateX=0}if(this._translateY===undefined){this._translateY=0}if(t!==null&&t!==undefined){this._translateX=b(t,"px")}if(e!==null&&e!==undefined){this._translateY=b(e,"px")}this.translate=this._translateX+","+this._translateY}},getter:{x:function(){return this._translateX||0},y:function(){return this._translateY||0},scale:function(){var t=(this.scale||"1,1").split(",");if(t[0]){t[0]=parseFloat(t[0])}if(t[1]){t[1]=parseFloat(t[1])}return t[0]===t[1]?t[0]:t},rotate3d:function(){var t=(this.rotate3d||"0,0,0,0deg").split(",");for(var e=0;e<=3;++e){if(t[e]){t[e]=parseFloat(t[e])}}if(t[3]){t[3]=b(t[3],"deg")}return t}},parse:function(t){var e=this;t.replace(/([a-zA-Z0-9]+)\((.*?)\)/g,function(t,n,i){e.setFromString(n,i)})},toString:function(t){var e=[];for(var i in this){if(this.hasOwnProperty(i)){if(!n.transform3d&&(i==="rotateX"||i==="rotateY"||i==="perspective"||i==="transformOrigin")){continue}if(i[0]!=="_"){if(t&&i==="scale"){e.push(i+"3d("+this[i]+",1)")}else if(t&&i==="translate"){e.push(i+"3d("+this[i]+",0)")}else{e.push(i+"("+this[i]+")")}}}}return e.join(" ")}};function c(t,e,n){if(e===true){t.queue(n)}else if(e){t.queue(e,n)}else{t.each(function(){n.call(this)})}}function l(e){var i=[];t.each(e,function(e){e=t.camelCase(e);e=t.transit.propertyMap[e]||t.cssProps[e]||e;e=h(e);if(n[e])e=h(n[e]);if(t.inArray(e,i)===-1){i.push(e)}});return i}function d(e,n,i,r){var s=l(e);if(t.cssEase[i]){i=t.cssEase[i]}var a=""+y(n)+" "+i;if(parseInt(r,10)>0){a+=" "+y(r)}var o=[];t.each(s,function(t,e){o.push(e+" "+a)});return o.join(", ")}t.fn.transition=t.fn.transit=function(e,i,r,s){var a=this;var u=0;var f=true;var l=t.extend(true,{},e);if(typeof i==="function"){s=i;i=undefined}if(typeof i==="object"){r=i.easing;u=i.delay||0;f=typeof i.queue==="undefined"?true:i.queue;s=i.complete;i=i.duration}if(typeof r==="function"){s=r;r=undefined}if(typeof l.easing!=="undefined"){r=l.easing;delete l.easing}if(typeof l.duration!=="undefined"){i=l.duration;delete l.duration}if(typeof l.complete!=="undefined"){s=l.complete;delete l.complete}if(typeof l.queue!=="undefined"){f=l.queue;delete l.queue}if(typeof l.delay!=="undefined"){u=l.delay;delete l.delay}if(typeof i==="undefined"){i=t.fx.speeds._default}if(typeof r==="undefined"){r=t.cssEase._default}i=y(i);var p=d(l,i,r,u);var h=t.transit.enabled&&n.transition;var b=h?parseInt(i,10)+parseInt(u,10):0;if(b===0){var g=function(t){a.css(l);if(s){s.apply(a)}if(t){t()}};c(a,f,g);return a}var m={};var v=function(e){var i=false;var r=function(){if(i){a.unbind(o,r)}if(b>0){a.each(function(){this.style[n.transition]=m[this]||null})}if(typeof s==="function"){s.apply(a)}if(typeof e==="function"){e()}};if(b>0&&o&&t.transit.useTransitionEnd){i=true;a.bind(o,r)}else{window.setTimeout(r,b)}a.each(function(){if(b>0){this.style[n.transition]=p}t(this).css(l)})};var z=function(t){this.offsetWidth;v(t)};c(a,f,z);return this};function p(e,i){if(!i){t.cssNumber[e]=true}t.transit.propertyMap[e]=n.transform;t.cssHooks[e]={get:function(n){var i=t(n).css("transit:transform");return i.get(e)},set:function(n,i){var r=t(n).css("transit:transform");r.setFromString(e,i);t(n).css({"transit:transform":r})}}}function h(t){return t.replace(/([A-Z])/g,function(t){return"-"+t.toLowerCase()})}function b(t,e){if(typeof t==="string"&&!t.match(/^[\-0-9\.]+$/)){return t}else{return""+t+e}}function y(e){var n=e;if(typeof n==="string"&&!n.match(/^[\-0-9\.]+/)){n=t.fx.speeds[n]||t.fx.speeds._default}return b(n,"ms")}t.transit.getTransitionValue=d;return t});
define('router',[
    "view-header",
    "domReady",
    "jquery",
    "jquery.easing",
    "jquery.transit"
], function (ViewHeader, domReady, $) {

    "use strict";

    var $body = $(document.body);

    if (!$.support.transition) {
        $.fn.transition = $.fn.beforeanimate;
    };

    // Global requires
    domReady(function(){
        ORW.Header = new ViewHeader({el: $body});
    });

    if ($body.hasClass('template-')) {
      // app page
      $body.removeClass('template-');
      $body.addClass('template-app');

      var app = window.location.pathname.split('/').pop();
      if (app) $body.addClass('app-' + app);
    }

    // Start routing by template type
    console.log('Routing...' + ' ' + $body.attr('class'));

    if ($body.hasClass('template-index') || $body.hasClass('template-home') || $body.hasClass('page-home')) {
        require(["page-home"]);
    }

    if ( $body.data('tempsuffix') == 'lookbook' ) {
        require(["page-lookbook"]);
    }

    if ( ($body.hasClass('template-collection') || $body.hasClass('template-search')) && $body.data('tempsuffix') != 'lookbook' ) {
        require(["page-collection"]);
    }

    if ($body.hasClass('template-product')) {
        require(["page-product"]);
    }

    if ($body.hasClass('template-page')) {
        require(["page-cms"]);
    }

    if ($body.hasClass('template-style-guide') || $body.hasClass('page-style-guide')) {
        require(["page-styleGuide"]);
    }

    if ($body.hasClass('template-customers-login') || $body.hasClass('template-customers-register')) {
        require(["page-login"]);
    }

    if ($body.hasClass('template-customers-account') || $body.hasClass('template-customers-order') || $body.hasClass('template-customers-addresses') ) {
        require(["page-account"]);
    }

    if ($body.hasClass('template-article')) {
        require(["page-article"]);
    }

    if ($body.hasClass('page-stores')) {
        require(['page-stores']);
    }

    if ($body.hasClass('page-your-shopping-cart')) {
        require(['page-cart']);
    }

    if ($body.hasClass('app-iwish')) {
      require([ 'page-iwish' ]);
    }

    if ($body.hasClass('template-page') && $body.hasClass('template-suffix-loyalty')) {
      require([ 'page-loyalty' ]);
    }

    if ($body.hasClass('page-about-us')) {
        require([ 'page-about' ]);
    }

    if ($body.hasClass('template-page') && $body.hasClass('template-suffix-appointments')) {
        require([ 'page-appointment' ]);
    }
    
});

/**
 * @license text 2.0.15 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/text/LICENSE
 */
/*jslint regexp: true */
/*global require, XMLHttpRequest, ActiveXObject,
  define, window, process, Packages,
  java, location, Components, FileUtils */

define('text',['module'], function (module) {
    'use strict';

    var text, fs, Cc, Ci, xpcIsWindows,
        progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'],
        xmlRegExp = /^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im,
        bodyRegExp = /<body[^>]*>\s*([\s\S]+)\s*<\/body>/im,
        hasLocation = typeof location !== 'undefined' && location.href,
        defaultProtocol = hasLocation && location.protocol && location.protocol.replace(/\:/, ''),
        defaultHostName = hasLocation && location.hostname,
        defaultPort = hasLocation && (location.port || undefined),
        buildMap = {},
        masterConfig = (module.config && module.config()) || {};

    function useDefault(value, defaultValue) {
        return value === undefined || value === '' ? defaultValue : value;
    }

    //Allow for default ports for http and https.
    function isSamePort(protocol1, port1, protocol2, port2) {
        if (port1 === port2) {
            return true;
        } else if (protocol1 === protocol2) {
            if (protocol1 === 'http') {
                return useDefault(port1, '80') === useDefault(port2, '80');
            } else if (protocol1 === 'https') {
                return useDefault(port1, '443') === useDefault(port2, '443');
            }
        }
        return false;
    }

    text = {
        version: '2.0.15',

        strip: function (content) {
            //Strips <?xml ...?> declarations so that external SVG and XML
            //documents can be added to a document without worry. Also, if the string
            //is an HTML document, only the part inside the body tag is returned.
            if (content) {
                content = content.replace(xmlRegExp, "");
                var matches = content.match(bodyRegExp);
                if (matches) {
                    content = matches[1];
                }
            } else {
                content = "";
            }
            return content;
        },

        jsEscape: function (content) {
            return content.replace(/(['\\])/g, '\\$1')
                .replace(/[\f]/g, "\\f")
                .replace(/[\b]/g, "\\b")
                .replace(/[\n]/g, "\\n")
                .replace(/[\t]/g, "\\t")
                .replace(/[\r]/g, "\\r")
                .replace(/[\u2028]/g, "\\u2028")
                .replace(/[\u2029]/g, "\\u2029");
        },

        createXhr: masterConfig.createXhr || function () {
            //Would love to dump the ActiveX crap in here. Need IE 6 to die first.
            var xhr, i, progId;
            if (typeof XMLHttpRequest !== "undefined") {
                return new XMLHttpRequest();
            } else if (typeof ActiveXObject !== "undefined") {
                for (i = 0; i < 3; i += 1) {
                    progId = progIds[i];
                    try {
                        xhr = new ActiveXObject(progId);
                    } catch (e) {}

                    if (xhr) {
                        progIds = [progId];  // so faster next time
                        break;
                    }
                }
            }

            return xhr;
        },

        /**
         * Parses a resource name into its component parts. Resource names
         * look like: module/name.ext!strip, where the !strip part is
         * optional.
         * @param {String} name the resource name
         * @returns {Object} with properties "moduleName", "ext" and "strip"
         * where strip is a boolean.
         */
        parseName: function (name) {
            var modName, ext, temp,
                strip = false,
                index = name.lastIndexOf("."),
                isRelative = name.indexOf('./') === 0 ||
                             name.indexOf('../') === 0;

            if (index !== -1 && (!isRelative || index > 1)) {
                modName = name.substring(0, index);
                ext = name.substring(index + 1);
            } else {
                modName = name;
            }

            temp = ext || modName;
            index = temp.indexOf("!");
            if (index !== -1) {
                //Pull off the strip arg.
                strip = temp.substring(index + 1) === "strip";
                temp = temp.substring(0, index);
                if (ext) {
                    ext = temp;
                } else {
                    modName = temp;
                }
            }

            return {
                moduleName: modName,
                ext: ext,
                strip: strip
            };
        },

        xdRegExp: /^((\w+)\:)?\/\/([^\/\\]+)/,

        /**
         * Is an URL on another domain. Only works for browser use, returns
         * false in non-browser environments. Only used to know if an
         * optimized .js version of a text resource should be loaded
         * instead.
         * @param {String} url
         * @returns Boolean
         */
        useXhr: function (url, protocol, hostname, port) {
            var uProtocol, uHostName, uPort,
                match = text.xdRegExp.exec(url);
            if (!match) {
                return true;
            }
            uProtocol = match[2];
            uHostName = match[3];

            uHostName = uHostName.split(':');
            uPort = uHostName[1];
            uHostName = uHostName[0];

            return (!uProtocol || uProtocol === protocol) &&
                   (!uHostName || uHostName.toLowerCase() === hostname.toLowerCase()) &&
                   ((!uPort && !uHostName) || isSamePort(uProtocol, uPort, protocol, port));
        },

        finishLoad: function (name, strip, content, onLoad) {
            content = strip ? text.strip(content) : content;
            if (masterConfig.isBuild) {
                buildMap[name] = content;
            }
            onLoad(content);
        },

        load: function (name, req, onLoad, config) {
            //Name has format: some.module.filext!strip
            //The strip part is optional.
            //if strip is present, then that means only get the string contents
            //inside a body tag in an HTML string. For XML/SVG content it means
            //removing the <?xml ...?> declarations so the content can be inserted
            //into the current doc without problems.

            // Do not bother with the work if a build and text will
            // not be inlined.
            if (config && config.isBuild && !config.inlineText) {
                onLoad();
                return;
            }

            masterConfig.isBuild = config && config.isBuild;

            var parsed = text.parseName(name),
                nonStripName = parsed.moduleName +
                    (parsed.ext ? '.' + parsed.ext : ''),
                url = req.toUrl(nonStripName),
                useXhr = (masterConfig.useXhr) ||
                         text.useXhr;

            // Do not load if it is an empty: url
            if (url.indexOf('empty:') === 0) {
                onLoad();
                return;
            }

            //Load the text. Use XHR if possible and in a browser.
            if (!hasLocation || useXhr(url, defaultProtocol, defaultHostName, defaultPort)) {
                text.get(url, function (content) {
                    text.finishLoad(name, parsed.strip, content, onLoad);
                }, function (err) {
                    if (onLoad.error) {
                        onLoad.error(err);
                    }
                });
            } else {
                //Need to fetch the resource across domains. Assume
                //the resource has been optimized into a JS module. Fetch
                //by the module name + extension, but do not include the
                //!strip part to avoid file system issues.
                req([nonStripName], function (content) {
                    text.finishLoad(parsed.moduleName + '.' + parsed.ext,
                                    parsed.strip, content, onLoad);
                });
            }
        },

        write: function (pluginName, moduleName, write, config) {
            if (buildMap.hasOwnProperty(moduleName)) {
                var content = text.jsEscape(buildMap[moduleName]);
                write.asModule(pluginName + "!" + moduleName,
                               "define(function () { return '" +
                                   content +
                               "';});\n");
            }
        },

        writeFile: function (pluginName, moduleName, req, write, config) {
            var parsed = text.parseName(moduleName),
                extPart = parsed.ext ? '.' + parsed.ext : '',
                nonStripName = parsed.moduleName + extPart,
                //Use a '.js' file name so that it indicates it is a
                //script that can be loaded across domains.
                fileName = req.toUrl(parsed.moduleName + extPart) + '.js';

            //Leverage own load() method to load plugin value, but only
            //write out values that do not have the strip argument,
            //to avoid any potential issues with ! in file names.
            text.load(nonStripName, req, function (value) {
                //Use own write() method to construct full module value.
                //But need to create shell that translates writeFile's
                //write() to the right interface.
                var textWrite = function (contents) {
                    return write(fileName, contents);
                };
                textWrite.asModule = function (moduleName, contents) {
                    return write.asModule(moduleName, fileName, contents);
                };

                text.write(pluginName, nonStripName, textWrite, config);
            }, config);
        }
    };

    if (masterConfig.env === 'node' || (!masterConfig.env &&
            typeof process !== "undefined" &&
            process.versions &&
            !!process.versions.node &&
            !process.versions['node-webkit'] &&
            !process.versions['atom-shell'])) {
        //Using special require.nodeRequire, something added by r.js.
        fs = require.nodeRequire('fs');

        text.get = function (url, callback, errback) {
            try {
                var file = fs.readFileSync(url, 'utf8');
                //Remove BOM (Byte Mark Order) from utf8 files if it is there.
                if (file[0] === '\uFEFF') {
                    file = file.substring(1);
                }
                callback(file);
            } catch (e) {
                if (errback) {
                    errback(e);
                }
            }
        };
    } else if (masterConfig.env === 'xhr' || (!masterConfig.env &&
            text.createXhr())) {
        text.get = function (url, callback, errback, headers) {
            var xhr = text.createXhr(), header;
            xhr.open('GET', url, true);

            //Allow plugins direct access to xhr headers
            if (headers) {
                for (header in headers) {
                    if (headers.hasOwnProperty(header)) {
                        xhr.setRequestHeader(header.toLowerCase(), headers[header]);
                    }
                }
            }

            //Allow overrides specified in config
            if (masterConfig.onXhr) {
                masterConfig.onXhr(xhr, url);
            }

            xhr.onreadystatechange = function (evt) {
                var status, err;
                //Do not explicitly handle errors, those should be
                //visible via console output in the browser.
                if (xhr.readyState === 4) {
                    status = xhr.status || 0;
                    if (status > 399 && status < 600) {
                        //An http 4xx or 5xx error. Signal an error.
                        err = new Error(url + ' HTTP status: ' + status);
                        err.xhr = xhr;
                        if (errback) {
                            errback(err);
                        }
                    } else {
                        callback(xhr.responseText);
                    }

                    if (masterConfig.onXhrComplete) {
                        masterConfig.onXhrComplete(xhr, url);
                    }
                }
            };
            xhr.send(null);
        };
    } else if (masterConfig.env === 'rhino' || (!masterConfig.env &&
            typeof Packages !== 'undefined' && typeof java !== 'undefined')) {
        //Why Java, why is this so awkward?
        text.get = function (url, callback) {
            var stringBuffer, line,
                encoding = "utf-8",
                file = new java.io.File(url),
                lineSeparator = java.lang.System.getProperty("line.separator"),
                input = new java.io.BufferedReader(new java.io.InputStreamReader(new java.io.FileInputStream(file), encoding)),
                content = '';
            try {
                stringBuffer = new java.lang.StringBuffer();
                line = input.readLine();

                // Byte Order Mark (BOM) - The Unicode Standard, version 3.0, page 324
                // http://www.unicode.org/faq/utf_bom.html

                // Note that when we use utf-8, the BOM should appear as "EF BB BF", but it doesn't due to this bug in the JDK:
                // http://bugs.sun.com/bugdatabase/view_bug.do?bug_id=4508058
                if (line && line.length() && line.charAt(0) === 0xfeff) {
                    // Eat the BOM, since we've already found the encoding on this file,
                    // and we plan to concatenating this buffer with others; the BOM should
                    // only appear at the top of a file.
                    line = line.substring(1);
                }

                if (line !== null) {
                    stringBuffer.append(line);
                }

                while ((line = input.readLine()) !== null) {
                    stringBuffer.append(lineSeparator);
                    stringBuffer.append(line);
                }
                //Make sure we return a JavaScript string and not a Java string.
                content = String(stringBuffer.toString()); //String
            } finally {
                input.close();
            }
            callback(content);
        };
    } else if (masterConfig.env === 'xpconnect' || (!masterConfig.env &&
            typeof Components !== 'undefined' && Components.classes &&
            Components.interfaces)) {
        //Avert your gaze!
        Cc = Components.classes;
        Ci = Components.interfaces;
        Components.utils['import']('resource://gre/modules/FileUtils.jsm');
        xpcIsWindows = ('@mozilla.org/windows-registry-key;1' in Cc);

        text.get = function (url, callback) {
            var inStream, convertStream, fileObj,
                readData = {};

            if (xpcIsWindows) {
                url = url.replace(/\//g, '\\');
            }

            fileObj = new FileUtils.File(url);

            //XPCOM, you so crazy
            try {
                inStream = Cc['@mozilla.org/network/file-input-stream;1']
                           .createInstance(Ci.nsIFileInputStream);
                inStream.init(fileObj, 1, 0, false);

                convertStream = Cc['@mozilla.org/intl/converter-input-stream;1']
                                .createInstance(Ci.nsIConverterInputStream);
                convertStream.init(inStream, "utf-8", inStream.available(),
                Ci.nsIConverterInputStream.DEFAULT_REPLACEMENT_CHARACTER);

                convertStream.readString(inStream.available(), readData);
                convertStream.close();
                inStream.close();
                callback(readData.value);
            } catch (e) {
                throw new Error((fileObj && fileObj.path || '') + ': ' + e);
            }
        };
    }
    return text;
});
/*! @vimeo/player v2.16.4 | (c) 2022 Vimeo | MIT License | https://github.com/vimeo/player.js */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('vimeo',factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global.Vimeo = global.Vimeo || {}, global.Vimeo.Player = factory()));
}(this, (function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  /**
   * @module lib/functions
   */

  /**
   * Check to see this is a node environment.
   * @type {Boolean}
   */

  /* global global */
  var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
  /**
   * Get the name of the method for a given getter or setter.
   *
   * @param {string} prop The name of the property.
   * @param {string} type Either “get” or “set”.
   * @return {string}
   */

  function getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) {
      return prop;
    }

    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
  }
  /**
   * Check to see if the object is a DOM Element.
   *
   * @param {*} element The object to check.
   * @return {boolean}
   */

  function isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
  }
  /**
   * Check to see whether the value is a number.
   *
   * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
   * @param {*} value The value to check.
   * @param {boolean} integer Check if the value is an integer.
   * @return {boolean}
   */

  function isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
  }
  /**
   * Check to see if the URL is a Vimeo url.
   *
   * @param {string} url The url string.
   * @return {boolean}
   */

  function isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
  }
  /**
   * Get the Vimeo URL from an element.
   * The element must have either a data-vimeo-id or data-vimeo-url attribute.
   *
   * @param {object} oEmbedParameters The oEmbed parameters.
   * @return {string}
   */

  function getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;

    if (!idOrUrl) {
      throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
    }

    if (isInteger(idOrUrl)) {
      return "https://vimeo.com/".concat(idOrUrl);
    }

    if (isVimeoUrl(idOrUrl)) {
      return idOrUrl.replace('http:', 'https:');
    }

    if (id) {
      throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    }

    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
  }

  var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
  var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';

  if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
    throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /*!
   * weakmap-polyfill v2.0.1 - ECMAScript6 WeakMap polyfill
   * https://github.com/polygonplanet/weakmap-polyfill
   * Copyright (c) 2015-2020 Polygon Planet <polygon.planet.aqua@gmail.com>
   * @license MIT
   */
  (function (self) {

    if (self.WeakMap) {
      return;
    }

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    var defineProperty = function (object, name, value) {
      if (Object.defineProperty) {
        Object.defineProperty(object, name, {
          configurable: true,
          writable: true,
          value: value
        });
      } else {
        object[name] = value;
      }
    };

    self.WeakMap = function () {
      // ECMA-262 23.3 WeakMap Objects
      function WeakMap() {
        if (this === void 0) {
          throw new TypeError("Constructor WeakMap requires 'new'");
        }

        defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])

        if (arguments.length > 0) {
          // Currently, WeakMap `iterable` argument is not supported
          throw new TypeError('WeakMap iterable is not supported');
        }
      } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)


      defineProperty(WeakMap.prototype, 'delete', function (key) {
        checkInstance(this, 'delete');

        if (!isObject(key)) {
          return false;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          delete key[this._id];
          return true;
        }

        return false;
      }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)

      defineProperty(WeakMap.prototype, 'get', function (key) {
        checkInstance(this, 'get');

        if (!isObject(key)) {
          return void 0;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          return entry[1];
        }

        return void 0;
      }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)

      defineProperty(WeakMap.prototype, 'has', function (key) {
        checkInstance(this, 'has');

        if (!isObject(key)) {
          return false;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          return true;
        }

        return false;
      }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)

      defineProperty(WeakMap.prototype, 'set', function (key, value) {
        checkInstance(this, 'set');

        if (!isObject(key)) {
          throw new TypeError('Invalid value used as weak map key');
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          entry[1] = value;
          return this;
        }

        defineProperty(key, this._id, [key, value]);
        return this;
      });

      function checkInstance(x, methodName) {
        if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
          throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
      }

      function genId(prefix) {
        return prefix + '_' + rand() + '.' + rand();
      }

      function rand() {
        return Math.random().toString().substring(2);
      }

      defineProperty(WeakMap, '_polyfill', true);
      return WeakMap;
    }();

    function isObject(x) {
      return Object(x) === x;
    }
  })(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

  var npo_src = createCommonjsModule(function (module) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function UMD(name, context, definition) {
    // special form of UMD for polyfilling across evironments
    context[name] = context[name] || definition();

    if (module.exports) {
      module.exports = context[name];
    }
  })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

    var builtInProp,
        cycle,
        scheduling_queue,
        ToString = Object.prototype.toString,
        timer = typeof setImmediate != "undefined" ? function timer(fn) {
      return setImmediate(fn);
    } : setTimeout; // dammit, IE8.

    try {
      Object.defineProperty({}, "x", {});

      builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
          value: val,
          writable: true,
          configurable: config !== false
        });
      };
    } catch (err) {
      builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
      };
    } // Note: using a queue instead of array for efficiency


    scheduling_queue = function Queue() {
      var first, last, item;

      function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
      }

      return {
        add: function add(fn, self) {
          item = new Item(fn, self);

          if (last) {
            last.next = item;
          } else {
            first = item;
          }

          last = item;
          item = void 0;
        },
        drain: function drain() {
          var f = first;
          first = last = cycle = void 0;

          while (f) {
            f.fn.call(f.self);
            f = f.next;
          }
        }
      };
    }();

    function schedule(fn, self) {
      scheduling_queue.add(fn, self);

      if (!cycle) {
        cycle = timer(scheduling_queue.drain);
      }
    } // promise duck typing


    function isThenable(o) {
      var _then,
          o_type = typeof o;

      if (o != null && (o_type == "object" || o_type == "function")) {
        _then = o.then;
      }

      return typeof _then == "function" ? _then : false;
    }

    function notify() {
      for (var i = 0; i < this.chain.length; i++) {
        notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
      }

      this.chain.length = 0;
    } // NOTE: This is a separate function to isolate
    // the `try..catch` so that other code can be
    // optimized better


    function notifyIsolated(self, cb, chain) {
      var ret, _then;

      try {
        if (cb === false) {
          chain.reject(self.msg);
        } else {
          if (cb === true) {
            ret = self.msg;
          } else {
            ret = cb.call(void 0, self.msg);
          }

          if (ret === chain.promise) {
            chain.reject(TypeError("Promise-chain cycle"));
          } else if (_then = isThenable(ret)) {
            _then.call(ret, chain.resolve, chain.reject);
          } else {
            chain.resolve(ret);
          }
        }
      } catch (err) {
        chain.reject(err);
      }
    }

    function resolve(msg) {
      var _then,
          self = this; // already triggered?


      if (self.triggered) {
        return;
      }

      self.triggered = true; // unwrap

      if (self.def) {
        self = self.def;
      }

      try {
        if (_then = isThenable(msg)) {
          schedule(function () {
            var def_wrapper = new MakeDefWrapper(self);

            try {
              _then.call(msg, function $resolve$() {
                resolve.apply(def_wrapper, arguments);
              }, function $reject$() {
                reject.apply(def_wrapper, arguments);
              });
            } catch (err) {
              reject.call(def_wrapper, err);
            }
          });
        } else {
          self.msg = msg;
          self.state = 1;

          if (self.chain.length > 0) {
            schedule(notify, self);
          }
        }
      } catch (err) {
        reject.call(new MakeDefWrapper(self), err);
      }
    }

    function reject(msg) {
      var self = this; // already triggered?

      if (self.triggered) {
        return;
      }

      self.triggered = true; // unwrap

      if (self.def) {
        self = self.def;
      }

      self.msg = msg;
      self.state = 2;

      if (self.chain.length > 0) {
        schedule(notify, self);
      }
    }

    function iteratePromises(Constructor, arr, resolver, rejecter) {
      for (var idx = 0; idx < arr.length; idx++) {
        (function IIFE(idx) {
          Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
          }, rejecter);
        })(idx);
      }
    }

    function MakeDefWrapper(self) {
      this.def = self;
      this.triggered = false;
    }

    function MakeDef(self) {
      this.promise = self;
      this.state = 0;
      this.triggered = false;
      this.chain = [];
      this.msg = void 0;
    }

    function Promise(executor) {
      if (typeof executor != "function") {
        throw TypeError("Not a function");
      }

      if (this.__NPO__ !== 0) {
        throw TypeError("Not a promise");
      } // instance shadowing the inherited "brand"
      // to signal an already "initialized" promise


      this.__NPO__ = 1;
      var def = new MakeDef(this);

      this["then"] = function then(success, failure) {
        var o = {
          success: typeof success == "function" ? success : true,
          failure: typeof failure == "function" ? failure : false
        }; // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.

        o.promise = new this.constructor(function extractChain(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }

          o.resolve = resolve;
          o.reject = reject;
        });
        def.chain.push(o);

        if (def.state !== 0) {
          schedule(notify, def);
        }

        return o.promise;
      };

      this["catch"] = function $catch$(failure) {
        return this.then(void 0, failure);
      };

      try {
        executor.call(void 0, function publicResolve(msg) {
          resolve.call(def, msg);
        }, function publicReject(msg) {
          reject.call(def, msg);
        });
      } catch (err) {
        reject.call(def, err);
      }
    }

    var PromisePrototype = builtInProp({}, "constructor", Promise,
    /*configurable=*/
    false); // Note: Android 4 cannot use `Object.defineProperty(..)` here

    Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise

    builtInProp(PromisePrototype, "__NPO__", 0,
    /*configurable=*/
    false);
    builtInProp(Promise, "resolve", function Promise$resolve(msg) {
      var Constructor = this; // spec mandated checks
      // note: best "isPromise" check that's practical for now

      if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
        return msg;
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        resolve(msg);
      });
    });
    builtInProp(Promise, "reject", function Promise$reject(msg) {
      return new this(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        reject(msg);
      });
    });
    builtInProp(Promise, "all", function Promise$all(arr) {
      var Constructor = this; // spec mandated checks

      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }

      if (arr.length === 0) {
        return Constructor.resolve([]);
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        var len = arr.length,
            msgs = Array(len),
            count = 0;
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          msgs[idx] = msg;

          if (++count === len) {
            resolve(msgs);
          }
        }, reject);
      });
    });
    builtInProp(Promise, "race", function Promise$race(arr) {
      var Constructor = this; // spec mandated checks

      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          resolve(msg);
        }, reject);
      });
    });
    return Promise;
  });
  });

  /**
   * @module lib/callbacks
   */
  var callbackMap = new WeakMap();
  /**
   * Store a callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
   *        The callback to call or an object with resolve and reject functions for a promise.
   * @return {void}
   */

  function storeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};

    if (!(name in playerCallbacks)) {
      playerCallbacks[name] = [];
    }

    playerCallbacks[name].push(callback);
    callbackMap.set(player.element, playerCallbacks);
  }
  /**
   * Get the callbacks for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @return {function[]}
   */

  function getCallbacks(player, name) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
  }
  /**
   * Remove a stored callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @param {function} [callback] The specific callback to remove.
   * @return {boolean} Was this the last callback?
   */

  function removeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};

    if (!playerCallbacks[name]) {
      return true;
    } // If no callback is passed, remove all callbacks for the event


    if (!callback) {
      playerCallbacks[name] = [];
      callbackMap.set(player.element, playerCallbacks);
      return true;
    }

    var index = playerCallbacks[name].indexOf(callback);

    if (index !== -1) {
      playerCallbacks[name].splice(index, 1);
    }

    callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
  }
  /**
   * Return the first stored callback for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @return {function} The callback, or false if there were none
   */

  function shiftCallbacks(player, name) {
    var playerCallbacks = getCallbacks(player, name);

    if (playerCallbacks.length < 1) {
      return false;
    }

    var callback = playerCallbacks.shift();
    removeCallback(player, name, callback);
    return callback;
  }
  /**
   * Move callbacks associated with an element to another element.
   *
   * @param {HTMLElement} oldElement The old element.
   * @param {HTMLElement} newElement The new element.
   * @return {void}
   */

  function swapCallbacks(oldElement, newElement) {
    var playerCallbacks = callbackMap.get(oldElement);
    callbackMap.set(newElement, playerCallbacks);
    callbackMap.delete(oldElement);
  }

  /**
   * @module lib/embed
   */
  var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'interactive_params', 'keyboard', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
  /**
   * Get the 'data-vimeo'-prefixed attributes from an element as an object.
   *
   * @param {HTMLElement} element The element.
   * @param {Object} [defaults={}] The default values to use.
   * @return {Object<string, string>}
   */

  function getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return oEmbedParameters.reduce(function (params, param) {
      var value = element.getAttribute("data-vimeo-".concat(param));

      if (value || value === '') {
        params[param] = value === '' ? 1 : value;
      }

      return params;
    }, defaults);
  }
  /**
   * Create an embed from oEmbed data inside an element.
   *
   * @param {object} data The oEmbed data.
   * @param {HTMLElement} element The element to put the iframe in.
   * @return {HTMLIFrameElement} The iframe embed.
   */

  function createEmbed(_ref, element) {
    var html = _ref.html;

    if (!element) {
      throw new TypeError('An element must be provided');
    }

    if (element.getAttribute('data-vimeo-initialized') !== null) {
      return element.querySelector('iframe');
    }

    var div = document.createElement('div');
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute('data-vimeo-initialized', 'true');
    return element.querySelector('iframe');
  }
  /**
   * Make an oEmbed call for the specified URL.
   *
   * @param {string} videoUrl The vimeo.com url for the video.
   * @param {Object} [params] Parameters to pass to oEmbed.
   * @param {HTMLElement} element The element.
   * @return {Promise}
   */

  function getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function (resolve, reject) {
      if (!isVimeoUrl(videoUrl)) {
        throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
      }

      var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));

      for (var param in params) {
        if (params.hasOwnProperty(param)) {
          url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        }
      }

      var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
      xhr.open('GET', url, true);

      xhr.onload = function () {
        if (xhr.status === 404) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
          return;
        }

        if (xhr.status === 403) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }

        try {
          var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed

          if (json.domain_status_code === 403) {
            // We still want to create the embed to give users visual feedback
            createEmbed(json, element);
            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
            return;
          }

          resolve(json);
        } catch (error) {
          reject(error);
        }
      };

      xhr.onerror = function () {
        var status = xhr.status ? " (".concat(xhr.status, ")") : '';
        reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
      };

      xhr.send();
    });
  }
  /**
   * Initialize all embeds within a specific element
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */

  function initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));

    var handleError = function handleError(error) {
      if ('console' in window && console.error) {
        console.error("There was an error creating an embed: ".concat(error));
      }
    };

    elements.forEach(function (element) {
      try {
        // Skip any that have data-vimeo-defer
        if (element.getAttribute('data-vimeo-defer') !== null) {
          return;
        }

        var params = getOEmbedParameters(element);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          return createEmbed(data, element);
        }).catch(handleError);
      } catch (error) {
        handleError(error);
      }
    });
  }
  /**
   * Resize embeds when messaged by the player.
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */

  function resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) {
      return;
    }

    window.VimeoPlayerResizeEmbeds_ = true;

    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      } // 'spacechange' is fired only on embeds with cards


      if (!event.data || event.data.event !== 'spacechange') {
        return;
      }

      var iframes = parent.querySelectorAll('iframe');

      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow !== event.source) {
          continue;
        } // Change padding-bottom of the enclosing div to accommodate
        // card carousel without distorting aspect ratio


        var space = iframes[i].parentElement;
        space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
        break;
      }
    };

    window.addEventListener('message', onMessage);
  }

  /**
   * @module lib/postmessage
   */
  /**
   * Parse a message received from postMessage.
   *
   * @param {*} data The data received from postMessage.
   * @return {object}
   */

  function parseMessageData(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
      }
    }

    return data;
  }
  /**
   * Post a message to the specified target.
   *
   * @param {Player} player The player object to use.
   * @param {string} method The API method to call.
   * @param {object} params The parameters to send to the player.
   * @return {void}
   */

  function postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
      return;
    }

    var message = {
      method: method
    };

    if (params !== undefined) {
      message.value = params;
    } // IE 8 and 9 do not support passing messages, so stringify them


    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));

    if (ieVersion >= 8 && ieVersion < 10) {
      message = JSON.stringify(message);
    }

    player.element.contentWindow.postMessage(message, player.origin);
  }
  /**
   * Parse the data received from a message event.
   *
   * @param {Player} player The player that received the message.
   * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
   * @return {void}
   */

  function processData(player, data) {
    data = parseMessageData(data);
    var callbacks = [];
    var param;

    if (data.event) {
      if (data.event === 'error') {
        var promises = getCallbacks(player, data.data.method);
        promises.forEach(function (promise) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          promise.reject(error);
          removeCallback(player, data.data.method, promise);
        });
      }

      callbacks = getCallbacks(player, "event:".concat(data.event));
      param = data.data;
    } else if (data.method) {
      var callback = shiftCallbacks(player, data.method);

      if (callback) {
        callbacks.push(callback);
        param = data.value;
      }
    }

    callbacks.forEach(function (callback) {
      try {
        if (typeof callback === 'function') {
          callback.call(player, param);
          return;
        }

        callback.resolve(param);
      } catch (e) {// empty
      }
    });
  }

  /* MIT License

  Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  Terms */
  function initializeScreenfull() {
    var fn = function () {
      var val;
      var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
      ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit
      ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
      var i = 0;
      var l = fnMap.length;
      var ret = {};

      for (; i < l; i++) {
        val = fnMap[i];

        if (val && val[1] in document) {
          for (i = 0; i < val.length; i++) {
            ret[fnMap[0][i]] = val[i];
          }

          return ret;
        }
      }

      return false;
    }();

    var eventNameMap = {
      fullscreenchange: fn.fullscreenchange,
      fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
      request: function request(element) {
        return new Promise(function (resolve, reject) {
          var onFullScreenEntered = function onFullScreenEntered() {
            screenfull.off('fullscreenchange', onFullScreenEntered);
            resolve();
          };

          screenfull.on('fullscreenchange', onFullScreenEntered);
          element = element || document.documentElement;
          var returnPromise = element[fn.requestFullscreen]();

          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenEntered).catch(reject);
          }
        });
      },
      exit: function exit() {
        return new Promise(function (resolve, reject) {
          if (!screenfull.isFullscreen) {
            resolve();
            return;
          }

          var onFullScreenExit = function onFullScreenExit() {
            screenfull.off('fullscreenchange', onFullScreenExit);
            resolve();
          };

          screenfull.on('fullscreenchange', onFullScreenExit);
          var returnPromise = document[fn.exitFullscreen]();

          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenExit).catch(reject);
          }
        });
      },
      on: function on(event, callback) {
        var eventName = eventNameMap[event];

        if (eventName) {
          document.addEventListener(eventName, callback);
        }
      },
      off: function off(event, callback) {
        var eventName = eventNameMap[event];

        if (eventName) {
          document.removeEventListener(eventName, callback);
        }
      }
    };
    Object.defineProperties(screenfull, {
      isFullscreen: {
        get: function get() {
          return Boolean(document[fn.fullscreenElement]);
        }
      },
      element: {
        enumerable: true,
        get: function get() {
          return document[fn.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: true,
        get: function get() {
          // Coerce to boolean in case of old WebKit
          return Boolean(document[fn.fullscreenEnabled]);
        }
      }
    });
    return screenfull;
  }

  var playerMap = new WeakMap();
  var readyMap = new WeakMap();
  var screenfull = {};

  var Player = /*#__PURE__*/function () {
    /**
     * Create a Player.
     *
     * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
     *        player iframe, and id, or a jQuery object.
     * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
     * @return {Player}
     */
    function Player(element) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Player);

      /* global jQuery */
      if (window.jQuery && element instanceof jQuery) {
        if (element.length > 1 && window.console && console.warn) {
          console.warn('A jQuery object with multiple elements was passed, using the first element.');
        }

        element = element[0];
      } // Find an element by ID


      if (typeof document !== 'undefined' && typeof element === 'string') {
        element = document.getElementById(element);
      } // Not an element!


      if (!isDomElement(element)) {
        throw new TypeError('You must pass either a valid element or a valid id.');
      } // Already initialized an embed in this div, so grab the iframe


      if (element.nodeName !== 'IFRAME') {
        var iframe = element.querySelector('iframe');

        if (iframe) {
          element = iframe;
        }
      } // iframe url is not a Vimeo url


      if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
        throw new Error('The player element passed isn’t a Vimeo embed.');
      } // If there is already a player object in the map, return that


      if (playerMap.has(element)) {
        return playerMap.get(element);
      }

      this._window = element.ownerDocument.defaultView;
      this.element = element;
      this.origin = '*';
      var readyPromise = new npo_src(function (resolve, reject) {
        _this._onMessage = function (event) {
          if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
            return;
          }

          if (_this.origin === '*') {
            _this.origin = event.origin;
          }

          var data = parseMessageData(event.data);
          var isError = data && data.event === 'error';
          var isReadyError = isError && data.data && data.data.method === 'ready';

          if (isReadyError) {
            var error = new Error(data.data.message);
            error.name = data.data.name;
            reject(error);
            return;
          }

          var isReadyEvent = data && data.event === 'ready';
          var isPingResponse = data && data.method === 'ping';

          if (isReadyEvent || isPingResponse) {
            _this.element.setAttribute('data-ready', 'true');

            resolve();
            return;
          }

          processData(_this, data);
        };

        _this._window.addEventListener('message', _this._onMessage);

        if (_this.element.nodeName !== 'IFRAME') {
          var params = getOEmbedParameters(element, options);
          var url = getVimeoUrl(params);
          getOEmbedData(url, params, element).then(function (data) {
            var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
            // but store reference to the original element

            _this.element = iframe;
            _this._originalElement = element;
            swapCallbacks(element, iframe);
            playerMap.set(_this.element, _this);
            return data;
          }).catch(reject);
        }
      }); // Store a copy of this Player in the map

      readyMap.set(this, readyPromise);
      playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
      // the player is already ready.

      if (this.element.nodeName === 'IFRAME') {
        postMessage(this, 'ping');
      }

      if (screenfull.isEnabled) {
        var exitFullscreen = function exitFullscreen() {
          return screenfull.exit();
        };

        this.fullscreenchangeHandler = function () {
          if (screenfull.isFullscreen) {
            storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          } else {
            removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          } // eslint-disable-next-line


          _this.ready().then(function () {
            postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
          });
        };

        screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
      }

      return this;
    }
    /**
     * Get a promise for a method.
     *
     * @param {string} name The API method to call.
     * @param {Object} [args={}] Arguments to send via postMessage.
     * @return {Promise}
     */


    _createClass(Player, [{
      key: "callMethod",
      value: function callMethod(name) {
        var _this2 = this;

        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new npo_src(function (resolve, reject) {
          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this2.ready().then(function () {
            storeCallback(_this2, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this2, name, args);
          }).catch(reject);
        });
      }
      /**
       * Get a promise for the value of a player property.
       *
       * @param {string} name The property name
       * @return {Promise}
       */

    }, {
      key: "get",
      value: function get(name) {
        var _this3 = this;

        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return

          return _this3.ready().then(function () {
            storeCallback(_this3, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this3, name);
          }).catch(reject);
        });
      }
      /**
       * Get a promise for setting the value of a player property.
       *
       * @param {string} name The API method to call.
       * @param {mixed} value The value to set.
       * @return {Promise}
       */

    }, {
      key: "set",
      value: function set(name, value) {
        var _this4 = this;

        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'set');

          if (value === undefined || value === null) {
            throw new TypeError('There must be a value to set.');
          } // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return


          return _this4.ready().then(function () {
            storeCallback(_this4, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this4, name, value);
          }).catch(reject);
        });
      }
      /**
       * Add an event listener for the specified event. Will call the
       * callback with a single parameter, `data`, that contains the data for
       * that event.
       *
       * @param {string} eventName The name of the event.
       * @param {function(*)} callback The function to call when the event fires.
       * @return {void}
       */

    }, {
      key: "on",
      value: function on(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }

        if (!callback) {
          throw new TypeError('You must pass a callback function.');
        }

        if (typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }

        var callbacks = getCallbacks(this, "event:".concat(eventName));

        if (callbacks.length === 0) {
          this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }

        storeCallback(this, "event:".concat(eventName), callback);
      }
      /**
       * Remove an event listener for the specified event. Will remove all
       * listeners for that event if a `callback` isn’t passed, or only that
       * specific callback if it is passed.
       *
       * @param {string} eventName The name of the event.
       * @param {function} [callback] The specific callback to remove.
       * @return {void}
       */

    }, {
      key: "off",
      value: function off(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }

        if (callback && typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }

        var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener

        if (lastCallback) {
          this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }
      }
      /**
       * A promise to load a new video.
       *
       * @promise LoadVideoPromise
       * @fulfill {number} The video with this id or url successfully loaded.
       * @reject {TypeError} The id was not a number.
       */

      /**
       * Load a new video into this embed. The promise will be resolved if
       * the video is successfully loaded, or it will be rejected if it could
       * not be loaded.
       *
       * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
       * @return {LoadVideoPromise}
       */

    }, {
      key: "loadVideo",
      value: function loadVideo(options) {
        return this.callMethod('loadVideo', options);
      }
      /**
       * A promise to perform an action when the Player is ready.
       *
       * @todo document errors
       * @promise LoadVideoPromise
       * @fulfill {void}
       */

      /**
       * Trigger a function when the player iframe has initialized. You do not
       * need to wait for `ready` to trigger to begin adding event listeners
       * or calling other methods.
       *
       * @return {ReadyPromise}
       */

    }, {
      key: "ready",
      value: function ready() {
        var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
          reject(new Error('Unknown player. Probably unloaded.'));
        });
        return npo_src.resolve(readyPromise);
      }
      /**
       * A promise to add a cue point to the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point to use for removeCuePoint.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Add a cue point to the player.
       *
       * @param {number} time The time for the cue point.
       * @param {object} [data] Arbitrary data to be returned with the cue point.
       * @return {AddCuePointPromise}
       */

    }, {
      key: "addCuePoint",
      value: function addCuePoint(time) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.callMethod('addCuePoint', {
          time: time,
          data: data
        });
      }
      /**
       * A promise to remove a cue point from the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point that was removed.
       * @reject {InvalidCuePoint} The cue point with the specified id was not
       *         found.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Remove a cue point from the video.
       *
       * @param {string} id The id of the cue point to remove.
       * @return {RemoveCuePointPromise}
       */

    }, {
      key: "removeCuePoint",
      value: function removeCuePoint(id) {
        return this.callMethod('removeCuePoint', id);
      }
      /**
       * A representation of a text track on a video.
       *
       * @typedef {Object} VimeoTextTrack
       * @property {string} language The ISO language code.
       * @property {string} kind The kind of track it is (captions or subtitles).
       * @property {string} label The human‐readable label for the track.
       */

      /**
       * A promise to enable a text track.
       *
       * @promise EnableTextTrackPromise
       * @fulfill {VimeoTextTrack} The text track that was enabled.
       * @reject {InvalidTrackLanguageError} No track was available with the
       *         specified language.
       * @reject {InvalidTrackError} No track was available with the specified
       *         language and kind.
       */

      /**
       * Enable the text track with the specified language, and optionally the
       * specified kind (captions or subtitles).
       *
       * When set via the API, the track language will not change the viewer’s
       * stored preference.
       *
       * @param {string} language The two‐letter language code.
       * @param {string} [kind] The kind of track to enable (captions or subtitles).
       * @return {EnableTextTrackPromise}
       */

    }, {
      key: "enableTextTrack",
      value: function enableTextTrack(language, kind) {
        if (!language) {
          throw new TypeError('You must pass a language.');
        }

        return this.callMethod('enableTextTrack', {
          language: language,
          kind: kind
        });
      }
      /**
       * A promise to disable the active text track.
       *
       * @promise DisableTextTrackPromise
       * @fulfill {void} The track was disabled.
       */

      /**
       * Disable the currently-active text track.
       *
       * @return {DisableTextTrackPromise}
       */

    }, {
      key: "disableTextTrack",
      value: function disableTextTrack() {
        return this.callMethod('disableTextTrack');
      }
      /**
       * A promise to pause the video.
       *
       * @promise PausePromise
       * @fulfill {void} The video was paused.
       */

      /**
       * Pause the video if it’s playing.
       *
       * @return {PausePromise}
       */

    }, {
      key: "pause",
      value: function pause() {
        return this.callMethod('pause');
      }
      /**
       * A promise to play the video.
       *
       * @promise PlayPromise
       * @fulfill {void} The video was played.
       */

      /**
       * Play the video if it’s paused. **Note:** on iOS and some other
       * mobile devices, you cannot programmatically trigger play. Once the
       * viewer has tapped on the play button in the player, however, you
       * will be able to use this function.
       *
       * @return {PlayPromise}
       */

    }, {
      key: "play",
      value: function play() {
        return this.callMethod('play');
      }
      /**
       * Request that the player enters fullscreen.
       * @return {Promise}
       */

    }, {
      key: "requestFullscreen",
      value: function requestFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.request(this.element);
        }

        return this.callMethod('requestFullscreen');
      }
      /**
       * Request that the player exits fullscreen.
       * @return {Promise}
       */

    }, {
      key: "exitFullscreen",
      value: function exitFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.exit();
        }

        return this.callMethod('exitFullscreen');
      }
      /**
       * Returns true if the player is currently fullscreen.
       * @return {Promise}
       */

    }, {
      key: "getFullscreen",
      value: function getFullscreen() {
        if (screenfull.isEnabled) {
          return npo_src.resolve(screenfull.isFullscreen);
        }

        return this.get('fullscreen');
      }
      /**
       * Request that the player enters picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "requestPictureInPicture",
      value: function requestPictureInPicture() {
        return this.callMethod('requestPictureInPicture');
      }
      /**
       * Request that the player exits picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "exitPictureInPicture",
      value: function exitPictureInPicture() {
        return this.callMethod('exitPictureInPicture');
      }
      /**
       * Returns true if the player is currently picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "getPictureInPicture",
      value: function getPictureInPicture() {
        return this.get('pictureInPicture');
      }
      /**
       * A promise to unload the video.
       *
       * @promise UnloadPromise
       * @fulfill {void} The video was unloaded.
       */

      /**
       * Return the player to its initial state.
       *
       * @return {UnloadPromise}
       */

    }, {
      key: "unload",
      value: function unload() {
        return this.callMethod('unload');
      }
      /**
       * Cleanup the player and remove it from the DOM
       *
       * It won't be usable and a new one should be constructed
       *  in order to do any operations.
       *
       * @return {Promise}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        var _this5 = this;

        return new npo_src(function (resolve) {
          readyMap.delete(_this5);
          playerMap.delete(_this5.element);

          if (_this5._originalElement) {
            playerMap.delete(_this5._originalElement);

            _this5._originalElement.removeAttribute('data-vimeo-initialized');
          }

          if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
              _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
            } else {
              _this5.element.parentNode.removeChild(_this5.element);
            }
          } // If the clip is private there is a case where the element stays the
          // div element. Destroy should reset the div and remove the iframe child.


          if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
            _this5.element.removeAttribute('data-vimeo-initialized');

            var iframe = _this5.element.querySelector('iframe');

            if (iframe && iframe.parentNode) {
              // If we've added an additional wrapper div, remove that from the DOM.
              // If not, just remove the iframe element.
              if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
                iframe.parentNode.parentNode.removeChild(iframe.parentNode);
              } else {
                iframe.parentNode.removeChild(iframe);
              }
            }
          }

          _this5._window.removeEventListener('message', _this5._onMessage);

          if (screenfull.isEnabled) {
            screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
          }

          resolve();
        });
      }
      /**
       * A promise to get the autopause behavior of the video.
       *
       * @promise GetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */

      /**
       * Get the autopause behavior for this player.
       *
       * @return {GetAutopausePromise}
       */

    }, {
      key: "getAutopause",
      value: function getAutopause() {
        return this.get('autopause');
      }
      /**
       * A promise to set the autopause behavior of the video.
       *
       * @promise SetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */

      /**
       * Enable or disable the autopause behavior of this player.
       *
       * By default, when another video is played in the same browser, this
       * player will automatically pause. Unless you have a specific reason
       * for doing so, we recommend that you leave autopause set to the
       * default (`true`).
       *
       * @param {boolean} autopause
       * @return {SetAutopausePromise}
       */

    }, {
      key: "setAutopause",
      value: function setAutopause(autopause) {
        return this.set('autopause', autopause);
      }
      /**
       * A promise to get the buffered property of the video.
       *
       * @promise GetBufferedPromise
       * @fulfill {Array} Buffered Timeranges converted to an Array.
       */

      /**
       * Get the buffered property of the video.
       *
       * @return {GetBufferedPromise}
       */

    }, {
      key: "getBuffered",
      value: function getBuffered() {
        return this.get('buffered');
      }
      /**
       * @typedef {Object} CameraProperties
       * @prop {number} props.yaw - Number between 0 and 360.
       * @prop {number} props.pitch - Number between -90 and 90.
       * @prop {number} props.roll - Number between -180 and 180.
       * @prop {number} props.fov - The field of view in degrees.
       */

      /**
       * A promise to get the camera properties of the player.
       *
       * @promise GetCameraPromise
       * @fulfill {CameraProperties} The camera properties.
       */

      /**
       * For 360° videos get the camera properties for this player.
       *
       * @return {GetCameraPromise}
       */

    }, {
      key: "getCameraProps",
      value: function getCameraProps() {
        return this.get('cameraProps');
      }
      /**
       * A promise to set the camera properties of the player.
       *
       * @promise SetCameraPromise
       * @fulfill {Object} The camera was successfully set.
       * @reject {RangeError} The range was out of bounds.
       */

      /**
       * For 360° videos set the camera properties for this player.
       *
       * @param {CameraProperties} camera The camera properties
       * @return {SetCameraPromise}
       */

    }, {
      key: "setCameraProps",
      value: function setCameraProps(camera) {
        return this.set('cameraProps', camera);
      }
      /**
       * A representation of a chapter.
       *
       * @typedef {Object} VimeoChapter
       * @property {number} startTime The start time of the chapter.
       * @property {object} title The title of the chapter.
       * @property {number} index The place in the order of Chapters. Starts at 1.
       */

      /**
       * A promise to get chapters for the video.
       *
       * @promise GetChaptersPromise
       * @fulfill {VimeoChapter[]} The chapters for the video.
       */

      /**
       * Get an array of all the chapters for the video.
       *
       * @return {GetChaptersPromise}
       */

    }, {
      key: "getChapters",
      value: function getChapters() {
        return this.get('chapters');
      }
      /**
       * A promise to get the currently active chapter.
       *
       * @promise GetCurrentChaptersPromise
       * @fulfill {VimeoChapter|undefined} The current chapter for the video.
       */

      /**
       * Get the currently active chapter for the video.
       *
       * @return {GetCurrentChaptersPromise}
       */

    }, {
      key: "getCurrentChapter",
      value: function getCurrentChapter() {
        return this.get('currentChapter');
      }
      /**
       * A promise to get the color of the player.
       *
       * @promise GetColorPromise
       * @fulfill {string} The hex color of the player.
       */

      /**
       * Get the color for this player.
       *
       * @return {GetColorPromise}
       */

    }, {
      key: "getColor",
      value: function getColor() {
        return this.get('color');
      }
      /**
       * A promise to set the color of the player.
       *
       * @promise SetColorPromise
       * @fulfill {string} The color was successfully set.
       * @reject {TypeError} The string was not a valid hex or rgb color.
       * @reject {ContrastError} The color was set, but the contrast is
       *         outside of the acceptable range.
       * @reject {EmbedSettingsError} The owner of the player has chosen to
       *         use a specific color.
       */

      /**
       * Set the color of this player to a hex or rgb string. Setting the
       * color may fail if the owner of the video has set their embed
       * preferences to force a specific color.
       *
       * @param {string} color The hex or rgb color string to set.
       * @return {SetColorPromise}
       */

    }, {
      key: "setColor",
      value: function setColor(color) {
        return this.set('color', color);
      }
      /**
       * A representation of a cue point.
       *
       * @typedef {Object} VimeoCuePoint
       * @property {number} time The time of the cue point.
       * @property {object} data The data passed when adding the cue point.
       * @property {string} id The unique id for use with removeCuePoint.
       */

      /**
       * A promise to get the cue points of a video.
       *
       * @promise GetCuePointsPromise
       * @fulfill {VimeoCuePoint[]} The cue points added to the video.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Get an array of the cue points added to the video.
       *
       * @return {GetCuePointsPromise}
       */

    }, {
      key: "getCuePoints",
      value: function getCuePoints() {
        return this.get('cuePoints');
      }
      /**
       * A promise to get the current time of the video.
       *
       * @promise GetCurrentTimePromise
       * @fulfill {number} The current time in seconds.
       */

      /**
       * Get the current playback position in seconds.
       *
       * @return {GetCurrentTimePromise}
       */

    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.get('currentTime');
      }
      /**
       * A promise to set the current time of the video.
       *
       * @promise SetCurrentTimePromise
       * @fulfill {number} The actual current time that was set.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       */

      /**
       * Set the current playback position in seconds. If the player was
       * paused, it will remain paused. Likewise, if the player was playing,
       * it will resume playing once the video has buffered.
       *
       * You can provide an accurate time and the player will attempt to seek
       * to as close to that time as possible. The exact time will be the
       * fulfilled value of the promise.
       *
       * @param {number} currentTime
       * @return {SetCurrentTimePromise}
       */

    }, {
      key: "setCurrentTime",
      value: function setCurrentTime(currentTime) {
        return this.set('currentTime', currentTime);
      }
      /**
       * A promise to get the duration of the video.
       *
       * @promise GetDurationPromise
       * @fulfill {number} The duration in seconds.
       */

      /**
       * Get the duration of the video in seconds. It will be rounded to the
       * nearest second before playback begins, and to the nearest thousandth
       * of a second after playback begins.
       *
       * @return {GetDurationPromise}
       */

    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.get('duration');
      }
      /**
       * A promise to get the ended state of the video.
       *
       * @promise GetEndedPromise
       * @fulfill {boolean} Whether or not the video has ended.
       */

      /**
       * Get the ended state of the video. The video has ended if
       * `currentTime === duration`.
       *
       * @return {GetEndedPromise}
       */

    }, {
      key: "getEnded",
      value: function getEnded() {
        return this.get('ended');
      }
      /**
       * A promise to get the loop state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the player is set to loop.
       */

      /**
       * Get the loop state of the player.
       *
       * @return {GetLoopPromise}
       */

    }, {
      key: "getLoop",
      value: function getLoop() {
        return this.get('loop');
      }
      /**
       * A promise to set the loop state of the player.
       *
       * @promise SetLoopPromise
       * @fulfill {boolean} The loop state that was set.
       */

      /**
       * Set the loop state of the player. When set to `true`, the player
       * will start over immediately once playback ends.
       *
       * @param {boolean} loop
       * @return {SetLoopPromise}
       */

    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        return this.set('loop', loop);
      }
      /**
       * A promise to set the muted state of the player.
       *
       * @promise SetMutedPromise
       * @fulfill {boolean} The muted state that was set.
       */

      /**
       * Set the muted state of the player. When set to `true`, the player
       * volume will be muted.
       *
       * @param {boolean} muted
       * @return {SetMutedPromise}
       */

    }, {
      key: "setMuted",
      value: function setMuted(muted) {
        return this.set('muted', muted);
      }
      /**
       * A promise to get the muted state of the player.
       *
       * @promise GetMutedPromise
       * @fulfill {boolean} Whether or not the player is muted.
       */

      /**
       * Get the muted state of the player.
       *
       * @return {GetMutedPromise}
       */

    }, {
      key: "getMuted",
      value: function getMuted() {
        return this.get('muted');
      }
      /**
       * A promise to get the paused state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the video is paused.
       */

      /**
       * Get the paused state of the player.
       *
       * @return {GetLoopPromise}
       */

    }, {
      key: "getPaused",
      value: function getPaused() {
        return this.get('paused');
      }
      /**
       * A promise to get the playback rate of the player.
       *
       * @promise GetPlaybackRatePromise
       * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
       */

      /**
       * Get the playback rate of the player on a scale from `0.5` to `2`.
       *
       * @return {GetPlaybackRatePromise}
       */

    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        return this.get('playbackRate');
      }
      /**
       * A promise to set the playbackrate of the player.
       *
       * @promise SetPlaybackRatePromise
       * @fulfill {number} The playback rate was set.
       * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
       */

      /**
       * Set the playback rate of the player on a scale from `0.5` to `2`. When set
       * via the API, the playback rate will not be synchronized to other
       * players or stored as the viewer's preference.
       *
       * @param {number} playbackRate
       * @return {SetPlaybackRatePromise}
       */

    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(playbackRate) {
        return this.set('playbackRate', playbackRate);
      }
      /**
       * A promise to get the played property of the video.
       *
       * @promise GetPlayedPromise
       * @fulfill {Array} Played Timeranges converted to an Array.
       */

      /**
       * Get the played property of the video.
       *
       * @return {GetPlayedPromise}
       */

    }, {
      key: "getPlayed",
      value: function getPlayed() {
        return this.get('played');
      }
      /**
       * A promise to get the qualities available of the current video.
       *
       * @promise GetQualitiesPromise
       * @fulfill {Array} The qualities of the video.
       */

      /**
       * Get the qualities of the current video.
       *
       * @return {GetQualitiesPromise}
       */

    }, {
      key: "getQualities",
      value: function getQualities() {
        return this.get('qualities');
      }
      /**
       * A promise to get the current set quality of the video.
       *
       * @promise GetQualityPromise
       * @fulfill {string} The current set quality.
       */

      /**
       * Get the current set quality of the video.
       *
       * @return {GetQualityPromise}
       */

    }, {
      key: "getQuality",
      value: function getQuality() {
        return this.get('quality');
      }
      /**
       * A promise to set the video quality.
       *
       * @promise SetQualityPromise
       * @fulfill {number} The quality was set.
       * @reject {RangeError} The quality is not available.
       */

      /**
       * Set a video quality.
       *
       * @param {string} quality
       * @return {SetQualityPromise}
       */

    }, {
      key: "setQuality",
      value: function setQuality(quality) {
        return this.set('quality', quality);
      }
      /**
       * A promise to get the seekable property of the video.
       *
       * @promise GetSeekablePromise
       * @fulfill {Array} Seekable Timeranges converted to an Array.
       */

      /**
       * Get the seekable property of the video.
       *
       * @return {GetSeekablePromise}
       */

    }, {
      key: "getSeekable",
      value: function getSeekable() {
        return this.get('seekable');
      }
      /**
       * A promise to get the seeking property of the player.
       *
       * @promise GetSeekingPromise
       * @fulfill {boolean} Whether or not the player is currently seeking.
       */

      /**
       * Get if the player is currently seeking.
       *
       * @return {GetSeekingPromise}
       */

    }, {
      key: "getSeeking",
      value: function getSeeking() {
        return this.get('seeking');
      }
      /**
       * A promise to get the text tracks of a video.
       *
       * @promise GetTextTracksPromise
       * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
       */

      /**
       * Get an array of the text tracks that exist for the video.
       *
       * @return {GetTextTracksPromise}
       */

    }, {
      key: "getTextTracks",
      value: function getTextTracks() {
        return this.get('textTracks');
      }
      /**
       * A promise to get the embed code for the video.
       *
       * @promise GetVideoEmbedCodePromise
       * @fulfill {string} The `<iframe>` embed code for the video.
       */

      /**
       * Get the `<iframe>` embed code for the video.
       *
       * @return {GetVideoEmbedCodePromise}
       */

    }, {
      key: "getVideoEmbedCode",
      value: function getVideoEmbedCode() {
        return this.get('videoEmbedCode');
      }
      /**
       * A promise to get the id of the video.
       *
       * @promise GetVideoIdPromise
       * @fulfill {number} The id of the video.
       */

      /**
       * Get the id of the video.
       *
       * @return {GetVideoIdPromise}
       */

    }, {
      key: "getVideoId",
      value: function getVideoId() {
        return this.get('videoId');
      }
      /**
       * A promise to get the title of the video.
       *
       * @promise GetVideoTitlePromise
       * @fulfill {number} The title of the video.
       */

      /**
       * Get the title of the video.
       *
       * @return {GetVideoTitlePromise}
       */

    }, {
      key: "getVideoTitle",
      value: function getVideoTitle() {
        return this.get('videoTitle');
      }
      /**
       * A promise to get the native width of the video.
       *
       * @promise GetVideoWidthPromise
       * @fulfill {number} The native width of the video.
       */

      /**
       * Get the native width of the currently‐playing video. The width of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoWidthPromise}
       */

    }, {
      key: "getVideoWidth",
      value: function getVideoWidth() {
        return this.get('videoWidth');
      }
      /**
       * A promise to get the native height of the video.
       *
       * @promise GetVideoHeightPromise
       * @fulfill {number} The native height of the video.
       */

      /**
       * Get the native height of the currently‐playing video. The height of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoHeightPromise}
       */

    }, {
      key: "getVideoHeight",
      value: function getVideoHeight() {
        return this.get('videoHeight');
      }
      /**
       * A promise to get the vimeo.com url for the video.
       *
       * @promise GetVideoUrlPromise
       * @fulfill {number} The vimeo.com url for the video.
       * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
       */

      /**
       * Get the vimeo.com url for the video.
       *
       * @return {GetVideoUrlPromise}
       */

    }, {
      key: "getVideoUrl",
      value: function getVideoUrl() {
        return this.get('videoUrl');
      }
      /**
       * A promise to get the volume level of the player.
       *
       * @promise GetVolumePromise
       * @fulfill {number} The volume level of the player on a scale from 0 to 1.
       */

      /**
       * Get the current volume level of the player on a scale from `0` to `1`.
       *
       * Most mobile devices do not support an independent volume from the
       * system volume. In those cases, this method will always return `1`.
       *
       * @return {GetVolumePromise}
       */

    }, {
      key: "getVolume",
      value: function getVolume() {
        return this.get('volume');
      }
      /**
       * A promise to set the volume level of the player.
       *
       * @promise SetVolumePromise
       * @fulfill {number} The volume was set.
       * @reject {RangeError} The volume was less than 0 or greater than 1.
       */

      /**
       * Set the volume of the player on a scale from `0` to `1`. When set
       * via the API, the volume level will not be synchronized to other
       * players or stored as the viewer’s preference.
       *
       * Most mobile devices do not support setting the volume. An error will
       * *not* be triggered in that situation.
       *
       * @param {number} volume
       * @return {SetVolumePromise}
       */

    }, {
      key: "setVolume",
      value: function setVolume(volume) {
        return this.set('volume', volume);
      }
    }]);

    return Player;
  }(); // Setup embed only if this is not a node environment


  if (!isNode) {
    screenfull = initializeScreenfull();
    initializeEmbeds();
    resizeEmbeds();
  }

  return Player;

})));

//# sourceMappingURL=player.js.map;
define('module-oneVideo',[
	"jquery",
    "vimeo"
], function ($, Player) {

	"use strict";

	/*
		OneVideo 1.2.0 Usage
		Yang @onerockwell
  	*/

  	var OneVideoView = Backbone.View.extend({
		
		initialize: function (settings) {
			var self = this;
            self.$videoBoxes = self.$el;
            self.isResponsive = settings.isResponsive || false;
            
            self.initVideos();
		},

		events: {

		},
        
        initVideos: function() {
            var self = this;
            
            _.each(self.$videoBoxes, function(box){
                var $box = $(box);
                var boxId = $box.attr('id');
                var type = $box.data('video-type');
                var videoId = $box.data('video-id');
                var videoSrc = $box.data('video-src');
                var autoplay = $box.hasClass('autoplay');
                var videoControl = JSON.parse($box.attr('data-video-control'));
                if (type == 'vimeo') {
                    self.loadVimeoPlayer(videoId,videoSrc,$box,boxId,autoplay,videoControl);
                } else {// Self-host videos
                    self.loadHostPlayer(videoId,videoSrc,$box,boxId,autoplay,videoControl);
                }
            });
        },
        
        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.medium) {
                return true;
            }
            return false;
        },
        
        loadHostPlayer: function(video_id,video_src,$video_box,video_box_id,autoplay,videoControl){
            var self = this, id = '', $videoWrapper = $video_box;
            var videoRatio = $videoWrapper.data('ratio') ? $videoWrapper.data('ratio') : 0.6; // 0.6 is default for product video
            var $playerCtl = $videoWrapper.siblings('.video-ctl');
            var responsive = function(r){
                var wrapperRatio = $videoWrapper.width()/$videoWrapper.height();
                if (wrapperRatio >= r) {
                    $videoWrapper.find('video').css({
                        'width' : '100%',
                        'height': $videoWrapper.width()/r
                    });
                } else {
                    $videoWrapper.find('video').css({
                        'height' : '100%',
                        'width': $videoWrapper.height()*r
                    });
                }
            };
            
            if (self.isMobile()) {
                var $video = $('<video loop><source src="' + video_src + '" type="video/mp4"></video>');
                // $playerCtl.text('Play');
                $playerCtl.removeClass('playing').addClass('paused');
            } else {
                var $video = $('<video loop><source src="' + video_src + '" type="video/mp4"></video>');
                if (autoplay) {
                    $video = $('<video autoplay loop><source src="' + video_src + '" type="video/mp4"></video>');
                }
            }
            
            $video_box.html($video);
            
            var theVideo = $video[0]; 
            theVideo.muted;
            $video.on('play', function() {
                $video.isPlaying = true;
                // $playerCtl.text('Pause');
                $playerCtl.removeClass('paused').addClass('playing');
                $video.isPlaying = true;
                if (self.isMobile()) {
                    $video_box.find('video').css({
                        'opacity' : '1'
                    })
                }
                console.log('play the video!');
            });
            $video.on('pause', function() {
                $video.isPlaying = false;
                // $playerCtl.text('Play');
                $playerCtl.removeClass('playing').addClass('paused');
                $video.isPlaying = false;
                if (self.isMobile()) {
                    $video_box.find('video').css({
                        'opacity' : '0'
                    })
                }
                console.log('pause the video!');
            });
            
            if ($playerCtl.length) {
                // $playerCtl.text('Pause');
                $playerCtl.removeClass('paused').addClass('playing');
                $playerCtl.on('click', function(){
                    if ($video.isPlaying) {
                        theVideo.pause();
                        // $playerCtl.text('Play');
                        $playerCtl.removeClass('playing').addClass('paused');
                    } else {
                        theVideo.play();
                        // $playerCtl.text('Pause');
                        $playerCtl.removeClass('paused').addClass('playing');
                    }
                })
            }
            
            $video.on('loadstart', function(){
                if (self.isResponsive) {
                    responsive(videoRatio);
                }
                console.log('init video');
            })
            
            if (self.isResponsive) {
                $(window).resize(function() {
                    clearTimeout(id);
                    id = setTimeout(function(){
                        responsive(videoRatio);
                    }, 400);
                });
            }
        },
        
        loadVimeoPlayer: function(video_id,video_src,$video_box,video_box_id,autoplay,videoControl){
            var self = this, id = '', $videoWrapper = $video_box;
            var videoRatio = $videoWrapper.data('ratio') ? $videoWrapper.data('ratio') : 0.6; // 0.6 is default for product video
            var $playerCtl = $videoWrapper.siblings('.video-ctl');
            var responsive = function(r){
                var wrapperRatio = $videoWrapper.width()/$videoWrapper.height();
                if (wrapperRatio >= r) {
                    $videoWrapper.find('iframe').css({
                        'width' : '100%',
                        'height': $videoWrapper.width()/r
                    });
                } else {
                    $videoWrapper.find('iframe').css({
                        'height' : '100%',
                        'width': $videoWrapper.height()*r
                    });
                }
            };

            var switchOn = 0
            if (autoplay){
                switchOn = 1;
            }
            var videoControlSetting = 0 
            if (videoControl) {
                videoControlSetting = 1
            }
    
            if ((self.isMobile() || $('html').hasClass('supports-touch')) && !videoControl) {
                var options = {
                    id: video_id,
                    byline: false,
                    portrait: false,
                    title: false,
                    loop: false,
                    background: true,
                    autoplay: false,
                    muted: false
                };
                var vmplayer = new Player(video_box_id, options);
            } else {
                var $iframe = $('<iframe frameborder="0" src="' + video_src + '?title=0&amp;byline=0&amp;portrait=1&amp;autoplay=' + switchOn + '&amp;loop=1&amp;controls=' + videoControlSetting +'" allow="autoplay">');
                $video_box.html($iframe);
                var vmplayer = new Player($iframe);
            }

            if ($playerCtl.length) {
                
                if (!$('html').hasClass('supports-touch')) {//!self.isMobile() && 
                    // $playerCtl.text('Pause');
                    $playerCtl.removeClass('playing').addClass('paused');
                    $playerCtl.on('click', function(){
                        if (vmplayer.isPlaying) {
                            vmplayer.pause();
                            // $playerCtl.text('Play');
                            //$playerCtl.removeClass('playing').addClass('paused');
                        } else {
                            vmplayer.play();
                            // $playerCtl.text('Pause');
                            //$playerCtl.removeClass('paused').addClass('playing');
                        }
                    })
                } else {
                    // $playerCtl.text('Play');
                    //$playerCtl.removeClass('playing').addClass('paused');
                    $playerCtl.on('click', function(){
                        if (vmplayer.isPlaying) {
                            vmplayer.pause();
                            // $playerCtl.text('Play');
                            //$playerCtl.removeClass('playing').addClass('paused');
                        }else{
                            vmplayer.pause().then(function () {
                                vmplayer.play();
                            });
                            // $playerCtl.text('Pause');
                            //$playerCtl.removeClass('paused').addClass('playing');
                        }
                    })
                }
                
            }
            
            vmplayer.setVolume(1);
            vmplayer.on('play', function() {
                vmplayer.isPlaying = true;
                if (self.isMobile() || $('html').hasClass('supports-touch')) {
                    $video_box.addClass('played');
                    // $video_box.find('iframe').css({
                    //     'opacity' : '1'
                    // })
                    $playerCtl.css({
                        'z-index' : '3'
                    })
                }
                $playerCtl.removeClass('paused').addClass('playing');
                $playerCtl.css('opacity', '1');
                console.log('played vm video');
            });
            vmplayer.on('pause', function() {
                vmplayer.isPlaying = false;
                if (self.isMobile() || $('html').hasClass('supports-touch')) {
                    // $video_box.find('iframe').css({
                    //     'opacity' : '0'
                    // })
                }
                $playerCtl.removeClass('playing').addClass('paused');
                console.log('paused vm video');
            });
            vmplayer.on('ended', function() {
                vmplayer.isPlaying = false;
                if (self.isMobile() || $('html').hasClass('supports-touch')) {
                    // $video_box.find('iframe').css({
                    //     'opacity' : '0'
                    // })
                    if ($playerCtl.length) {
                        $playerCtl.removeClass('playing').addClass('paused');
                    }
                }
                console.log('ended vm video');
            });
            vmplayer.on('loaded', function() {
                if (self.isResponsive) {
                    responsive(videoRatio);
                }
                console.log('init vm video here');
            });

            var timer;
            $playerCtl.on('mousemove', function(e){
                $playerCtl.css('opacity', '1');
                clearTimeout(timer);
                timer = setTimeout( function() {
                    if ($playerCtl.hasClass('playing')){
                        console.log("hide",$playerCtl);
                        $playerCtl.css('opacity', '0');
                    }
                },1000);
            });
            
            if (videoControl) {
                $playerCtl.css('display', 'none');
                $videoWrapper.addClass('videoControl');
            }
            
            if (self.isResponsive) {
                $(window).resize(function() {
                    clearTimeout(id);
                    id = setTimeout(function(){
                        responsive(videoRatio);
                    }, 400);
                });
            }
        },
        
        destroy: function() {
            var self = this;
            self.undelegateEvents();
        }


	});

	var OneVideo = {
		init: function (settings) {
			return new OneVideoView(settings);
		}
	}

	return OneVideo;


});
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define('slick',['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" tabindex="0" role="none">Previous</button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next" tabindex="0" role="none">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" aria-label="pagination" tabindex="0" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }


        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }

        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick',
                '*:not(.slick-arrow)', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this;
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        _.$slideTrack.attr('role', 'listbox');

        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
            $(this).attr({
                'role': 'option',
                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
            });
        });

        if (_.$dots !== null) {
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                $(this).attr({
                    'aria-selected': 'false',
                    'aria-controls': 'navigation' + _.instanceUid + i + '',
                    'id': 'slick-slide' + _.instanceUid + i + ''
                });
            })
                .first().attr('aria-selected', 'true').end()
                .find('button').attr('role', 'button').end()
                .closest('div').attr('role', 'toolbar');
        }
        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {
                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            _.setPosition();

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {

                    _.$slides
                        .slice(index - centerOffset, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand') {
            _.lazyLoad();
        }

    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.setSlideClasses(index);
            _.asNavFor(index);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(
                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();

        if (swipeDirection === 'vertical') {
            return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                .removeClass('slick-active')

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active')
                .attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));

define('view-home',[
    'jquery',
    'module-oneVideo',
    'slick',
    'jquery.hoverintent',
], function ($, OneVideo) {

    "use strict";

    var ViewHome = Backbone.View.extend({

        initialize: function(opts){
            var self = this;
            self.$largeSliderSection = self.$el.find('.section.large-slider');
            self.$largeSlider = self.$largeSliderSection.find('.slick-large-slider');
            self.$editorialSection = self.$el.find('.section.editorial');
            self.$editorialSlider = self.$editorialSection.find('.slick-editorial-slider');
            self.$featuredDesignerSection = self.$el.find('.section.featured-designers');

            if(self.$featuredDesignerSection.length > 0){
                self.featuredDesignerSection();
            }
            
            if(self.$largeSlider.length > 0){
                self.largeSlider();
                self.initVideo();
            }

            if(self.$editorialSlider.length > 0){
                self.editorialSlider();
            }

        },

        events: {

        },

        initVideo: function() {
            var self = this;
            self.$videoBoxes = self.$largeSliderSection.find('.video-box');
            var $videoSlide = self.$videoBoxes.parents(".slide");
            $videoSlide.addClass("video-slide");

			OneVideo.init({
                el: self.$videoBoxes
            });
        },

        largeSlider: function(){
            var self = this,
                $customPager = self.$largeSliderSection.find('.custom-paging'),
                $customPagerCurrent = $customPager.find('.current'),
                enableAutoscroll = self.$largeSliderSection.data("enable-autoscroll"),
                autoScrollDuration = self.$largeSliderSection.data("autoscroll-duration") || 1000;

            function updateSlideColor(currentSlide){
                var $activeSlide = self.$largeSlider.find('[data-slick-index="'+currentSlide+'"]');
                if($activeSlide.hasClass('font-light')){
                    self.$largeSlider.attr('data-color', 'light');
                }else{
                    self.$largeSlider.attr('data-color', 'dark');
                }
            }

            self.$largeSlider.on('init', function(event, slick, direction){
                updateSlideColor(slick.currentSlide);
            });

            self.$largeSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                updateSlideColor(nextSlide);
                $customPagerCurrent.html(nextSlide + 1);

                //Set video to autoplay upon reaching this slide.
                var $video = $(event.currentTarget).find("iframe");
                if ($video.length > 0) {
                    _.each($video, function(video) {
                        if (video.src.search("muted") === -1) {
                            var symbol = video.src.indexOf("?") > -1 ? "&" : "?";
                            video.src += symbol + "muted=1";
                        }
                    });
                }
            });

            self.$largeSlider = self.$largeSlider.slick({
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows: true,
                autoplay: enableAutoscroll,
                autoplaySpeed: autoScrollDuration,
                prevArrow: '<button type="button" class="slick-prev icon icon-chevron-left"><span class="visually-hidden">Previous slide</span></button>',
                nextArrow: '<button type="button" class="slick-next icon icon-chevron-right"><span class="visually-hidden">Next slide</span></button>'
            });
        },

        setEditorialSliderImageHeights: function (e, slick, cI, nextIndex) {
          var self = this
          setTimeout(function () {

            var $next = $((slick || [])[nextIndex || 0])

            var $image = $next.length
              ? $next
              : self.$editorialSlider.find('.slick-slide.slick-current img').first();

            var height = $image.height();

            var dotSpacing = height + 20 + (window.innerWidth / 100);
            self.$editorialSlider.find('.slick-dots').css('top', dotSpacing);

          }, e ? 0 : 50)
        },

        editorialSlider: function () {
            var self = this;

            self.$editorialSlider = self.$editorialSlider.slick({
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 5000,
                // lazyLoad: 'ondemand', // existing bug, cannot use with adaptive height
                adaptiveHeight: true,
            });

            this.setEditorialSliderImageHeights();
            $(window).on('resize', this.setEditorialSliderImageHeights.bind(this));
            self.$editorialSlider.on('beforeChange', this.setEditorialSliderImageHeights.bind(this));
        },

        featuredDesignerSection: function(){
            var self = this;
            var desktopStartingPoint = 4;

            function removeDuplicateRow($section) {
                const titleTab = $section.find(".collection-title.active");
                const tabs = $section.find(".tab");
                const actives = $section.find(".tab.active");
                console.log("REMOVE DUPLICATE ROW", {
                    "titleTab": titleTab,
                    "tabs": tabs,
                    "actives": actives
                });
                if (actives.length > 1) {
                    for (var i = 1; i <= actives.length; i++) {
                        $(actives[i]).css("display", "none");
                    }
                }
            }

            function updateActiveDesigner($designer, $collTitles){
                $collTitles.find('.collection-title').removeClass('active before-active');
                $designer.addClass('active');
                $designer.prev().addClass('before-active');
            }

            _.each(self.$featuredDesignerSection, function(section){
                var $section = $(section);
                var $sliders = $section.find('.slick-featured-designer-slider');
                var $collTitles = $section.find('.collection-list');

                $sliders.slick({
                    dots: true,
                    infinite: true,
                    speed: 600,
                    slidesToShow: 1,
                    arrows: false,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: ORW.responsiveSizes['medium'],
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: ORW.responsiveSizes['large'],
                            settings: "unslick"
                        }
                    ]
                });

                $collTitles.on('init', function(event){
                    var $designer = $collTitles.find('button:nth-child(' + (desktopStartingPoint + 1) + ')');
                    if (!$designer.length) {
                        $designer = $collTitles.find('button:nth-child(1)');
                    } 
                    updateActiveDesigner($designer, $collTitles);

                    var tab = $designer.data('tab-toggle');
                    $section.find('.tab').removeClass('active');
                    $section.find('[data-tab="'+tab+'"]').addClass('active');

                    // manually set scroll of tabs container on mobile
                    if(!self.isDesktop()){
                    var offset = (window.innerWidth / 2) - ($designer.width() / 2)
                    $collTitles.scrollLeft($designer.offset().left - offset);
                    }
                });

                $collTitles.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    var $nextSlide = $collTitles.find('[data-slick-index="'+nextSlide+'"]');
                    updateActiveDesigner($nextSlide, $collTitles);
                });
            
                $collTitles.slick({
                    dots: false,
                    infinite: false,
                    speed: 600,
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,
                    arrows: false,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    mobileFirst: false,
                    initialSlide: desktopStartingPoint,
                    responsive: [
                        {
                            breakpoint: ORW.responsiveSizes['large'],
                            settings: "unslick"
                        }
                    ]
                });
                removeDuplicateRow($section);
            });

            var events = {
                'click .section.featured-designers .collection-title': function(e){
                    var $curr = $(e.currentTarget);
                    var index = $curr.data('slick-index');
                    var tab = $curr.data('tab-toggle');
                    var $section = $curr.parents('.section.featured-designers');
                    var $collTitles = $section.find('.collection-list');
                    updateActiveDesigner($curr, $collTitles);
                    $section.find('.tab').removeClass('active');
                    $section.find('[data-tab="'+tab+'"]').addClass('active');
                    if(self.isDesktop()){
                        $collTitles.slick('goTo', index);
                    }
                    removeDuplicateRow($section);
                }
            };

            _.extend(self.events, events);
            self.delegateEvents();
        },

        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w < ORW.responsiveSizes.medium) {
                return true;
            }
            return false;
        },

        isDesktop: function () {
            var self = this;
            var w = $(window).width();
            if (w > ORW.responsiveSizes.large) {
              return true;
            }
            return false;
        }

    });

    return ViewHome;

});
define('page-home',[
    "view-home",
    "domReady",
    "jquery"
], function (ViewHome, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
    	console.log('init home');
        new ViewHome({el: $('#MainContent')});
    });

});

define('module-oneSocial',[
	"jquery"
], function ($) {

	"use strict";

	/*
		OneSocial 2.0.0 Usage
		Yang@onerockwell

		Share button for social media

		// Html

		<div class="social-share clear-conatiner">
            <div class="share-fb share-elm"></div>
            <div class="share-pin share-elm"></div>
            <div class="share-tw share-elm"></div>
            <div class="share-google share-elm"></div>
        </div>

		// Use example on PDP
		$item represent the wrapper or container of the target element you want to share

		new OneSocial.init({
			el: $item,
			image: $item.find('img').prop('src'),
			title: $item.find('h4').text(),
			description: $item.find('p').text(),
			pinterestTag: '#RK',
			twitterTag: '@RK',
		});
	*/

	var SocialView = Backbone.View.extend({

		initialize: function (settings) {
			console.log('Social init');

			this.$socialWrapper = this.$el;
            this.settings = settings;
			
			this.title = settings.title || $('meta[property="og:title"]').attr('content');
			this.link = settings.link || window.location.href;
			this.description = settings.description || $('meta[name="description"]').attr('content');

			this.pinterestTag = settings.pinterestTag || null;
			this.twitterTag = settings.twitterTag || null;
			this.productData = settings.product || null;
			
			this.storeName = ORW.storeName;

			this.options = {
				'title': this.title,
				'link' : this.link,
				'description': this.description,
				'pinTag': this.pinterestTag,
				'twTag' : this.twitterTag,
				'product' : this.productData
			}
			this.emailSharingInit();
		},

		events: {
			'click .share-copy': function (e) {
				var self = this,
				link = self.link;
				
				e.preventDefault();
				window.prompt("Copy to clipboard: Ctrl+C, Enter", link);
				// self.seoTools('productEmail');
			},
			'click .share-fb': function (e) {
				
			},
			'click .share-tw': function (e) {
				e.preventDefault();
				var self = this;
				var shareUrl = encodeURIComponent(self.link);
				if (this.twitterTag) {
					var description = encodeURIComponent(self.title + ' ' + self.twitterTag);
				} else {
					var description = encodeURIComponent(self.title);
				}
				var url = 'https://twitter.com/share?url='+shareUrl+"&text="+description;
				var nw = window.open(url, 'share', 'height=375,width=650');
				if (window.focus) { nw.focus(); }
				// self.seoTools('productTweet');
			},
			'click .share-pin': function (e) {
				e.preventDefault();
				var self = this;
				var shareUrl = encodeURIComponent(self.link);
				var image = encodeURIComponent(self.findImage(e));
				if (self.pinterestTag) {
					var description = encodeURIComponent(self.title + ' ' + self.pinterestTag);
				} else {
					var description = encodeURIComponent(self.title);
				}
				var url = "https://pinterest.com/pin/create/button/?url="+shareUrl+"&description="+description+"&media="+image;
				var nw = window.open(url, 'share', 'height=375,width=650');
				if (window.focus) { nw.focus(); }
				// self.seoTools('productPin');
			},
			'click .share-google': function (e) {
				e.preventDefault();
                var self = this;
				var image = self.findImage(e);
				var url = encodeURI("https://plus.google.com/share?url="+self.link);
				var nw = window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
				if (window.focus) { nw.focus(); }
			},

		},
        
        findImage: function (e) {
            var self = this;
            var image = '';
            var $curr = $(e.currentTarget);
            
            if (self.settings.image && $.type(self.settings.image) == 'string') {
                return self.settings.image
            } else if (self.settings.image && $.type(self.settings.image) == 'function') {
				var resultImg = self.settings.image;
				if (resultImg()) {
					return resultImg();
				}
			}
            
            if ($('body').hasClass('template-product')) {
                // Product page share
                var $image = $('#ProductPhoto img');
            } else {
                var $image = $curr.closest('img');
            }
            
            if ($image.length > 1) {
                $image = $image.first();
                image = $image.prop('src');
            } else if ($image.length == 1) {
                image = $image.prop('src');
            }
            
            return image;
        },
		
		emailSharingInit: function () {
			var self = this;
			// Init email sharing
			var link = encodeURIComponent(self.link);
			var shareSubject = 'Check%20this%20out%20on%20' + self.storeName;
			var shareBody = 'Check%20out' + '%20%22' + self.title + '%22%20' + 'on%20' + self.storeName + '%20at' + '%0D%0A%0D%0A' + link;
			_.each(this.$socialWrapper.find('.share-mail'),function(link){
				var $link = $(link);
				$link.attr('href','mailto:?subject=' + shareSubject + '&body=' + shareBody);
			})
		},

		seoTools: function (eventType) {
			var self = this;
			if (self.productData && dataLayer) {
				dataLayer.push({
					'event': eventType,
					'product' : self.productData
				});
			}
		},
		
		destroy: function() {
            var self = this;
            self.undelegateEvents();
        }

	});

	var OneSocial = {
		init: function (settings) {
			return new SocialView(settings);
		}
	}

	return OneSocial;
});

/*
 * Viewport - jQuery selectors for finding elements in viewport
 *
 * Copyright (c) 2008-2009 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *  http://www.appelsiini.net/projects/viewport
 *
 */
(function($) {
    
    $.belowthefold = function(element, settings) {
        var fold = $(window).height() + $(window).scrollTop();
        return fold <= $(element).offset().top - settings.threshold;
    };

    $.abovethetop = function(element, settings) {
        var top = $(window).scrollTop();
        return top >= $(element).offset().top + $(element).height() - settings.threshold;
    };
    
    $.rightofscreen = function(element, settings) {
        var fold = $(window).width() + $(window).scrollLeft();
        return fold <= $(element).offset().left - settings.threshold;
    };
    
    $.leftofscreen = function(element, settings) {
        var left = $(window).scrollLeft();
        return left >= $(element).offset().left + $(element).width() - settings.threshold;
    };
    
    $.inviewport = function(element, settings) {
        return !$.rightofscreen(element, settings) && !$.leftofscreen(element, settings) && !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
    };
    
    $.extend($.expr[':'], {
        "below-the-fold": function(a, i, m) {
            return $.belowthefold(a, {threshold : 0});
        },
        "above-the-top": function(a, i, m) {
            return $.abovethetop(a, {threshold : 0});
        },
        "left-of-screen": function(a, i, m) {
            return $.leftofscreen(a, {threshold : 0});
        },
        "right-of-screen": function(a, i, m) {
            return $.rightofscreen(a, {threshold : 0});
        },
        "in-viewport": function(a, i, m) {
            return $.inviewport(a, {threshold : 0});
        }
    });

    
})(jQuery);

define("jquery.viewport", ["jquery"], function(){});

define('view-lookbook',[
    'jquery',
    'module-oneSocial',
    'jquery.viewport',
    'slick'
], function ($, OneSocial) {

    "use strict";

    var ViewLookbook = Backbone.View.extend({

        initialize: function (opts) {
            var self = this;
            
            self.$pager = self.$el.find('.collection-pagination');
            self.$productGrid = self.$el.find('.lookbook-products');
            self.$products = self.$productGrid.find('.item');
            
            // self.quickview();
            // self.infinityScroll();
        },

        events: {
            
        },
        
        infinityScroll: function () {
            var self = this;
            var loadMore = function(prev){ // Passing param to determin whether loading next page or prev
                var addPage = function(d){
                    var $content = $(d).find('.lookbook-main');
                    var $pager = $content.find('.collection-pagination');
                    var $newItems = $content.find('.lookbook-products .item');
                    var loadingPageNum = ORW.utilities.getUrlParam(self.url,'page');
                    var afterAppend = function (index, item) {
                        
                        $(item).data('page',loadingPageNum);
                        
                        if (index == $newItems.length-1) {
                            // Perform re-init of product grid if needed
                            ORW.rebuildLookbook();
                            ORW.isLoading = false;
                            
                            if (prev) {
                                loadMore(true); // Recursive!!
                                $('html, body').animate({
                                    scrollTop: self.$productGrid.prop("scrollHeight")
                                }, 0);
                            } else {
                                return false;
                            }
                        }
                    }
                    
                    ORW.pagerStack.push(self.url);

                    if (!ORW.isFinished) {
                        self.$pager = $pager;
                        $newItems.prependTo(self.$productGrid).each(afterAppend);
                    } else {
                        self.$pager.replaceWith($pager);
                        self.$pager = $pager;
                        $newItems.appendTo(self.$productGrid).each(afterAppend);
                        window.history.pushState(null, null, self.url);
                    }
                    
                }
                
                // Start of Load More
                if (!ORW.isLoading) {
                    var status = prev ? 'prev' : 'next';
                    if (ORW.isFinished) {
                        // Load next page
                        self.url = self.$pager.find('.next a').length ? self.$pager.find('.next a').attr('href') : '';
                    } else {
                        // Load prev page
                        self.url = self.$pager.find('.prev a').length ? self.$pager.find('.prev a').attr('href') : '';
                    }

                    if ($.inArray(self.url, ORW.pagerStack) == -1 && self.url) {
                        console.log('load ' + status);
                        ORW.isLoading = true;
                        $.get(self.url).done(addPage);
                    } else {
                        if (prev) {
                            // Loading Prev Finished
                            ORW.isFinished = true;
                            console.log('load prev finished');
                            
                            // Check if need to load a look detial modal
                            var lookHandle = ORW.utilities.getUrlParam(undefined,'look');
                            if (lookHandle && lookHandle != 'false') {
                                setTimeout(function() {
                                    $('[data-handle=' + lookHandle + ']').trigger('click');
                                }, 800);
                            }
                            
                        } else {
                            $('#loadmore').addClass('disabled');
                            return false;
                        }
                    }
                }
            }
            
            // Load Prev Page Trigger
            loadMore(true);
            
            // Load Next Page Triggers
            if ($('#loadmore:in-viewport').length) {
		    	loadMore();
		    }
		    $(window).on('scroll.listview', function () {
				if ($('#loadmore:in-viewport').length) {
			    	loadMore();
			    }
			});
        },
        
        quickview: function(){
            var self = this;
            self.qvBuild();
            
            var events = {
                'click .lookbook-products .item' : 'qvHandle',
                'click #quick-view-modal .close' : 'qvHandle'
            };
            // Update and delegate adding events
			_.extend(self.events, events);
			self.delegateEvents();
        },
        
        qvBuild: function(){
            var self = this;
            var html = '<div id="quick-view-modal"><a class="close">close</a><div class="slider-wrapper">';
                _.each(self.$productGrid.find('.item'),function(item){
                    html += '<div class="slide-item">' + $(item).html() + '</div>';
                });
                html += '</div></div>';
            
            self.overlayEngaged = false;
            self.$overlay = $(html);
            self.$productGrid.after(self.$overlay);

            self.$slider = self.$overlay.find('.slider-wrapper').slick({
                zIndex: 100,
                centerMode: true,
                slidesToShow: 1,
                centerPadding: '60px',
                variableWidth: true,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '40px',
                            slidesToShow: 1
                        }
                    }
                ]
            });
        },
        
        qvHandle: function(e){
            e.preventDefault();
            var self = this;
            var currentUrl,newurl;
            currentUrl = newurl = window.location.href;
            
            // Close if opened
            if (self.$overlay.hasClass('active')) {
                self.$overlay.removeClass('active');
                newurl = ORW.utilities.updateUrlParam(currentUrl,'look','false');
                window.history.pushState(null, null, newurl);
                return false;
            }
            
            var $curr = $(e.currentTarget);
            var index = $curr.parent().find('.item').index($curr);
            var handle = $curr.data('handle');
            var pageIndex = $curr.data('page');
            
            
            if (pageIndex) {
                currentUrl = ORW.utilities.getUrlParam(currentUrl,'page', pageIndex);
            }
            newurl = ORW.utilities.updateUrlParam(currentUrl,'look',handle);
            window.history.pushState(null, null, newurl);
            
            if (!ORW.isLoading) {
                self.$overlay.addClass('active');
                self.$slider.resize();
                self.$slider.slick('slickGoTo', index);
            }
        },
        
        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        },
        
        destroy: function() {
            var self = this;
            self.undelegateEvents();
            self.$overlay.remove();
            $(window).off('scroll.listview');
        }

    });

    return ViewLookbook;

});
define('page-lookbook',[
    "view-lookbook", // ViewLookbook
    "domReady",
    "jquery"
], function (ViewLookbook, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
    	console.log('init lookbook');
        new ViewLookbook({el: $('.lookbook-main') });
    });

});

define('module-oneSwatches',[
  "jquery",

], function($) {

  "use strict";

  /*
		OneSwatches 2.1.0 Usage
		Yang @onerockwell
		Adding option availablity check

		OneSwatches 2.0.0 Usage
		Yang @onerockwell

    	OneSwatches 1.0.0 Usage
        Yang & Patrick @onerockwell
  	*/

  var OneSwatchesView = Backbone.View.extend({

    initialize: function(settings) {
      console.log('Init swatches');
      var self = this;
      self.optionsMapMix = {};
      self.optionsFlowStr = ['', '', ''];
      self.$content = self.$el;
      self.$media = self.$content.find('.product-media');
      self.$optionSelects = self.$content.find('.single-option-selector');
      self.$optionSwatches = self.$content.find('.oneswatch .swatches');
      self.$sizeSwatches = self.$content.find('.oneswatch .swatches[data-name="size"]');
      self.preSelect = settings.preSelect;

      self.orderVariants();

      if (settings.product) {
        self.buildOptionMaps(settings.product);
        window.optionsMapMix = self.optionsMapMix;
      }

      // PreSelect
      if (!settings.preSelect) {
        _.each(self.$content.find('.single-option-selector'), function(select) {
          if ($(select).siblings('label').length) {
            if ($(select).children().length > 1) {
              $(select).prepend('<option value="" class="label-option">Select a ' + $(select).siblings('label').text() + '</option>').val('');
            }
          } else {
            var label = 'Size'; // Hard coded single select
            $(select).prepend('<option value="" class="label-option">Select a ' + label + '</option>').val('');
          }
        });
      }

      self.$content.find('.single-option-selector').trigger('change');

      // Single select
      if (self.$optionSelects.length == 1) {
        self.updateOptionsInSelector();
      }

      // Click outside to close
      $(window).on('click', function(e) {
        $('.oneswatch').removeClass('opened');
      });

      if (!self.preSelect) {
        $('.label-option').remove();
      }
    },

    events: {
      // 'click .oneswatch': 'swatchDropdown', # Doesnt seem to be used, overrides size guide click handler
      'click .swatches .swatch': 'swatchHandle',
      'change .single-option-selector': 'dropdownHandle'
    },

    swatchDropdown: function(e) {
      // Dropdown control
      e.stopPropagation();
      e.preventDefault();
      var self = this,
        $curr = $(e.currentTarget);
      $curr.siblings('.oneswatch').removeClass('opened');
      $curr.toggleClass('opened');
    },

    swatchHandle: function(e) {
      // Swatch click control
      var self = this,
        $curr = $(e.currentTarget),
        $parent = $curr.closest('.swatches'),
        $form = $curr.closest('form'),
        $label = $parent.siblings('.swatch-label-wrap').find('.swatch-label'),
        selectAttr = $parent.data('name'),
        selectIndex = $parent.data('option'),
        val = $curr.data('name');

      if ($curr.hasClass('active')) {
        return false;
      }

      if ($form.attr('id').split('-').length > 1) {
        // PLP
        var selectorArray = $form.attr('id').split('-'),
          pid = selectorArray[1],
          $dropdown = $('#productSelect-' + pid + '-option-' + selectIndex);
      } else {
        // PDP
        var $dropdown = $('#productSelect-option-' + selectIndex);
      }

      $dropdown.val(val);
      $dropdown.change();

      const $wishlistWrap = $('[data-wishlist-button-wrap]');
      $wishlistWrap.removeClass('select-product-size');
      $wishlistWrap.addClass('product-size-selected');

      // if (self.isMobile()) {
        $label.html(selectAttr + '  <span class="value">' + val + '</span>');
      // }
    },

    dropdownHandle: function(e) {
      console.log('e value here');
      console.log(e.currentTarget.value);
      var self = this;
      self.updateOptionsInSelector(e);
      self.updateSwatches(e);
    },

    updateSwatches: function(e) {
      var self = this,
        $curr = $(e.currentTarget),
        $form = $curr.closest('form'),
        selectedValue = $curr.val(),
        optionIndexArray = $curr.data('option').split('option'),
        optionIndex = optionIndexArray[1] - 1; // Please make sure all dropdown has a valid data-option attribute
      // console.log(optionIndexArray[1]);

      var $swatchContainer = $form.find('.swatches[data-option="' + optionIndex + '"]');
      var $label = $swatchContainer.siblings('.swatch-label-wrap').find('.swatch-label');
      var $selectedSwatch = $swatchContainer.find('.swatch').filter(function(index) {
          return $(this).data('select') == selectedValue;
        }),
        selectAttr = $swatchContainer.data('name');

      $swatchContainer.find('.swatch').removeClass('active');
      
      $label.html(selectAttr + ' <span class="value">' + selectedValue + '</span>');

      // self.updateImage(e, selectAttr);

    },

    updateImage: function(e, attribute) {
      var self = this,
        $curr = $(e.currentTarget), // Shopify select dropdown
        $form = $curr.closest('form'),
        $media = self.$content.find('.product-media'),
        selectedValue = $curr.val(),
        canUpdateImage = false;

      attribute = attribute.replace(/\-| |\_|\//g, '').toLowerCase();

      if (attribute.indexOf("color") >= 0 ||
        attribute.indexOf("finish") >= 0
      ) {
        canUpdateImage = true;
      }

      // console.log(selectedValue);
      if (canUpdateImage) {
        // Only apply when color got selected
        if ($form.attr('id').split('-').length > 1) {
          // PLP
          var $selectedSwatch = $form.find('.swatches [data-select="' + selectedValue + '"]');
          var imageSrc = $selectedSwatch.length ? $selectedSwatch.data('image') : false;
          if (imageSrc) {
            $form.parents('.item').find('.product-image').attr('src', imageSrc);
          }
        } else {
          // PDP
          selectedValue = selectedValue.replace(/\-| |\_|\//g, '').toLowerCase();
          // console.log(selectedValue);
          var $thumbnails = $media.find('#ProductThumbs li');
          var $selectedThumbs = $thumbnails.filter(function(index) {
            return $(this).data('option') == selectedValue;
          });
          if ($selectedThumbs.length) {
            $thumbnails.removeClass('active').addClass('inactive');
            $selectedThumbs.removeClass('inactive').addClass('active');
          }
        }
      }
    },

    buildOptionMaps: function(product) {
      var self = this;
      // console.log(product);
      // Building our mapping object.
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        // if (variant.available) {

          // For each option
          _.each(product.options, function(option, k) {
            // k is option index

            // Gathering values for the 1st option.
            self.optionsMapMix[k] = self.optionsMapMix[k] || [];

            switch (k) {
              case 0: // Order: 0-1-2
                // Gathering values for the 2nd option.
                if (product.options.length == 1) {
                  var key = variant.options[k];
                  self.optionsMapMix[k] = self.optionsMapMix[k] || [];
                  self.optionsMapMix[k].push(variant.options[0].toString());
                }
                if (product.options.length > 1) {
                  var key = variant.options[k];
                  self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
                  self.optionsMapMix[k][key].push(variant.options[1]);
                  self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
                }
                // Gathering values for the 3rd option.
                if (product.options.length === 3) {
                  var key = variant.options[k] + ' / ' + variant.options[1];
                  self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
                  self.optionsMapMix[k][key].push(variant.options[2]);
                  self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
                }
                break;
              case 1: // Order: 1-0-2
                // Gathering values for the 2nd option.
                if (product.options.length > 1) {
                  var key = variant.options[k];
                  self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
                  self.optionsMapMix[k][key].push(variant.options[0]);
                  self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
                }
                // Gathering values for the 3rd option.
                if (product.options.length === 3) {
                  var key = variant.options[k] + ' / ' + variant.options[0];
                  self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
                  self.optionsMapMix[k][key].push(variant.options[2]);
                  self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
                }
                break;
              case 2: // Order: 2-0-1
                // Gathering values for the 2nd option.
                if (product.options.length > 1) {
                  var key = variant.options[k];
                  self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
                  self.optionsMapMix[k][key].push(variant.options[0]);
                  self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
                }
                // Gathering values for the 3rd option.
                if (product.options.length === 3) {
                  var key = variant.options[k] + ' / ' + variant.options[0];
                  self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
                  self.optionsMapMix[k][key].push(variant.options[1]);
                  self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
                }
            }
          });

        // }
      }
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var loc = variant.title.split(' / ').pop();
        if (typeof self.optionsMapMix[1] !== 'undefined' && typeof self.optionsMapMix[1][loc] !== 'undefined') {
          self.optionsMapMix[1][loc]['available'] = variant.available;
        }
      }
    },

    updateOptionsInSelector: function(e) {
      var self = this;
      var optionsfilter = function(options, optionsArray, value, resultsArray) {
        if (options && options.length) {
          _.each(options, function(option) {
            if ($.inArray(option, resultsArray) == -1) {
              resultsArray.push(option);
              var key = value + ' / ' + option;
              var newOptions = optionsArray[key];
              optionsfilter(newOptions, optionsArray, value, resultsArray);
            }
          });
        } else {
          return resultsArray;
        }
      };

      if ($.isEmptyObject(self.optionsMapMix)) {
        return false;
      }

      if (e == null) {
        // For single select update without passing event
        var $selector = self.$optionSelects,
          $options = $selector.find('option'),
          optionArray = self.optionsMapMix[0],
          availableOptions = [];

        // Update select options
        $selector.val('');
        $options = $options.filter(function(index, elem) {
          return $.inArray($(elem).attr('value'), optionArray) != -1;
        });

        // Update swatches
        var $linkedSwatch = self.$optionSwatches;
        var $swatches = $linkedSwatch.find('.swatch').addClass('disabled');
        $swatches = $swatches.filter(function(index, elem) {
          var swatchValue = String($(elem).data('select'));
          return $.inArray(swatchValue, optionArray) != -1;
        });
        if ($swatches && $swatches.length) $swatches.removeClass('disabled');
        return false;

      } else {
        // For multi selects update using event trigger
        var $curr = $(e.currentTarget),
          availableOptions = [],
          selectorValue = $curr.val(),
          selectorIndex = self.$optionSelects.index($curr),
          optionArray = self.optionsMapMix[selectorIndex],
          results = ''

        // Here we need to 'flatrize' the available options
        availableOptions.push(selectorValue);
        optionsfilter(results, optionArray, selectorValue, availableOptions);

        // Should the values array also check selected values? For 3 selections, we need to check the selected value agains the avaliable mitrix

        // self.optionsFlowStr[selectorIndex] = selectorValue;
        // console.log(self.optionsFlowStr);

        // _.each(self.$optionSelects, function(select){
        // 	var $selector = $(select);
        // 	var initialValue = $selector.val();
        // 	var currIndex = self.$optionSelects.index($selector);
        // 	var $options = $selector.find('option');
        //
        // 	if (currIndex !== selectorIndex && initialValue) {
        // 		console.log('also chose: ' + initialValue);
        // 	}
        // });

        // console.log(availableOptions);

        // Update the other two select dropdowns and swatches
        _.each(self.$optionSelects, function(select) {
          var $selector = $(select);
          var initialValue = $selector.val();
          var currIndex = self.$optionSelects.index($selector);
          var $options = $selector.find('option');


          if (currIndex !== selectorIndex) {
            // Update select options
            $selector.val('');
            $options = $options.filter(function(index, elem) {
              return $.inArray($(elem).attr('value'), availableOptions) != -1;
            });
            $selector.val(initialValue);

            // Update swatches
            var $linkedSwatch = self.$optionSwatches.filter(function(index, elem) {
              return $(elem).data('option') == currIndex;
            });
            var $swatches = $linkedSwatch.find('.swatch').addClass('disabled');
            $swatches = $swatches.filter(function(index, elem) {
              // var swatchValue = String($(elem).data('select'));
              // return $.inArray(swatchValue, availableOptions) != -1;
              if (self.optionsMapMix[1] != undefined && self.optionsMapMix[1][$(elem).attr('data-name')] != undefined)
                return self.optionsMapMix[1][$(elem).attr('data-name')]['available'];
            });
            if ($swatches && $swatches.length) $swatches.removeClass('disabled');
            var $selectedSwatch = $swatches.filter('[data-select="' + initialValue + '"]');
            if ($selectedSwatch && $selectedSwatch.length) $selectedSwatch.addClass('active');
          }

        });

        return false;
      }

    },

    isMobile: function() {
      var self = this;
      var w = $(window).width();
      if (w <= ORW.responsiveSizes.large) {
        return true;
      }
      return false;
    },

    destroy: function() {
      var self = this;
      self.undelegateEvents();
    },

    orderVariants: function () {
        var self = this;
        var sizeHash = {
            'xxs'   : 0,
            'xs'    : 1,
            's'     : 2,
            'm'     : 3,
            'l'     : 4,
            'xl'    : 5,
            'xxl'   : 6
        };

        self.$sizeSwatches.each(function () {
          var sorted = $(this).children('button').sort(function (a, b) {
            var numberReg = /\d/;
            var nonNumberReg = /[a-zA-Z]/g;
            var $a = $(a);
            var $b = $(b);

            var aData = '' + $a.data('name');
            var bData = '' + $b.data('name');

            var aSizeValue = numberReg.test(aData) ? parseFloat(aData.replace(nonNumberReg, '')) : sizeHash[aData.toLowerCase()];
            var bSizeValue = numberReg.test(bData) ? parseFloat(bData.replace(nonNumberReg, '')) : sizeHash[bData.toLowerCase()];

            if (aSizeValue && bSizeValue) {
                return aSizeValue - bSizeValue;
            }

            return aData - bData;
          });

          $(this).html(sorted);
          $(this).removeClass('invisible');
        });
    }

  });

  var OneSwatches = {
    init: function(settings) {
      return new OneSwatchesView(settings);
    }
  }

  return OneSwatches;


});

define('view-collection',[
    'jquery',
    'module-oneSwatches',
    'jquery.viewport'
], function ($, OneSwatches) {

    "use strict";

    var ViewCollection = Backbone.View.extend({

        initialize: function (opts) {
            var self = this;
            self.$pager = self.$el.find('.collection-pagination');
            self.$productGrid = self.$el.find('.collection-products');
            self.$products = self.$productGrid.find('.item');

            // self.swatches();
            self.quickbuy();
            self.addAll();
            // self.infinityScroll();
            self.glowingText();
        },

        events: {

        },

        // swatches: function(){
        //     var self = this;
        //     self.swatches = OneSwatches.init({ el: self.$productGrid, preSelect: false });
        // },

        addAll: function() {
            // Add All requires Quickbuy
            var self = this;
            var addAllToBag = function(e){
                e.preventDefault();
                // Add CTA status change here..

                // Collecting data
                var productIds = [];
                _.each(self.$products, function(product){
                    var $productSelected = $(product).find('select.product-single__variants');
                    if ($productSelected.length) {
                        productIds.push($productSelected.val());
                    }
                });

                // Add Multiple Products
                var data = {
                    id : productIds,
                    quantity : 1
                }, callback = function(line_item){
                    // Success callback, cart loaded, please add CTA status change here..
                    console.log(line_item);
                    ajaxCart.load();
                    $('header .block-minicart').trigger('click');
                }, errorCallback = function (XMLHttpRequest, textStatus) {
                    // Error callback, please add extra error handling here
                    var data = eval('(' + XMLHttpRequest.responseText + ')');
                    console.log(data);
                };
                ShopifyAPI.addMultipleItems(data, callback, errorCallback);
            }

            var events = {
                'click .add-all-to-bag' : addAllToBag
            }

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        quickshop: function(){
            var self = this;
        },

        quickbuy: function () {
            var self = this;
            var $products = self.$products.filter(function(index){
                var $qbcontainer = $(this).find('.quick-buy-container');
                return $qbcontainer.length && !$qbcontainer.hasClass('initialized');
            });
            var events = {
                'click .quick-buy-ctl' : function(e){
                    var $curr = $(e.currentTarget);
                    var $item = $curr.parents('.item');
                    var temp = '';

                    temp = $curr.text();
                    $curr.text($curr.data('toggle'));
                    $curr.data('toggle', temp);

                    $item.find('.quick-buy-container').toggleClass('active');
                }
            };

            // swatches: function(){
            //     var self = this;
            //     // Init Shopify option selector
            //     // Option init and Swatch init needed to be separated
            //     new Shopify.OptionSelectors('productSelect', {
            //         product: self.productJSON,
            //         onVariantSelected: ShopifyAPI.selectCallback,
            //         enableHistoryState: true
            //     });
            //     OneSwatches.init({ el: self.$content, preSelect: true, product: self.productJSON });
            // },

            _.each($products, function(item){
                var $product = $(item);
                if ($product.find('.quick-buy-container').length) {
                    var $form = $product.find('form'),
                    pid = $product.data('id'),
                    pdata = $product.find('[data-product-json]').length ? JSON.parse($product.find('[data-product-json]').html()) : false;

                    new Shopify.OptionSelectors('productSelect-' + pid, {
                        product: pdata,
                        onVariantSelected: ShopifyAPI.selectCallback,
                        enableHistoryState: false
                    });

                    OneSwatches.init({ el: $product, preSelect: true, product: pdata });

                    $product.find('.quick-buy-container').addClass('initialized');
                }
            });

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        infinityScroll: function () {
            var self = this;
            var events = {
                'click .item a' : function(e){
                    var $curr = $(e.currentTarget);
                    var $item = $curr.parents('.item');
                    var pageIndex = $item.data('page');
                    e.preventDefault();
                    if (pageIndex) {
                        var currentUrl = ORW.utilities.getUrlParam(window.location.href,'page', pageIndex);
                        window.history.pushState(null, null, currentUrl);
                    }
                    window.location.href = $curr.prop('href');
                }
            };
            var loadMore = function(prev){ // Passing param to determin whether loading next page or prev
                var addPage = function(d){
                    var $content = $(d).find('.product-collection');
                    var $pager = $content.find('.collection-pagination');
                    var $newItems = $content.find('.collection-products .item');
                    var loadingPageNum = ORW.utilities.getUrlParam(self.url,'page');
                    var afterAppend = function (index, item) {

                        $(item).data('page',loadingPageNum);

                        if (index == $newItems.length-1) {
                            // Perform re-init of product grid if needed
                            ORW.rebuildListing();

                            // Need to re-init ajax cart
                            $('.add-to-cart-form').off('submit');
                            ajaxCart.init({
                                formSelector: '.add-to-cart-form',
                                addToCartSelector: '.add-to-cart-btn',
                                cartContainer: '#CartContainer',
                                cartCountSelector: '.minicart-count',
                                cartCostSelector: '#CartCost',
                                moneyFormat: theme.moneyFormat
                            });

                            ORW.isLoading = false;

                            if (prev) {
                                loadMore(true); // Recursive!!
                                $('html, body').animate({
                                    scrollTop: self.$productGrid.prop("scrollHeight")
                                }, 0);
                            } else {
                                return false;
                            }
                        }
                    }

                    ORW.pagerStack.push(self.url);

                    if (!ORW.isFinished) {
                        self.$pager = $pager;
                        $newItems.prependTo(self.$productGrid).each(afterAppend);
                    } else {
                        self.$pager.replaceWith($pager);
                        self.$pager = $pager;
                        $newItems.appendTo(self.$productGrid).each(afterAppend);
                        window.history.pushState(null, null, self.url);
                    }

                }

                // Start of Load More
                if (!ORW.isLoading) {
                    var status = prev ? 'prev' : 'next';
                    if (ORW.isFinished) {
                        // Load next page
                        self.url = self.$pager.find('.next a').length ? self.$pager.find('.next a').attr('href') : '';
                    } else {
                        // Load prev page
                        self.url = self.$pager.find('.prev a').length ? self.$pager.find('.prev a').attr('href') : '';
                    }

                    if ($.inArray(self.url, ORW.pagerStack) == -1 && self.url) {
                        console.log('load ' + status);
                        ORW.isLoading = true;
                        $.get(self.url).done(addPage);
                    } else {
                        if (prev) {
                            ORW.isFinished = true;
                            console.log('load prev finished');
                        } else {
                            $('#loadmore').addClass('disabled');
                            return false;
                        }
                    }
                }
            }

            // Load Prev Page Trigger
            loadMore(true);

            // Load Next Page Triggers
            if ($('#loadmore:in-viewport').length) {
		    	loadMore();
		    }
		    $(window).on('scroll.listview', function () {
				if ($('#loadmore:in-viewport').length) {
			    	loadMore();
			    }
			});

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        glowingText: function () {
            var $glowingTexts = $('.glowing-text'); // Div injected by liquid section
            if (!$glowingTexts.length) return; // section is not enabled

            var $glowingTextEl = $($glowingTexts[0]); // Use only the first included section

            var textValues = $glowingTextEl.data('text-values') || '';
            var pagination = $glowingTextEl.data('collection-pagination') || 0;
            var textColor = $glowingTextEl.data('text-color') || 'black';

            var textValues = textValues.replace(/;$/, '').split(';');

            if (!textValues.length) {
                console.warn('No text provided to glowing text module');
                return;
            }

            var randomNumber = Math.floor(Math.random() * textValues.length);
            var randomText = textValues[randomNumber];

            var insertAfterItem = 11;

            if (pagination && pagination >= insertAfterItem) {
                // Add banner text after (4 * n) row

                setTimeout(function () {
                    var $banner = $('<div class="glowing-banner"><h1 style="color: ' + textColor + ';">'+ randomText +'</h1></div>');
                    var $items = $('.item');
                    var promoOffset = 0; // Used to offset grid count by 1, if an in-grid promo is present (since it takes up two columns)

                    window.the_items = $items;
                    $items.slice(0, insertAfterItem).each(function () {
                        var $item = $(this);

                        if ($item.hasClass('in-grid-promo')) {
                            // Is an in-grid promo

                            // Since an in grid promo takes up 2 columns,
                            // there will only be (19 - n) items
                            // where 19 is the first 20 items (5 rows of 4, 0 index based)
                            // and n == total in-grid promos
                            promoOffset -= 1;
                        }
                    });

                    var offset = insertAfterItem + promoOffset;

                    var $itemToInsertAfter = $($('.item').get(offset));

                    $banner.insertAfter($itemToInsertAfter);
                }, 1000);
            }
        },

        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        },

        destroy: function() {
            var self = this;
            self.undelegateEvents();
            // self.swatches.destroy();
            $(window).off('scroll.listview');
        }

    });

    return ViewCollection;

});
define('view-collectionNav',[
    'jquery',
    'jquery.scrolltofixed'
], function ($) {

    "use strict";

    var ViewCollectionNav = Backbone.View.extend({

        initialize: function (opts) {
            var self = this;
            self.$nav = self.$el;
            self.$sorter = self.$nav.find('.collection-nav-block.sorting');
            self.$filter = self.$nav.find('.collection-nav-block.filters');
            self.$body = $('body');
            self.$header = $('header.site-header');
            self.$footer = $('footer.site-footer');

            self.prepareParams();
            self.navDropdown();
            self.navFix();
            self.initSorting();
            self.initFiltering();

            var collectionHeaderHeight = $($('.collection-header')[0]).height();

            $(window).scroll(function () {
              if ($(this).scrollTop() > collectionHeaderHeight) {
                self.$header.addClass('scrolled');
              } else {
                self.$header.removeClass('scrolled');
              }
            });
        },

        events: {

        },

        prepareParams: function(){
            var self = this;
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    // console.log(aKeyValue);
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }

            // Clean the pagination
            delete Shopify.queryParams.page;
            delete Shopify.queryParams.showAll;

            if (!$.isEmptyObject(Shopify.queryParams)) {
                $('.collection-nav-block.clear-all').removeClass('hide');
                $('.clear-all.clear-all-sort').removeClass('hide');
            }
        },

        navDropdown: function(){
            var self = this;
            var events = {
                'click .collection-nav' : function(e){
                    e.stopPropagation();
                },
                'click .nav-title:not(.clear-all-ctl)' : function(e){
                    e.preventDefault();
                    e.stopPropagation();
                    var $curr = $(e.currentTarget);
                    if ($curr.parent().hasClass('opened')) {
                        $curr.parent().removeClass('opened');
                        self.$body.removeClass('collection-nav-opened');
                    } else {
                        self.$body.addClass('collection-nav-opened');
                        $curr.parent().siblings('.collection-nav-block').removeClass('opened');
                        $curr.parent().addClass('opened');
                    }
                },
                'click .mobile-nav-close' : function(e){
                    var $curr = $(e.currentTarget);
                    self.$body.removeClass('collection-nav-opened');
                    $curr.siblings('.collection-nav-block').removeClass('opened');
                }
            };

            // Click outside to close
            $(window).on('click', function (e) {
                self.$body.removeClass('collection-nav-opened');
                self.$nav.find('.collection-nav-block').removeClass('opened');
            });

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        navFix: function(){
            var self = this,
                lastScrollTop = 0;

            var topOffset = 60;
            if(self.isDesktop()){
                topOffset = 70;
            }
            // var $promoBanner = $('.promo-banner.activate');
            // if ($promoBanner) topOffset -= $promoBanner.outerHeight(true);
            // console.log($promoBanner.outerHeight(true));

            self.$nav.scrollToFixed({
                removeOffsets: true,
                spacerClass: 'fixed',
                zIndex: 999,
                dontSetWidth: true,
                marginTop: topOffset,
                limit: function() {
                    var limit = self.$footer.offset().top - self.$nav.outerHeight(true);
                    return limit;
                }
            });
        },

        initSorting: function(){
            var self = this;
            var events = {
                'click .collection-nav-block.sorting .filter' : function(e){
                    e.preventDefault();
                    var $curr = $(e.currentTarget),
                        sortVal = $curr.data('link');

                    if (sortVal != '') {
                        $curr.addClass('active').siblings('.filter').removeClass('active');
                        Shopify.queryParams.sort_by = $curr.data('link');
                    } else {
                        delete Shopify.queryParams.sort_by;
                    }

                    location.search = $.param(Shopify.queryParams);
                }
            }

            // Active Status
            if (Shopify.queryParams.sort_by) {
                self.$sorter.find('*[data-link="' + Shopify.queryParams.sort_by + '"]').addClass('active');
            }else{
                self.$sorter.find('*[data-link=""]').addClass('active');
            }

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        initFiltering: function(){
            var self = this;
            var $filterSelects = self.$filter.find('select');
            var events = {
                'click .collection-nav-block.filters .filter-swatch' : function(e){
                    e.preventDefault();
                    var $curr = $(e.currentTarget),
                        $filterParent = $curr.parents('.filter'),
                        $fitlerSelect = $filterParent.find('select'),
                        filterVal = $curr.data('link');

                    if ($curr.hasClass('disabled')) {
                        return false;
                    }

                    if (filterVal !== '') {
                        $curr.addClass('active').siblings('.filter-swatch').removeClass('active');
                        $fitlerSelect.val(filterVal).change();
                    } else {
                        var newURL = '/collections/' + Shopify.collectionHandle;
                        var search = $.param(Shopify.queryParams);
                        if (search.length) {
                            newURL += '?' + search;
                        }
                        location.href = newURL;
                    }

                },
                'change .collection-nav-block.filters select' : function(e){
                    delete Shopify.queryParams.page;
                    var newTags = [];
                    _.each($filterSelects, function(select){
                        if ($(select).val()) {
                            newTags.push($(select).val());
                        }
                    });

                    if (Shopify.collectionHandle) {
                        // PLP
                        var newURL = '/collections/' + Shopify.collectionHandle;
                        var search = $.param(Shopify.queryParams);

                        if (newTags.length) {
                            newURL += '/' + newTags.join('+');
                        }
                        if (search.length) {
                            newURL += '?' + search;
                        }

                        location.href = newURL;
                    } else {
                        // Search
                        if (newTags.length) {
                            Shopify.queryParams.constraint = newTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }

                        location.search = $.param(Shopify.queryParams);
                    }
                }
            }

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        destroy: function() {
            var self = this;
            self.undelegateEvents();
        },

        isDesktop: function () {
            var self = this;
            var w = $(window).width();
            if (w > ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        },

        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.medium) {
                return true;
            }
            return false;
        }

    });

    return ViewCollectionNav;

});

define('page-collection',[
    "view-collection", // ViewCollection
    "view-collectionNav", // ViewCollectionNav
    "domReady",
    "jquery"
], function (ViewCollection, ViewCollectionNav, domReady, $) {

    "use strict";
    
    var collection,
        rebuilt = false;
    
    // For lazy loading
    ORW.pagerStack = [];
    ORW.isLoading = false;
    ORW.isFinished = false;
        
    function rebuildListing() {
      if (rebuilt) {
        console.log('rebuilt listing');
      } else {
        console.log('init listing');
      }

      if (collection) {
        collection.destroy();
      }

      collection = document.querySelector('.product-collection') ? new ViewCollection({el: document.querySelector('.product-collection') }) : false;

      if (!rebuilt) rebuilt = true;
    }

    // Global requires
    domReady(function(){
        $('.collection-nav').length && new ViewCollectionNav({el: $('.collection-nav') });
        ORW.rebuildListing();

        $('#isp_refine_nevigation').append('<i class="dropdown-chevron icon-chevron-down-small"></i>')
        $('#isp_refine_nevigation').append('<i class="dropdown-chevron icon-chevron-up-small"></i>')

        $('.dropdown-toggle-isp .caret').remove();
        $('.dropdown-toggle-isp').append('<i class="dropdown-chevron icon-chevron-down-small"></i>')
        $('.dropdown-toggle-isp').append('<i class="dropdown-chevron icon-chevron-up-small"></i>')

        $(document).on("click", "a.iWishAdd" , function(e) {
          e.preventDefault();
          const variantId = $(this).data('product').toString();
          iwish_add($(this), variantId);
        });
    });
});

if ($(document.body).hasClass('template-collection')) {
    window.addEventListener('fs-serprender', function(event) {

        var currencyFormatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: 'USD'
        });

        for(var id in ISP_PRODUCTS) {
            var product = ISP_PRODUCTS[id];
            var tags = product.att[1][1];
            var price = currencyFormatter.format(parseFloat(product.p)).replace('.00','');
            var price_compare = currencyFormatter.format(parseFloat(product.p_c)).replace('.00','');
            var vendor = product.v;

            tags.forEach(function(tag) {
                if(tag.includes('badge_')) {
                    var badgeText = tag.replace('badge_','');
                    $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info .badge').remove();
                    $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info').append('<p class="badge">'+badgeText+'</p>');
                }
            })

            let discount = tags.find(function(tag) { return tag.includes('discount:'); });
            if(discount !== undefined) {
                let discountText = discount.replace('discount:', '');
                //Remove handles case of multiple fs-serprender events
                $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info .discount').remove();
                $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info').append('<p class="discount">'+discountText+'</p>');
            }

            $('li.isp_grid_product[product_id="'+product.id+'"] .isp_compare_at_price').text(price_compare);
            $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_price').text(price);

            $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info .designer-name').remove();
            $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info')
                .prepend('<p class="designer-name">'+vendor+'</p>');
        }
    })
};
(function($){

  $.event.special.doubletap = {
    bindType: 'touchend',
    delegateType: 'touchend',

    handle: function(event) {
      var handleObj   = event.handleObj,
          targetData  = jQuery.data(event.target),
          now         = new Date().getTime(),
          delta       = targetData.lastTouch ? now - targetData.lastTouch : 0,
          delay       = delay == null ? 300 : delay;

      if (delta < delay && delta > 30) {
        targetData.lastTouch = null;
        event.type = handleObj.origType;
        ['clientX', 'clientY', 'pageX', 'pageY'].forEach(function(property) {
          event[property] = event.originalEvent.changedTouches[0][property];
        })

        // let jQuery handle the triggering of "doubletap" event handlers
        handleObj.handler.apply(this, arguments);
      } else {
        targetData.lastTouch = now;
      }
    }
  };

})(jQuery);
define("jquery.doubletap", ["jquery"], function(){});

/**
 * @license jquery.panzoom.js v3.2.2
 * Updated: Wed Jun 21 2017
 * Add pan and zoom functionality to any element
 * Copyright (c) timmy willison
 * Released under the MIT license
 * https://github.com/timmywil/jquery.panzoom/blob/master/MIT-License.txt
 */

(function(global, factory) {
	// AMD
	if (typeof define === 'function' && define.amd) {
		define('jquery.panzoom',[ 'jquery' ], function(jQuery) {
			return factory(global, jQuery);
		});
	// CommonJS/Browserify
	} else if (typeof exports === 'object') {
		factory(global, require('jquery'));
	// Global
	} else {
		factory(global, global.jQuery);
	}
}(typeof window !== 'undefined' ? window : this, function(window, $) {
	'use strict';

	var document = window.document;
	var datakey = '__pz__';
	var slice = Array.prototype.slice;
	var rIE11 = /trident\/7./i;
	var supportsInputEvent = (function() {
		// IE11 returns a false positive
		if (rIE11.test(navigator.userAgent)) {
			return false;
		}
		var input = document.createElement('input');
		input.setAttribute('oninput', 'return');
		return typeof input.oninput === 'function';
	})();

	// Regex
	var rupper = /([A-Z])/g;
	var rsvg = /^http:[\w\.\/]+svg$/;

	var floating = '(\\-?\\d[\\d\\.e-]*)';
	var commaSpace = '\\,?\\s*';
	var rmatrix = new RegExp(
		'^matrix\\(' +
		floating + commaSpace +
		floating + commaSpace +
		floating + commaSpace +
		floating + commaSpace +
		floating + commaSpace +
		floating + '\\)$'
	);

	/**
	 * Utility for determining transform matrix equality
	 * Checks backwards to test translation first
	 * @param {Array} first
	 * @param {Array} second
	 */
	function matrixEquals(first, second) {
		var i = first.length;
		while(--i) {
			if (Math.round(+first[i]) !== Math.round(+second[i])) {
				return false;
			}
		}
		return true;
	}

	/**
	 * Creates the options object for reset functions
	 * @param {Boolean|Object} opts See reset methods
	 * @returns {Object} Returns the newly-created options object
	 */
	function createResetOptions(opts) {
		var options = { range: true, animate: true };
		if (typeof opts === 'boolean') {
			options.animate = opts;
		} else {
			$.extend(options, opts);
		}
		return options;
	}

	/**
	 * Represent a transformation matrix with a 3x3 matrix for calculations
	 * Matrix functions adapted from Louis Remi's jQuery.transform (https://github.com/louisremi/jquery.transform.js)
	 * @param {Array|Number} a An array of six values representing a 2d transformation matrix
	 */
	function Matrix(a, b, c, d, e, f, g, h, i) {
		if ($.type(a) === 'array') {
			this.elements = [
				+a[0], +a[2], +a[4],
				+a[1], +a[3], +a[5],
				    0,     0,     1
			];
		} else {
			this.elements = [
				a, b, c,
				d, e, f,
				g || 0, h || 0, i || 1
			];
		}
	}

	Matrix.prototype = {
		/**
		 * Multiply a 3x3 matrix by a similar matrix or a vector
		 * @param {Matrix|Vector} matrix
		 * @return {Matrix|Vector} Returns a vector if multiplying by a vector
		 */
		x: function(matrix) {
			var isVector = matrix instanceof Vector;

			var a = this.elements,
				b = matrix.elements;

			if (isVector && b.length === 3) {
				// b is actually a vector
				return new Vector(
					a[0] * b[0] + a[1] * b[1] + a[2] * b[2],
					a[3] * b[0] + a[4] * b[1] + a[5] * b[2],
					a[6] * b[0] + a[7] * b[1] + a[8] * b[2]
				);
			} else if (b.length === a.length) {
				// b is a 3x3 matrix
				return new Matrix(
					a[0] * b[0] + a[1] * b[3] + a[2] * b[6],
					a[0] * b[1] + a[1] * b[4] + a[2] * b[7],
					a[0] * b[2] + a[1] * b[5] + a[2] * b[8],

					a[3] * b[0] + a[4] * b[3] + a[5] * b[6],
					a[3] * b[1] + a[4] * b[4] + a[5] * b[7],
					a[3] * b[2] + a[4] * b[5] + a[5] * b[8],

					a[6] * b[0] + a[7] * b[3] + a[8] * b[6],
					a[6] * b[1] + a[7] * b[4] + a[8] * b[7],
					a[6] * b[2] + a[7] * b[5] + a[8] * b[8]
				);
			}
			return false; // fail
		},
		/**
		 * Generates an inverse of the current matrix
		 * @returns {Matrix}
		 */
		inverse: function() {
			var d = 1 / this.determinant(),
				a = this.elements;
			return new Matrix(
				d * ( a[8] * a[4] - a[7] * a[5]),
				d * (-(a[8] * a[1] - a[7] * a[2])),
				d * ( a[5] * a[1] - a[4] * a[2]),

				d * (-(a[8] * a[3] - a[6] * a[5])),
				d * ( a[8] * a[0] - a[6] * a[2]),
				d * (-(a[5] * a[0] - a[3] * a[2])),

				d * ( a[7] * a[3] - a[6] * a[4]),
				d * (-(a[7] * a[0] - a[6] * a[1])),
				d * ( a[4] * a[0] - a[3] * a[1])
			);
		},
		/**
		 * Calculates the determinant of the current matrix
		 * @returns {Number}
		 */
		determinant: function() {
			var a = this.elements;
			return a[0] * (a[8] * a[4] - a[7] * a[5]) - a[3] * (a[8] * a[1] - a[7] * a[2]) + a[6] * (a[5] * a[1] - a[4] * a[2]);
		}
	};

	/**
	 * Create a vector containing three values
	 */
	function Vector(x, y, z) {
		this.elements = [ x, y, z ];
	}

	/**
	 * Get the element at zero-indexed index i
	 * @param {Number} i
	 */
	Vector.prototype.e = Matrix.prototype.e = function(i) {
		return this.elements[ i ];
	};

	/**
	 * Create a Panzoom object for a given element
	 * @constructor
	 * @param {Element} elem - Element to use pan and zoom
	 * @param {Object} [options] - An object literal containing options to override default options
	 *  (See Panzoom.defaults for ones not listed below)
	 * @param {jQuery} [options.$zoomIn] - zoom in buttons/links collection (you can also bind these yourself
	 *  e.g. $button.on('click', function(e) { e.preventDefault(); $elem.panzoom('zoomIn'); });)
	 * @param {jQuery} [options.$zoomOut] - zoom out buttons/links collection on which to bind zoomOut
	 * @param {jQuery} [options.$zoomRange] - zoom in/out with this range control
	 * @param {jQuery} [options.$reset] - Reset buttons/links collection on which to bind the reset method
	 * @param {Function} [options.on[Start|Change|Zoom|Pan|End|Reset] - Optional callbacks for panzoom events
	 */
	function Panzoom(elem, options) {

		// Allow instantiation without `new` keyword
		if (!(this instanceof Panzoom)) {
			return new Panzoom(elem, options);
		}

		// Sanity checks
		if (elem.nodeType !== 1) {
			$.error('Panzoom called on non-Element node');
		}
		if (!$.contains(document, elem)) {
			$.error('Panzoom element must be attached to the document');
		}

		// Don't remake
		var d = $.data(elem, datakey);
		if (d) {
			return d;
		}

		// Extend default with given object literal
		// Each instance gets its own options
		this.options = options = $.extend({}, Panzoom.defaults, options);
		this.elem = elem;
		var $elem = this.$elem = $(elem);
		this.$set = options.$set && options.$set.length ? options.$set : $elem;
		this.$doc = $(elem.ownerDocument || document);
		this.$parent = $elem.parent();
		this.parent = this.$parent[0];

		// This is SVG if the namespace is SVG
		// However, while <svg> elements are SVG, we want to treat those like other elements
		this.isSVG = rsvg.test(elem.namespaceURI) && elem.nodeName.toLowerCase() !== 'svg';

		this.panning = false;

		// Save the original transform value
		// Save the prefixed transform style key
		// Set the starting transform
		this._buildTransform();

		// Build the appropriately-prefixed transform style property name
		// De-camelcase
		this._transform = $.cssProps.transform.replace(rupper, '-$1').toLowerCase();

		// Build the transition value
		this._buildTransition();

		// Build containment dimensions
		this.resetDimensions();

		// Add zoom and reset buttons to `this`
		var $empty = $();
		var self = this;
		$.each([ '$zoomIn', '$zoomOut', '$zoomRange', '$reset' ], function(i, name) {
			self[ name ] = options[ name ] || $empty;
		});

		this.enable();

		this.scale = this.getMatrix()[0];
		this._checkPanWhenZoomed();

		// Save the instance
		$.data(elem, datakey, this);
	}

	// Attach regex for possible use (immutable)
	Panzoom.rmatrix = rmatrix;

	Panzoom.defaults = {
		// Should always be non-empty
		// Used to bind jQuery events without collisions
		// A guid is not added here as different instantiations/versions of panzoom
		// on the same element is not supported, so don't do it.
		eventNamespace: '.panzoom',

		// Whether or not to transition the scale
		transition: true,

		// Default cursor style for the element
		cursor: 'move',

		// There may be some use cases for zooming without panning or vice versa
		disablePan: false,
		disableZoom: false,

		// Pan only on the X or Y axes
		disableXAxis: false,
		disableYAxis: false,

		// Set whether you'd like to pan on left (1), middle (2), or right click (3)
		which: 1,

		// The increment at which to zoom
		// Should be a number greater than 0
		increment: 0.3,

		// When no scale is passed, this option tells
		// the `zoom` method to increment
		// the scale *linearly* based on the increment option.
		// This often ends up looking like very little happened at larger zoom levels.
		// The default is to multiply/divide the scale based on the increment.
		linearZoom: false,

		// Pan only when the scale is greater than minScale
		panOnlyWhenZoomed: false,

		// min and max zoom scales
		minScale: 0.3,
		maxScale: 6,

		// The default step for the range input
		// Precendence: default < HTML attribute < option setting
		rangeStep: 0.05,

		// Animation duration (ms)
		duration: 200,
		// CSS easing used for scale transition
		easing: 'ease-in-out',

		// Indicate that the element should be contained within it's parent when panning
		// Note: this does not affect zooming outside of the parent
		// Set this value to 'invert' to only allow panning outside of the parent element (basically the opposite of the normal use of contain)
		// 'invert' is useful for a large panzoom element where you don't want to show anything behind it
		contain: false
	};

	Panzoom.prototype = {
		constructor: Panzoom,

		/**
		 * @returns {Panzoom} Returns the instance
		 */
		instance: function() {
			return this;
		},

		/**
		 * Enable or re-enable the panzoom instance
		 */
		enable: function() {
			// Unbind first
			this._initStyle();
			this._bind();
			this.disabled = false;
		},

		/**
		 * Disable panzoom
		 */
		disable: function() {
			this.disabled = true;
			this._resetStyle();
			this._unbind();
		},

		/**
		 * @returns {Boolean} Returns whether the current panzoom instance is disabled
		 */
		isDisabled: function() {
			return this.disabled;
		},

		/**
		 * Destroy the panzoom instance
		 */
		destroy: function() {
			this.disable();
			$.removeData(this.elem, datakey);
		},

		/**
		 * Builds the restricing dimensions from the containment element
		 * Also used with focal points
		 * Call this method whenever the dimensions of the element or parent are changed
		 */
		resetDimensions: function() {
			// Reset container properties
			this.container = this.parent.getBoundingClientRect();

			// Set element properties
			var elem = this.elem;
			// getBoundingClientRect() works with SVG, offsetWidth does not
			var dims = elem.getBoundingClientRect();
			var absScale = Math.abs(this.scale);
			this.dimensions = {
				width: dims.width,
				height: dims.height,
				left: $.css(elem, 'left', true) || 0,
				top: $.css(elem, 'top', true) || 0,
				// Borders and margins are scaled
				border: {
					top: $.css(elem, 'borderTopWidth', true) * absScale || 0,
					bottom: $.css(elem, 'borderBottomWidth', true) * absScale || 0,
					left: $.css(elem, 'borderLeftWidth', true) * absScale || 0,
					right: $.css(elem, 'borderRightWidth', true) * absScale || 0
				},
				margin: {
					top: $.css(elem, 'marginTop', true) * absScale || 0,
					left: $.css(elem, 'marginLeft', true) * absScale || 0
				}
			};
		},

		/**
		 * Return the element to it's original transform matrix
		 * @param {Boolean} [options] If a boolean is passed, animate the reset (default: true). If an options object is passed, simply pass that along to setMatrix.
		 * @param {Boolean} [options.silent] Silence the reset event
		 */
		reset: function(options) {
			options = createResetOptions(options);
			// Reset the transform to its original value
			var matrix = this.setMatrix(this._origTransform, options);
			if (!options.silent) {
				this._trigger('reset', matrix);
			}
		},

		/**
		 * Only resets zoom level
		 * @param {Boolean|Object} [options] Whether to animate the reset (default: true) or an object of options to pass to zoom()
		 */
		resetZoom: function(options) {
			options = createResetOptions(options);
			var origMatrix = this.getMatrix(this._origTransform);
			options.dValue = origMatrix[ 3 ];
			this.zoom(origMatrix[0], options);
		},

		/**
		 * Only reset panning
		 * @param {Boolean|Object} [options] Whether to animate the reset (default: true) or an object of options to pass to pan()
		 */
		resetPan: function(options) {
			var origMatrix = this.getMatrix(this._origTransform);
			this.pan(origMatrix[4], origMatrix[5], createResetOptions(options));
		},

		/**
		 * Sets a transform on the $set
		 * For SVG, the style attribute takes precedence
		 * and allows us to animate
		 * @param {String} transform
		 */
		setTransform: function(transform) {
			var $set = this.$set;
			var i = $set.length;
			while(i--) {
				$.style($set[i], 'transform', transform);

				// Support IE9-11, Edge 13-14+
				// Set attribute alongside style attribute
				// since IE and Edge do not respect style settings on SVG
				// See https://css-tricks.com/transforms-on-svg-elements/
				if (this.isSVG) {
					$set[i].setAttribute('transform', transform);
				}
			}
		},

		/**
		 * Retrieving the transform is different for SVG
		 *  (unless a style transform is already present)
		 * Uses the $set collection for retrieving the transform
		 * @param {String} [transform] Pass in an transform value (like 'scale(1.1)')
		 *  to have it formatted into matrix format for use by Panzoom
		 * @returns {String} Returns the current transform value of the element
		 */
		getTransform: function(transform) {
			var $set = this.$set;
			var transformElem = $set[0];
			if (transform) {
				this.setTransform(transform);
			} else {

				// IE and Edge still set the transform style properly
				// They just don't render it on SVG
				// So we get a correct value here
				transform = $.style(transformElem, 'transform');

				if (this.isSVG && (!transform || transform === 'none')) {
					transform = $.attr(transformElem, 'transform') || 'none';
				}
			}

			// Convert any transforms set by the user to matrix format
			// by setting to computed
			if (transform !== 'none' && !rmatrix.test(transform)) {

				// Get computed and set for next time
				this.setTransform(transform = $.css(transformElem, 'transform'));
			}

			return transform || 'none';
		},

		/**
		 * Retrieve the current transform matrix for $elem (or turn a transform into it's array values)
		 * @param {String} [transform] matrix-formatted transform value
		 * @returns {Array} Returns the current transform matrix split up into it's parts, or a default matrix
		 */
		getMatrix: function(transform) {
			var matrix = rmatrix.exec(transform || this.getTransform());
			if (matrix) {
				matrix.shift();
			}
			return matrix || [ 1, 0, 0, 1, 0, 0 ];
		},

		/**
		 * Get the current scale.
		 * @param {String} [transform] matrix-formatted transform value
		 * @returns {Number} Current scale relative to the initial scale (height / width = 1)
		 */
		getScale: function(matrix) {
			return Math.sqrt(Math.pow(matrix[0], 2) + Math.pow(matrix[1], 2));
		},

		/**
		 * Given a matrix object, quickly set the current matrix of the element
		 * @param {Array|String} matrix
		 * @param {Object} [options]
		 * @param {Boolean|String} [options.animate] Whether to animate the transform change, or 'skip' indicating that it is unnecessary to set
		 * @param {Boolean} [options.contain] Override the global contain option
		 * @param {Boolean} [options.range] If true, $zoomRange's value will be updated.
		 * @param {Boolean} [options.silent] If true, the change event will not be triggered
		 * @returns {Array} Returns the newly-set matrix
		 */
		setMatrix: function(matrix, options) {
			if (this.disabled) { return; }
			if (!options) { options = {}; }
			// Convert to array
			if (typeof matrix === 'string') {
				matrix = this.getMatrix(matrix);
			}
			var scale = this.getScale(matrix);
			var contain = typeof options.contain !== 'undefined' ? options.contain : this.options.contain;

			// Apply containment
			if (contain) {
				var dims = options.dims;
				if (!dims) {
					this.resetDimensions();
					dims = this.dimensions;
				}
				var spaceWLeft, spaceWRight, scaleDiff;
				var container = this.container;
				var width = dims.width;
				var height = dims.height;
				var conWidth = container.width;
				var conHeight = container.height;
				var zoomAspectW = conWidth / width;
				var zoomAspectH = conHeight / height;

				// If the element is not naturally centered,
				// assume full space right
				if (this.$parent.css('textAlign') !== 'center' || $.css(this.elem, 'display') !== 'inline') {
					// offsetWidth gets us the width without the transform
					scaleDiff = (width - this.elem.offsetWidth) / 2;
					spaceWLeft = scaleDiff - dims.border.left;
					spaceWRight = width - conWidth - scaleDiff + dims.border.right;
				} else {
					spaceWLeft = spaceWRight = ((width - conWidth) / 2);
				}
				// Yang@Onerockwell Fix for contain invert vertical range 
				// var spaceHTop = ((height - conHeight) / 2) + dims.border.top;
				var spaceHTop = 0;
				var spaceHBottom = ((height - conHeight) / 2) - dims.border.top - dims.border.bottom;

				if (contain === 'invert' || contain === 'automatic' && zoomAspectW < 1.01) {
					matrix[4] = Math.max(Math.min(matrix[4], spaceWLeft - dims.border.left), -spaceWRight);
				} else {
					matrix[4] = Math.min(Math.max(matrix[4], spaceWLeft), -spaceWRight);
				}
				if (contain === 'invert' || (contain === 'automatic' && zoomAspectH < 1.01)) {
					// Yang@Onerockwell Fix for contain invert vertical range 
					// matrix[5] = Math.max(Math.min(matrix[5], spaceHTop - dims.border.top), -spaceHBottom);
					matrix[5] = Math.max(Math.min(matrix[5], spaceHTop - dims.border.top), -spaceHBottom*2);
				} else {
					matrix[5] = Math.min(Math.max(matrix[5], spaceHTop), -spaceHBottom);
				}
			}

			// Animate
			if (options.animate !== 'skip') {
				// Set transition
				this.transition(!options.animate);
			}

			// Update range element
			if (options.range) {
				this.$zoomRange.val(scale);
			}

			// Set the matrix on this.$set
			if (this.options.disableXAxis || this.options.disableYAxis) {
				var originalMatrix = this.getMatrix();
				if (this.options.disableXAxis) {
					matrix[4] = originalMatrix[4];
				}
				if (this.options.disableYAxis) {
					matrix[5] = originalMatrix[5];
				}
			}
			this.setTransform('matrix(' + matrix.join(',') + ')');

			this.scale = scale;

			// Disable/enable panning if zooming is at minimum and panOnlyWhenZoomed is true
			this._checkPanWhenZoomed(scale);

			if (!options.silent) {
				this._trigger('change', matrix);
			}

			return matrix;
		},

		/**
		 * @returns {Boolean} Returns whether the panzoom element is currently being dragged
		 */
		isPanning: function() {
			return this.panning;
		},

		/**
		 * Apply the current transition to the element, if allowed
		 * @param {Boolean} [off] Indicates that the transition should be turned off
		 */
		transition: function(off) {
			if (!this._transition) { return; }
			var transition = off || !this.options.transition ? 'none' : this._transition;
			var $set = this.$set;
			var i = $set.length;
			while(i--) {
				// Avoid reflows when zooming
				if ($.style($set[i], 'transition') !== transition) {
					$.style($set[i], 'transition', transition);
				}
			}
		},

		/**
		 * Pan the element to the specified translation X and Y
		 * Note: this is not the same as setting jQuery#offset() or jQuery#position()
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Object} [options] These options are passed along to setMatrix
		 * @param {Array} [options.matrix] The matrix being manipulated (if already known so it doesn't have to be retrieved again)
		 * @param {Boolean} [options.silent] Silence the pan event. Note that this will also silence the setMatrix change event.
		 * @param {Boolean} [options.relative] Make the x and y values relative to the existing matrix
		 */
		pan: function(x, y, options) {
			if (this.options.disablePan) { return; }
			if (!options) { options = {}; }
			var matrix = options.matrix;
			if (!matrix) {
				matrix = this.getMatrix();
			}
			// Cast existing matrix values to numbers
			if (options.relative) {
				x += +matrix[4];
				y += +matrix[5];
			}
			matrix[4] = x;
			matrix[5] = y;
			this.setMatrix(matrix, options);
			if (!options.silent) {
				this._trigger('pan', matrix[4], matrix[5]);
			}
		},

		/**
		 * Zoom in/out the element using the scale properties of a transform matrix
		 * @param {Number|Boolean} [scale] The scale to which to zoom or a boolean indicating to transition a zoom out
		 * @param {Object} [opts] All global options can be overwritten by this options object. For example, override the default increment.
		 * @param {Boolean} [opts.noSetRange] Specify that the method should not set the $zoomRange value (as is the case when $zoomRange is calling zoom on change)
		 * @param {jQuery.Event|Object} [opts.focal] A focal point on the panzoom element on which to zoom.
		 *  If an object, set the clientX and clientY properties to the position relative to the parent
		 * @param {Boolean} [opts.animate] Whether to animate the zoom (defaults to true if scale is not a number, false otherwise)
		 * @param {Boolean} [opts.silent] Silence the zoom event
		 * @param {Array} [opts.matrix] Optionally pass the current matrix so it doesn't need to be retrieved
		 * @param {Number} [opts.dValue] Think of a transform matrix as four values a, b, c, d
		 *  where a/d are the horizontal/vertical scale values and b/c are the skew values
		 *  (5 and 6 of matrix array are the tx/ty transform values).
		 *  Normally, the scale is set to both the a and d values of the matrix.
		 *  This option allows you to specify a different d value for the zoom.
		 *  For instance, to flip vertically, you could set -1 as the dValue.
		 */
		zoom: function(scale, opts) {
			// Shuffle arguments
			if (typeof scale === 'object') {
				opts = scale;
				scale = null;
			} else if (!opts) {
				opts = {};
			}
			var options = $.extend({}, this.options, opts);
			// Check if disabled
			if (options.disableZoom) { return; }
			var animate = false;
			var matrix = options.matrix || this.getMatrix();
			var surfaceM = new Matrix(matrix);
			var startScale = this.getScale(matrix);

			// Calculate zoom based on increment
			if (typeof scale !== 'number') {
				if (options.linearZoom) {
					scale = 1 + (options.increment * (scale ? -1 : 1)) / startScale;
				} else {
					scale = scale ? (1 / (1 + options.increment)) : (1 + options.increment);
				}
				animate = true;
			} else {
				scale = 1 / startScale;
			}

			// Constrain scale
			scale = Math.max(Math.min(scale, options.maxScale / startScale), options.minScale / startScale);
			var m = surfaceM.x(new Matrix(scale, 0, 0, 0, (typeof options.dValue === 'number' ? options.dValue / startScale : scale), 0));

			// Calculate focal point based on scale
			var focal = options.focal;
			if (focal && !options.disablePan) {
				// Adapted from code by Florian Günther
				// https://github.com/florianguenther/zui53
				this.resetDimensions();
				var dims = options.dims = this.dimensions;
				var clientX = focal.clientX;
				var clientY = focal.clientY;

				// Adjust the focal point for transform-origin 50% 50%
				// SVG elements have a transform origin of 0 0
				if (!this.isSVG) {
					clientX -= (dims.width / startScale) / 2;
					clientY -= (dims.height / startScale) / 2;
				}

				var clientV = new Vector(clientX, clientY, 1);
				// Supply an offset manually if necessary
				var o = this.parentOffset || this.$parent.offset();
				var offsetM = new Matrix(1, 0, o.left - this.$doc.scrollLeft(), 0, 1, o.top - this.$doc.scrollTop());
				var surfaceV = surfaceM.inverse().x(offsetM.inverse().x(clientV));
				surfaceM = surfaceM.x(new Matrix([scale, 0, 0, scale, 0, 0]));
				clientV = offsetM.x(surfaceM.x(surfaceV));
				matrix[4] = +matrix[4] + (clientX - clientV.e(0));
				matrix[5] = +matrix[5] + (clientY - clientV.e(1));
			}

			// Set the scale
			matrix[0] = m.e(0);
			matrix[1] = m.e(3);
			matrix[2] = m.e(1);
			matrix[3] = m.e(4);

			// Calling zoom may still pan the element
			this.setMatrix(matrix, {
				animate: typeof options.animate !== 'undefined' ? options.animate : animate,
				// Set the zoomRange value
				range: !options.noSetRange
			});

			// Trigger zoom event
			if (!options.silent) {
				this._trigger('zoom', scale, options);
			}
		},

		/**
		 * Get/set option on an existing instance
		 * @returns {Array|undefined} If getting, returns an array of all values
		 *   on each instance for a given key. If setting, continue chaining by returning undefined.
		 */
		option: function(key, value) {
			var options;
			if (!key) {
				// Avoids returning direct reference
				return $.extend({}, this.options);
			}

			if (typeof key === 'string') {
				if (arguments.length === 1) {
					return this.options[ key ] !== undefined ?
						this.options[ key ] :
						null;
				}
				options = {};
				options[ key ] = value;
			} else {
				options = key;
			}

			this._setOptions(options);
		},

		/**
		 * Internally sets options
		 * @param {Object} options - An object literal of options to set
		 * @private
		 */
		_setOptions: function(options) {
			$.each(options, $.proxy(function(key, value) {
				switch(key) {
					case 'disablePan':
						this._resetStyle();
						/* falls through */
					case '$zoomIn':
					case '$zoomOut':
					case '$zoomRange':
					case '$reset':
					case 'disableZoom':
					case 'onStart':
					case 'onChange':
					case 'onZoom':
					case 'onPan':
					case 'onEnd':
					case 'onReset':
					case 'eventNamespace':
						this._unbind();
				}
				this.options[ key ] = value;
				switch(key) {
					case 'disablePan':
						this._initStyle();
						/* falls through */
					case '$zoomIn':
					case '$zoomOut':
					case '$zoomRange':
					case '$reset':
						// Set these on the instance
						this[ key ] = value;
						/* falls through */
					case 'disableZoom':
					case 'onStart':
					case 'onChange':
					case 'onZoom':
					case 'onPan':
					case 'onEnd':
					case 'onReset':
					case 'eventNamespace':
						this._bind();
						break;
					case 'cursor':
						$.style(this.elem, 'cursor', value);
						break;
					case 'minScale':
						this.$zoomRange.attr('min', value);
						break;
					case 'maxScale':
						this.$zoomRange.attr('max', value);
						break;
					case 'rangeStep':
						this.$zoomRange.attr('step', value);
						break;
					case 'startTransform':
						this._buildTransform();
						break;
					case 'duration':
					case 'easing':
						this._buildTransition();
						/* falls through */
					case 'transition':
						this.transition();
						break;
					case 'panOnlyWhenZoomed':
						this._checkPanWhenZoomed();
						break;
					case '$set':
						if (value instanceof $ && value.length) {
							this.$set = value;
							// Reset styles
							this._initStyle();
							this._buildTransform();
						}
				}
			}, this));
		},

		/**
		 * Disable/enable panning depending on whether the current scale
		 * matches the minimum
		 * @param {Number} [scale]
		 * @private
		 */
		_checkPanWhenZoomed: function(scale) {
			var options = this.options;
			if (options.panOnlyWhenZoomed) {
				if (!scale) {
					scale = this.getMatrix()[0];
				}
				var toDisable = scale <= options.minScale;
				if (options.disablePan !== toDisable) {
					this.option('disablePan', toDisable);
				}
			}
		},

		/**
		 * Initialize base styles for the element and its parent
		 * @private
		 */
		_initStyle: function() {
			var styles = {
				// Set the same default whether SVG or HTML
				// transform-origin cannot be changed to 50% 50% in IE9-11 or Edge 13-14+
				'transform-origin': this.isSVG ? '0 0' : '50% 50%'
			};
			// Set elem styles
			if (!this.options.disablePan) {
				styles.cursor = this.options.cursor;
			}
			this.$set.css(styles);

			// Set parent to relative if set to static
			var $parent = this.$parent;
			// No need to add styles to the body
			if ($parent.length && !$.nodeName(this.parent, 'body')) {
				styles = {
					overflow: 'hidden'
				};
				if ($parent.css('position') === 'static') {
					styles.position = 'relative';
				}
				$parent.css(styles);
			}
		},

		/**
		 * Undo any styles attached in this plugin
		 * @private
		 */
		_resetStyle: function() {
			this.$elem.css({
				'cursor': '',
				'transition': ''
			});
			this.$parent.css({
				'overflow': '',
				'position': ''
			});
		},

		/**
		 * Binds all necessary events
		 * @private
		 */
		_bind: function() {
			var self = this;
			var options = this.options;
			var ns = options.eventNamespace;
			var str_down = 'mousedown' + ns + ' pointerdown' + ns + ' MSPointerDown' + ns;
			var str_start = 'touchstart' + ns + ' ' + str_down;
			var str_click = 'touchend' + ns + ' click' + ns + ' pointerup' + ns + ' MSPointerUp' + ns;
			var events = {};
			var $reset = this.$reset;
			var $zoomRange = this.$zoomRange;

			// Bind panzoom events from options
			$.each([ 'Start', 'Change', 'Zoom', 'Pan', 'End', 'Reset' ], function() {
				var m = options[ 'on' + this ];
				if ($.isFunction(m)) {
					events[ 'panzoom' + this.toLowerCase() + ns ] = m;
				}
			});

			// Bind $elem drag and click/touchdown events
			// Bind touchstart if either panning or zooming is enabled
			if (!options.disablePan || !options.disableZoom) {
				events[ str_start ] = function(e) {
					var touches;
					if (e.type === 'touchstart' ?
						// Touch
						(touches = e.touches || e.originalEvent.touches) &&
							((touches.length === 1 && !options.disablePan) || touches.length === 2) :
						// Mouse/Pointer: Ignore unexpected click types
						// Support: IE10 only
						// IE10 does not support e.button for MSPointerDown, but does have e.which
						!options.disablePan && (e.which || e.originalEvent.which) === options.which) {

						e.preventDefault();
						e.stopPropagation();
						self._startMove(e, touches);
					}
				};
				// Prevent the contextmenu event
				// if we're binding to right-click
				if (options.which === 3) {
					events.contextmenu = false;
				}
			}
			this.$elem.on(events);

			// Bind reset
			if ($reset.length) {
				$reset.on(str_click, function(e) {
					e.preventDefault();
					self.reset();
				});
			}

			// Set default attributes for the range input
			if ($zoomRange.length) {
				$zoomRange.attr({
					// Only set the range step if explicit or
					// set the default if there is no attribute present
					step: options.rangeStep === Panzoom.defaults.rangeStep &&
						$zoomRange.attr('step') ||
						options.rangeStep,
					min: options.minScale,
					max: options.maxScale
				}).prop({
					value: this.getMatrix()[0]
				});
			}

			// No bindings if zooming is disabled
			if (options.disableZoom) {
				return;
			}

			var $zoomIn = this.$zoomIn;
			var $zoomOut = this.$zoomOut;

			// Bind zoom in/out
			// Don't bind one without the other
			if ($zoomIn.length && $zoomOut.length) {
				// preventDefault cancels future mouse events on touch events
				$zoomIn.on(str_click, function(e) {
					e.preventDefault();
					self.zoom();
				});
				$zoomOut.on(str_click, function(e) {
					e.preventDefault();
					self.zoom(true);
				});
			}

			if ($zoomRange.length) {
				events = {};
				// Cannot prevent default action here
				events[ str_down ] = function() {
					self.transition(true);
				};
				// Zoom on input events if available and change events
				// See https://github.com/timmywil/jquery.panzoom/issues/90
				events[ (supportsInputEvent ? 'input' : 'change') + ns ] = function() {
					self.zoom(+this.value, { noSetRange: true });
				};
				$zoomRange.on(events);
			}
		},

		/**
		 * Unbind all events
		 * @private
		 */
		_unbind: function() {
			this.$elem
				.add(this.$zoomIn)
				.add(this.$zoomOut)
				.add(this.$reset)
				.off(this.options.eventNamespace);
		},

		/**
		 * Builds the original transform value
		 * @private
		 */
		_buildTransform: function() {
			// Save the original transform
			// Retrieving this also adds the correct prefixed style name
			// to jQuery's internal $.cssProps
			return this._origTransform = this.getTransform(this.options.startTransform);
		},

		/**
		 * Set transition property for later use when zooming
		 * @private
		 */
		_buildTransition: function() {
			if (this._transform) {
				var options = this.options;
				this._transition = this._transform + ' ' + options.duration + 'ms ' + options.easing;
			}
		},

		/**
		 * Calculates the distance between two touch points
		 * Remember pythagorean?
		 * @param {Array} touches
		 * @returns {Number} Returns the distance
		 * @private
		 */
		_getDistance: function(touches) {
			var touch1 = touches[0];
			var touch2 = touches[1];
			return Math.sqrt(Math.pow(Math.abs(touch2.clientX - touch1.clientX), 2) + Math.pow(Math.abs(touch2.clientY - touch1.clientY), 2));
		},

		/**
		 * Constructs an approximated point in the middle of two touch points
		 * @returns {Object} Returns an object containing pageX and pageY
		 * @private
		 */
		_getMiddle: function(touches) {
			var touch1 = touches[0];
			var touch2 = touches[1];
			return {
				clientX: ((touch2.clientX - touch1.clientX) / 2) + touch1.clientX,
				clientY: ((touch2.clientY - touch1.clientY) / 2) + touch1.clientY
			};
		},

		/**
		 * Trigger a panzoom event on our element
		 * The event is passed the Panzoom instance
		 * @param {String|jQuery.Event} event
		 * @param {Mixed} arg1[, arg2, arg3, ...] Arguments to append to the trigger
		 * @private
		 */
		_trigger: function (event) {
			if (typeof event === 'string') {
				event = 'panzoom' + event;
			}
			this.$elem.triggerHandler(event, [this].concat(slice.call(arguments, 1)));
		},

		/**
		 * Starts the pan
		 * This is bound to mouse/touchmove on the element
		 * @param {jQuery.Event} event An event with pageX, pageY, and possibly the touches list
		 * @param {TouchList} [touches] The touches list if present
		 * @private
		 */
		_startMove: function(event, touches) {
			if (this.panning) {
				return;
			}
			var moveEvent, endEvent,
				startDistance, startScale, startMiddle,
				startPageX, startPageY, touch;
			var self = this;
			var options = this.options;
			var ns = options.eventNamespace;
			var matrix = this.getMatrix();
			var original = matrix.slice(0);
			var origPageX = +original[4];
			var origPageY = +original[5];
			var panOptions = { matrix: matrix, animate: 'skip' };
			var type = event.type;

			// Use proper events
			if (type === 'pointerdown') {
				moveEvent = 'pointermove';
				endEvent = 'pointerup';
			} else if (type === 'touchstart') {
				moveEvent = 'touchmove';
				endEvent = 'touchend';
			} else if (type === 'MSPointerDown') {
				moveEvent = 'MSPointerMove';
				endEvent = 'MSPointerUp';
			} else {
				moveEvent = 'mousemove';
				endEvent = 'mouseup';
			}

			// Add namespace
			moveEvent += ns;
			endEvent += ns;

			// Remove any transitions happening
			this.transition(true);

			// Indicate that we are currently panning
			this.panning = true;

			// Trigger start event
			this._trigger('start', event, touches);

			var setStart = function(event, touches) {
				if (touches) {
					if (touches.length === 2) {
						if (startDistance != null) {
							return;
						}
						startDistance = self._getDistance(touches);
						startScale = self.getScale(matrix);
						startMiddle = self._getMiddle(touches);
						return;
					}
					if (startPageX != null) {
						return;
					}
					if ((touch = touches[0])) {
						startPageX = touch.pageX;
						startPageY = touch.pageY;
					}
				}
				if (startPageX != null) {
					return;
				}
				startPageX = event.pageX;
				startPageY = event.pageY;
			};

			setStart(event, touches);

			var move = function(e) {
				var coords;
				e.preventDefault();
				touches = e.touches || e.originalEvent.touches;
				setStart(e, touches);

				if (touches) {
					if (touches.length === 2) {

						// Calculate move on middle point
						var middle = self._getMiddle(touches);
						var diff = self._getDistance(touches) - startDistance;

						// Set zoom
						self.zoom(diff * (options.increment / 100) + startScale, {
							focal: middle,
							matrix: matrix,
							animate: 'skip'
						});

						// Set pan
						self.pan(
							+matrix[4] + middle.clientX - startMiddle.clientX,
							+matrix[5] + middle.clientY - startMiddle.clientY,
							panOptions
						);
						startMiddle = middle;
						return;
					}
					coords = touches[0] || { pageX: 0, pageY: 0 };
				}

				if (!coords) {
					coords = e;
				}

				self.pan(
					origPageX + coords.pageX - startPageX,
					origPageY + coords.pageY - startPageY,
					panOptions
				);
			};

			// Bind the handlers
			$(document)
				.off(ns)
				.on(moveEvent, move)
				.on(endEvent, function(e) {
					e.preventDefault();
					// Unbind all document events
					$(this).off(ns);
					self.panning = false;
					// Trigger our end event
					// Simply set the type to "panzoomend" to pass through all end properties
					// jQuery's `not` is used here to compare Array equality
					e.type = 'panzoomend';
					self._trigger(e, matrix, !matrixEquals(matrix, original));
				});
		}
	};

	// Add Panzoom as a static property
	$.Panzoom = Panzoom;

	/**
	 * Extend jQuery
	 * @param {Object|String} options - The name of a method to call on the prototype
	 *  or an object literal of options
	 * @returns {jQuery|Mixed} jQuery instance for regular chaining or the return value(s) of a panzoom method call
	 */
	$.fn.panzoom = function(options) {
		var instance, args, m, ret;

		// Call methods widget-style
		if (typeof options === 'string') {
			ret = [];
			args = slice.call(arguments, 1);
			this.each(function() {
				instance = $.data(this, datakey);

				if (!instance) {
					ret.push(undefined);

				// Ignore methods beginning with `_`
				} else if (options.charAt(0) !== '_' &&
					typeof (m = instance[ options ]) === 'function' &&
					// If nothing is returned, do not add to return values
					(m = m.apply(instance, args)) !== undefined) {

					ret.push(m);
				}
			});

			// Return an array of values for the jQuery instances
			// Or the value itself if there is only one
			// Or keep chaining
			return ret.length ?
				(ret.length === 1 ? ret[0] : ret) :
				this;
		}

		return this.each(function() { new Panzoom(this, options); });
	};

	return Panzoom;
}));
define('module-oneZoom',[
	"jquery",
    "jquery.doubletap",
    "jquery.panzoom"
	], function ($) {

	"use strict";

	/*
    	OneZoom 1.0.0 Usage
        Yang@onerockwell
  	*/

  	var OneZoomView = Backbone.View.extend({
		
		initialize: function (settings) {
			var self = this;
			self.zoomEngaging = false;
            self.$productMedia = self.$el;
            self.$mainImage = settings.mainImage;
            self.$thumbImage = settings.thumbImage;
            
            self.buildDesktopZoom();
            self.buildMobileZoom();
            
		},

		events: {
            'click .image-slide' : 'desktopZoomHandle',
            'click #onezoom.opened' : 'desktopZoomClose',
            'doubletap .image-slide' : 'mobileZoomHandle',
            'doubletap #onezoom-mobile' : 'mobileZoomHandle',
            'click .onezoom-close': 'mobileZoomeOut'
		},
        
        buildDesktopZoom: function(){
            var self = this;
            self.$zoomContainer = $('<div id="onezoom"></div>');
            self.$zoomContainer.appendTo(self.$productMedia);
        },
        
        buildMobileZoom: function(){
            var self = this;
            self.zoomMobileEngaging = false;
            self.$zoomMobileContainer = $('<div id="onezoom-mobile"></div>');
            self.$zoomMobileContainer.appendTo(self.$productMedia);
        },
        
        desktopZoomHandle: function(e){
			var self = this;
			e.preventDefault();
            if (!self.isMobile()) {
				var $curr = $(e.currentTarget);
				var $zoomImage = $('<img class="zoomed-image" src="' + $curr.attr('href') + '" />');
				
				self.$zoomContainer.html($zoomImage);
	            
	            if (!self.zoomEngaging) {
	                self.zoomStatus('engage');
	                self.$zoomContainer.addClass('opened');
	            }
			}
        },
        
        mobileZoomHandle: function(e){
            var self = this;
			if (self.isMobile()) {
				if (self.$zoomMobileEngaging) {
	                self.mobileZoomeOut();
	            } else {
	                self.mobileZoomeIn(e);
	            }
			}
        },
        
        mobileZoomeIn: function(e){
            var self = this;
            var $curr = $(e.currentTarget);
            var $currImage = $curr.find('img');
            var $bigImage = $('<img src="' + $curr.attr('href') + '" />');

            self.$zoomMobileCloseIcon = $('<div class="onezoom-close"></div>');
            self.$zoomMobileContainer.addClass('opened').html($bigImage);
            self.$zoomMobileContainer.prepend(self.$zoomMobileCloseIcon);
            
            // get proper coordinates for touchend event
            if (e.changedTouches) {
                e = e.changedTouches[0];
            }
			
            $bigImage.load(function(){
				
				console.log($bigImage.width());
				
				$bigImage.panzoom({
	                contain: 'automatic',
	                minScale: 1,
	                maxScale: 5
	            });
				
                var rate = $bigImage.width() / $currImage.width();
                var pan = {
                    x: (self.$mainImage.offset().left - e.pageX) * rate + ($currImage.width() / 2),
                    y: (self.$mainImage.offset().top - e.pageY) * rate + ($currImage.height() / 2)
                };
                $bigImage.panzoom('pan', pan.x, pan.y);
            })
            
            // mark as zoomed
            this.$zoomMobileEngaging = true;
        },
        
        mobileZoomeOut: function(e){
            var self = this;
            if (!this.$zoomMobileContainer) {
                return false;
            }
            this.$zoomMobileContainer.removeClass('opened');
            self.$zoomMobileEngaging = false;
        },
        
        desktopZoomClose: function(e){
            var self = this;
            self.$zoomContainer.removeClass('opened');
            self.zoomStatus('disengage');
        },
		
		zoomStatus: function(opt){
			var self = this;
			if (opt == 'engage') {
				self.zoomEngaging = true;
				$('html').addClass('zooming');
			} else if (opt == 'disengage'){
				self.zoomEngaging = false;
				$('html').removeClass('zooming');
			}
		},
		
		isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w < ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        }
        
	});

	var OneZoom = {
		init: function (settings) {
			return new OneZoomView(settings);
		}
	}

	return OneZoom;


});
define('module-oneTab',[
	"jquery",

	], function ($) {

	"use strict";

	/*
		OneTab 1.0.0 Usage
		Yang @onerockwell
  	*/

  	var OneTabView = Backbone.View.extend({
		
		initialize: function (settings) {
			var self = this;
		},

		events: {
			'click .tab-titles > *' : function(e){
                var self = this;
                self.tabUpdate(e);
            }
		},
        
        tabSwitch: function($elem, className){
            $elem.addClass(className);
            $elem.siblings().removeClass(className);
        },
        
        tabUpdate: function(e){
            var self = this;
            var $curr = $(e.currentTarget);
            var $tabContainer = $curr.parents('.tab-container');
            var tabVal = $curr.attr('data-tab');
            var $activeTab  = $tabContainer.find('.tabs-content [data-tab="' + tabVal + '"]');
            
            self.tabSwitch($curr, 'active');
            self.tabSwitch($activeTab, 'active');
        },
		
		destroy: function() {
            var self = this;
            self.undelegateEvents();
        }

	});

	var OneTab = {
		init: function (settings) {
			return new OneTabView(settings);
		}
	}

	return OneTab;


});
/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
(function() {
  'use strict'

  var keyCounter = 0
  var allWaypoints = {}

  /* http://imakewebthings.com/waypoints/api/waypoint */
  function Waypoint(options) {
    if (!options) {
      throw new Error('No options passed to Waypoint constructor')
    }
    if (!options.element) {
      throw new Error('No element option passed to Waypoint constructor')
    }
    if (!options.handler) {
      throw new Error('No handler option passed to Waypoint constructor')
    }

    this.key = 'waypoint-' + keyCounter
    this.options = Waypoint.Adapter.extend({}, Waypoint.defaults, options)
    this.element = this.options.element
    this.adapter = new Waypoint.Adapter(this.element)
    this.callback = options.handler
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
    this.enabled = this.options.enabled
    this.triggerPoint = null
    this.group = Waypoint.Group.findOrCreate({
      name: this.options.group,
      axis: this.axis
    })
    this.context = Waypoint.Context.findOrCreateByElement(this.options.context)

    if (Waypoint.offsetAliases[this.options.offset]) {
      this.options.offset = Waypoint.offsetAliases[this.options.offset]
    }
    this.group.add(this)
    this.context.add(this)
    allWaypoints[this.key] = this
    keyCounter += 1
  }

  /* Private */
  Waypoint.prototype.queueTrigger = function(direction) {
    this.group.queueTrigger(this, direction)
  }

  /* Private */
  Waypoint.prototype.trigger = function(args) {
    if (!this.enabled) {
      return
    }
    if (this.callback) {
      this.callback.apply(this, args)
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy */
  Waypoint.prototype.destroy = function() {
    this.context.remove(this)
    this.group.remove(this)
    delete allWaypoints[this.key]
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable */
  Waypoint.prototype.disable = function() {
    this.enabled = false
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable */
  Waypoint.prototype.enable = function() {
    this.context.refresh()
    this.enabled = true
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/next */
  Waypoint.prototype.next = function() {
    return this.group.next(this)
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/previous */
  Waypoint.prototype.previous = function() {
    return this.group.previous(this)
  }

  /* Private */
  Waypoint.invokeAll = function(method) {
    var allWaypointsArray = []
    for (var waypointKey in allWaypoints) {
      allWaypointsArray.push(allWaypoints[waypointKey])
    }
    for (var i = 0, end = allWaypointsArray.length; i < end; i++) {
      allWaypointsArray[i][method]()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy-all */
  Waypoint.destroyAll = function() {
    Waypoint.invokeAll('destroy')
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable-all */
  Waypoint.disableAll = function() {
    Waypoint.invokeAll('disable')
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable-all */
  Waypoint.enableAll = function() {
    Waypoint.Context.refreshAll()
    for (var waypointKey in allWaypoints) {
      allWaypoints[waypointKey].enabled = true
    }
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/refresh-all */
  Waypoint.refreshAll = function() {
    Waypoint.Context.refreshAll()
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-height */
  Waypoint.viewportHeight = function() {
    return window.innerHeight || document.documentElement.clientHeight
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-width */
  Waypoint.viewportWidth = function() {
    return document.documentElement.clientWidth
  }

  Waypoint.adapters = []

  Waypoint.defaults = {
    context: window,
    continuous: true,
    enabled: true,
    group: 'default',
    horizontal: false,
    offset: 0
  }

  Waypoint.offsetAliases = {
    'bottom-in-view': function() {
      return this.context.innerHeight() - this.adapter.outerHeight()
    },
    'right-in-view': function() {
      return this.context.innerWidth() - this.adapter.outerWidth()
    }
  }

  window.Waypoint = Waypoint
}())
;(function() {
  'use strict'

  function requestAnimationFrameShim(callback) {
    window.setTimeout(callback, 1000 / 60)
  }

  var keyCounter = 0
  var contexts = {}
  var Waypoint = window.Waypoint
  var oldWindowLoad = window.onload

  /* http://imakewebthings.com/waypoints/api/context */
  function Context(element) {
    this.element = element
    this.Adapter = Waypoint.Adapter
    this.adapter = new this.Adapter(element)
    this.key = 'waypoint-context-' + keyCounter
    this.didScroll = false
    this.didResize = false
    this.oldScroll = {
      x: this.adapter.scrollLeft(),
      y: this.adapter.scrollTop()
    }
    this.waypoints = {
      vertical: {},
      horizontal: {}
    }

    element.waypointContextKey = this.key
    contexts[element.waypointContextKey] = this
    keyCounter += 1
    if (!Waypoint.windowContext) {
      Waypoint.windowContext = true
      Waypoint.windowContext = new Context(window)
    }

    this.createThrottledScrollHandler()
    this.createThrottledResizeHandler()
  }

  /* Private */
  Context.prototype.add = function(waypoint) {
    var axis = waypoint.options.horizontal ? 'horizontal' : 'vertical'
    this.waypoints[axis][waypoint.key] = waypoint
    this.refresh()
  }

  /* Private */
  Context.prototype.checkEmpty = function() {
    var horizontalEmpty = this.Adapter.isEmptyObject(this.waypoints.horizontal)
    var verticalEmpty = this.Adapter.isEmptyObject(this.waypoints.vertical)
    var isWindow = this.element == this.element.window
    if (horizontalEmpty && verticalEmpty && !isWindow) {
      this.adapter.off('.waypoints')
      delete contexts[this.key]
    }
  }

  /* Private */
  Context.prototype.createThrottledResizeHandler = function() {
    var self = this

    function resizeHandler() {
      self.handleResize()
      self.didResize = false
    }

    this.adapter.on('resize.waypoints', function() {
      if (!self.didResize) {
        self.didResize = true
        Waypoint.requestAnimationFrame(resizeHandler)
      }
    })
  }

  /* Private */
  Context.prototype.createThrottledScrollHandler = function() {
    var self = this
    function scrollHandler() {
      self.handleScroll()
      self.didScroll = false
    }

    this.adapter.on('scroll.waypoints', function() {
      if (!self.didScroll || Waypoint.isTouch) {
        self.didScroll = true
        Waypoint.requestAnimationFrame(scrollHandler)
      }
    })
  }

  /* Private */
  Context.prototype.handleResize = function() {
    Waypoint.Context.refreshAll()
  }

  /* Private */
  Context.prototype.handleScroll = function() {
    var triggeredGroups = {}
    var axes = {
      horizontal: {
        newScroll: this.adapter.scrollLeft(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left'
      },
      vertical: {
        newScroll: this.adapter.scrollTop(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up'
      }
    }

    for (var axisKey in axes) {
      var axis = axes[axisKey]
      var isForward = axis.newScroll > axis.oldScroll
      var direction = isForward ? axis.forward : axis.backward

      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey]
        if (waypoint.triggerPoint === null) {
          continue
        }
        var wasBeforeTriggerPoint = axis.oldScroll < waypoint.triggerPoint
        var nowAfterTriggerPoint = axis.newScroll >= waypoint.triggerPoint
        var crossedForward = wasBeforeTriggerPoint && nowAfterTriggerPoint
        var crossedBackward = !wasBeforeTriggerPoint && !nowAfterTriggerPoint
        if (crossedForward || crossedBackward) {
          waypoint.queueTrigger(direction)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
      }
    }

    for (var groupKey in triggeredGroups) {
      triggeredGroups[groupKey].flushTriggers()
    }

    this.oldScroll = {
      x: axes.horizontal.newScroll,
      y: axes.vertical.newScroll
    }
  }

  /* Private */
  Context.prototype.innerHeight = function() {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportHeight()
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerHeight()
  }

  /* Private */
  Context.prototype.remove = function(waypoint) {
    delete this.waypoints[waypoint.axis][waypoint.key]
    this.checkEmpty()
  }

  /* Private */
  Context.prototype.innerWidth = function() {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportWidth()
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerWidth()
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-destroy */
  Context.prototype.destroy = function() {
    var allWaypoints = []
    for (var axis in this.waypoints) {
      for (var waypointKey in this.waypoints[axis]) {
        allWaypoints.push(this.waypoints[axis][waypointKey])
      }
    }
    for (var i = 0, end = allWaypoints.length; i < end; i++) {
      allWaypoints[i].destroy()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-refresh */
  Context.prototype.refresh = function() {
    /*eslint-disable eqeqeq */
    var isWindow = this.element == this.element.window
    /*eslint-enable eqeqeq */
    var contextOffset = isWindow ? undefined : this.adapter.offset()
    var triggeredGroups = {}
    var axes

    this.handleScroll()
    axes = {
      horizontal: {
        contextOffset: isWindow ? 0 : contextOffset.left,
        contextScroll: isWindow ? 0 : this.oldScroll.x,
        contextDimension: this.innerWidth(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left',
        offsetProp: 'left'
      },
      vertical: {
        contextOffset: isWindow ? 0 : contextOffset.top,
        contextScroll: isWindow ? 0 : this.oldScroll.y,
        contextDimension: this.innerHeight(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up',
        offsetProp: 'top'
      }
    }

    for (var axisKey in axes) {
      var axis = axes[axisKey]
      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey]
        var adjustment = waypoint.options.offset
        var oldTriggerPoint = waypoint.triggerPoint
        var elementOffset = 0
        var freshWaypoint = oldTriggerPoint == null
        var contextModifier, wasBeforeScroll, nowAfterScroll
        var triggeredBackward, triggeredForward

        if (waypoint.element !== waypoint.element.window) {
          elementOffset = waypoint.adapter.offset()[axis.offsetProp]
        }

        if (typeof adjustment === 'function') {
          adjustment = adjustment.apply(waypoint)
        }
        else if (typeof adjustment === 'string') {
          adjustment = parseFloat(adjustment)
          if (waypoint.options.offset.indexOf('%') > - 1) {
            adjustment = Math.ceil(axis.contextDimension * adjustment / 100)
          }
        }

        contextModifier = axis.contextScroll - axis.contextOffset
        waypoint.triggerPoint = Math.floor(elementOffset + contextModifier - adjustment)
        wasBeforeScroll = oldTriggerPoint < axis.oldScroll
        nowAfterScroll = waypoint.triggerPoint >= axis.oldScroll
        triggeredBackward = wasBeforeScroll && nowAfterScroll
        triggeredForward = !wasBeforeScroll && !nowAfterScroll

        if (!freshWaypoint && triggeredBackward) {
          waypoint.queueTrigger(axis.backward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
        else if (!freshWaypoint && triggeredForward) {
          waypoint.queueTrigger(axis.forward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
        else if (freshWaypoint && axis.oldScroll >= waypoint.triggerPoint) {
          waypoint.queueTrigger(axis.forward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
      }
    }

    Waypoint.requestAnimationFrame(function() {
      for (var groupKey in triggeredGroups) {
        triggeredGroups[groupKey].flushTriggers()
      }
    })

    return this
  }

  /* Private */
  Context.findOrCreateByElement = function(element) {
    return Context.findByElement(element) || new Context(element)
  }

  /* Private */
  Context.refreshAll = function() {
    for (var contextId in contexts) {
      contexts[contextId].refresh()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-find-by-element */
  Context.findByElement = function(element) {
    return contexts[element.waypointContextKey]
  }

  window.onload = function() {
    if (oldWindowLoad) {
      oldWindowLoad()
    }
    Context.refreshAll()
  }


  Waypoint.requestAnimationFrame = function(callback) {
    var requestFn = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      requestAnimationFrameShim
    requestFn.call(window, callback)
  }
  Waypoint.Context = Context
}())
;(function() {
  'use strict'

  function byTriggerPoint(a, b) {
    return a.triggerPoint - b.triggerPoint
  }

  function byReverseTriggerPoint(a, b) {
    return b.triggerPoint - a.triggerPoint
  }

  var groups = {
    vertical: {},
    horizontal: {}
  }
  var Waypoint = window.Waypoint

  /* http://imakewebthings.com/waypoints/api/group */
  function Group(options) {
    this.name = options.name
    this.axis = options.axis
    this.id = this.name + '-' + this.axis
    this.waypoints = []
    this.clearTriggerQueues()
    groups[this.axis][this.name] = this
  }

  /* Private */
  Group.prototype.add = function(waypoint) {
    this.waypoints.push(waypoint)
  }

  /* Private */
  Group.prototype.clearTriggerQueues = function() {
    this.triggerQueues = {
      up: [],
      down: [],
      left: [],
      right: []
    }
  }

  /* Private */
  Group.prototype.flushTriggers = function() {
    for (var direction in this.triggerQueues) {
      var waypoints = this.triggerQueues[direction]
      var reverse = direction === 'up' || direction === 'left'
      waypoints.sort(reverse ? byReverseTriggerPoint : byTriggerPoint)
      for (var i = 0, end = waypoints.length; i < end; i += 1) {
        var waypoint = waypoints[i]
        if (waypoint.options.continuous || i === waypoints.length - 1) {
          waypoint.trigger([direction])
        }
      }
    }
    this.clearTriggerQueues()
  }

  /* Private */
  Group.prototype.next = function(waypoint) {
    this.waypoints.sort(byTriggerPoint)
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    var isLast = index === this.waypoints.length - 1
    return isLast ? null : this.waypoints[index + 1]
  }

  /* Private */
  Group.prototype.previous = function(waypoint) {
    this.waypoints.sort(byTriggerPoint)
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    return index ? this.waypoints[index - 1] : null
  }

  /* Private */
  Group.prototype.queueTrigger = function(waypoint, direction) {
    this.triggerQueues[direction].push(waypoint)
  }

  /* Private */
  Group.prototype.remove = function(waypoint) {
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    if (index > -1) {
      this.waypoints.splice(index, 1)
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/first */
  Group.prototype.first = function() {
    return this.waypoints[0]
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/last */
  Group.prototype.last = function() {
    return this.waypoints[this.waypoints.length - 1]
  }

  /* Private */
  Group.findOrCreate = function(options) {
    return groups[options.axis][options.name] || new Group(options)
  }

  Waypoint.Group = Group
}())
;(function() {
  'use strict'

  var $ = window.jQuery
  var Waypoint = window.Waypoint

  function JQueryAdapter(element) {
    this.$element = $(element)
  }

  $.each([
    'innerHeight',
    'innerWidth',
    'off',
    'offset',
    'on',
    'outerHeight',
    'outerWidth',
    'scrollLeft',
    'scrollTop'
  ], function(i, method) {
    JQueryAdapter.prototype[method] = function() {
      var args = Array.prototype.slice.call(arguments)
      return this.$element[method].apply(this.$element, args)
    }
  })

  $.each([
    'extend',
    'inArray',
    'isEmptyObject'
  ], function(i, method) {
    JQueryAdapter[method] = $[method]
  })

  Waypoint.adapters.push({
    name: 'jquery',
    Adapter: JQueryAdapter
  })
  Waypoint.Adapter = JQueryAdapter
}())
;(function() {
  'use strict'

  var Waypoint = window.Waypoint

  function createExtension(framework) {
    return function() {
      var waypoints = []
      var overrides = arguments[0]

      if (framework.isFunction(arguments[0])) {
        overrides = framework.extend({}, arguments[1])
        overrides.handler = arguments[0]
      }

      this.each(function() {
        var options = framework.extend({}, overrides, {
          element: this
        })
        if (typeof options.context === 'string') {
          options.context = framework(this).closest(options.context)[0]
        }
        waypoints.push(new Waypoint(options))
      })

      return waypoints
    }
  }

  if (window.jQuery) {
    window.jQuery.fn.waypoint = createExtension(window.jQuery)
  }
  if (window.Zepto) {
    window.Zepto.fn.waypoint = createExtension(window.Zepto)
  }
}())
;
define("jquery.waypoints", ["jquery"], function(){});

// Utility for creating objects in older browsers
if ( typeof Object.create !== 'function' ) {
  Object.create = function( obj ) {

    function F() {}
    F.prototype = obj;
    return new F();

  };
}

/*!
 * jQuery panelSnap
 * Version 0.15.1
 *
 * Requires:
 * - jQuery 1.7 or higher (no jQuery.migrate needed)
 *
 * https://github.com/guidobouman/jquery-panelsnap
 *
 * Copyright 2013, Guido Bouman
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * Date: Wed Feb 13 16:05:00 2013 +0100
 */
(function($, window, document, undefined) {
  'use strict';

  var pluginName = 'panelSnap';
  var storageName = 'plugin_' + pluginName;

  var pluginObject = {

    isMouseDown: false,
    isSnapping: false,
    enabled: true,
    scrollOffset: 0,

    init: function(options, container) {

      var self = this;

      self.container = container;
      self.$container = $(container);

      self.$eventContainer = self.$container;
      self.$snapContainer = self.$container;

      if(self.$container.is('body')) {
        self.$eventContainer = $(document);
        self.$snapContainer = $(document.scrollingElement || document.documentElement);

        var ua = navigator.userAgent;
        if(~ua.indexOf('WebKit') && !~ua.indexOf('Chrome')) {
          self.$snapContainer = $('body');
        }
      }

      self.options = $.extend(true, {}, $.fn.panelSnap.options, options);

      self.bind();

      if(self.options.$menu !== false && $('.ps-active', self.options.$menu).length > 0) {
        $('.ps-active', self.options.$menu).click();
      } else {
        var $target = self.getPanel(':first');
        self.activatePanel($target);
      }

      return self;

    },

    bind: function() {

      var self = this;

      self.bindProxied(self.$eventContainer, 'scrollstop', self.scrollStop);
      self.bindProxied(self.$eventContainer, 'mousewheel', self.mouseWheel);
      self.bindProxied(self.$eventContainer, 'mousedown', self.mouseDown);
      self.bindProxied(self.$eventContainer, 'mouseup', self.mouseUp);

      self.bindProxied($(window), 'resizestop', self.resize);

      if(self.options.$menu) {
        self.bindProxied(self.options.$menu, 'click', self.captureMenuClick, self.options.menuSelector);
      }

      if(self.options.navigation.keys.nextKey || self.options.navigation.keys.prevKey) {
        self.bindProxied($(window), 'keydown', self.keyDown);
      }

      if (self.options.navigation.buttons.$nextButton) {
        self.bindProxied(self.options.navigation.buttons.$nextButton, 'click', self.captureNextClick);
      }

      if (self.options.navigation.buttons.$prevButton) {
        self.bindProxied(self.options.navigation.buttons.$prevButton, 'click', self.capturePrevClick);
      }

    },

    bindProxied: function($element, event, method, selector) {

      var self = this;

      selector = typeof selector === 'string' ? selector : null;

      $element.on(event + self.options.namespace, selector, $.proxy(function(e) {

        return method.call(self, e);

      }, self));

    },

    destroy: function() {

      var self = this;

      // Gotta love namespaced events!
      self.$eventContainer.off(self.options.namespace);

      $(window).off(self.options.namespace);

      if(self.options.$menu !== false) {
        $(self.options.menuSelector, self.options.$menu).off(self.options.namespace);
      }

      self.$container.removeData(storageName);

    },

    scrollStop: function(e) {

      var self = this;

      e.stopPropagation();

      if(self.isMouseDown) {
        return;
      }

      if(self.isSnapping) {
        return;
      }

      // Check if enabled or just 1 panel in viewport
      var panelsInViewPort = self.getPanelsInViewport();
      if (!self.enabled || panelsInViewPort.length < 2) {
        $target = panelsInViewPort.eq(0);
        if(!$target.is(self.getPanel('.ps-active'))) {
          self.activatePanel($target);
        }

        return;
      }

      var offset = self.$snapContainer.scrollTop();
      var scrollDifference = offset - self.scrollOffset;
      var overThreshold = Math.abs(scrollDifference) > self.options.directionThreshold;

      var panelNumber;
      if(scrollDifference > 0) {
        panelNumber = overThreshold ? 1 : 0;
      } else if(scrollDifference < 0) {
        panelNumber = overThreshold ? 0 : 1;
      } else {
        // Nothing to scroll, get out.
        return;
      }

      var $target = panelsInViewPort.eq(panelNumber);
      var maxOffset = self.$container[0].scrollHeight - self.scrollInterval;

      if (offset <= 0 || offset >= maxOffset) {
        // Only activate, prevent stuttering
        self.activatePanel($target);
        // Set scrollOffset to a sane number for next scroll
        self.scrollOffset = offset <= 0 ? 0 : maxOffset;
      } else {
        self.snapToPanel($target);
      }

    },

    getPanelsInViewport: function() {

      var self = this;

      var viewport = { top: self.$snapContainer.scrollTop() };
      viewport.bottom = viewport.top + self.$snapContainer.height();

      var panels = self.getPanel().filter(function (_, el) {
        var $el = $(el);
        var bounds;

        if(self.$container.is('body')) {
          bounds = $el.offset();
        } else {
          bounds = $el.position();
          bounds.top += self.$snapContainer.scrollTop();
        }

        bounds.bottom = bounds.top + $el.outerHeight();

        return !(viewport.bottom < bounds.top || viewport.top > bounds.bottom);
      });

      return panels;
    },

    mouseWheel: function(e) {

      var self = this;

      // This event only fires when the user actually scrolls with their input device.
      // Be it a trackpad, legacy mouse or anything else.

      if(self.isSnapping) {
        self.scrollOffset = self.$snapContainer.scrollTop();
        self.$snapContainer.stop(true);
        self.isSnapping = false;
      }

    },

    mouseDown: function(e) {

      var self = this;

      self.isMouseDown = true;

    },

    mouseUp: function(e) {

      var self = this;

      self.isMouseDown = false;

      if(self.scrollOffset !== self.$snapContainer.scrollTop()) {
        self.scrollStop(e);
      }

    },

    keyDown: function(e) {

      var self = this;

      var nav = self.options.navigation;

      if(!self.enabled) {
        return;
      }

      switch(e.which) {
        case nav.keys.prevKey:
        case nav.keys.nextKey:
          e.preventDefault();
      }

      if (self.isSnapping) {
        return;
      }

      switch(e.which) {
        case nav.keys.prevKey:
          self.snapTo('prev', nav.wrapAround);
          break;
        case nav.keys.nextKey:
          self.snapTo('next', nav.wrapAround);
          break;
      }

    },

    captureNextClick: function(e) {

      var self = this;

      e.preventDefault();

      if (self.isSnapping) {
        return;
      }

      self.snapTo('next', self.options.navigation.wrapAround);

    },

    capturePrevClick: function(e) {

      var self = this;

      e.preventDefault();

      if (self.isSnapping) {
        return;
      }

      self.snapTo('prev', self.options.navigation.wrapAround);

    },

    resize: function(e) {

      var self = this;

      if(!self.enabled) {
        return;
      }

      var $target = self.getPanel('.ps-active');

      self.snapToPanel($target);

    },

    captureMenuClick: function(e) {

      var self = this;

      var panel = $(e.currentTarget).data('panel');
      var $target = self.getPanel('[data-panel="' + panel + '"]');

      self.snapToPanel($target);

      return false;

    },

    snapToPanel: function($target) {

      var self = this;

      if (!$target.jquery) {
        return;
      }

      self.isSnapping = true;

      self.options.onSnapStart.call(self, $target);
      self.$container.trigger('panelsnap:start', [$target]);

      var scrollTarget = 0;
      if(self.$container.is('body') && $target.offset()) {
        scrollTarget = $target.offset().top;
      } else if ($target.offset()) {
        scrollTarget = self.$snapContainer.scrollTop() + $target.position().top;
      }

      scrollTarget -=  self.options.offset;

      self.$snapContainer.stop(true).delay(self.options.delay).animate({
        scrollTop: scrollTarget
      }, self.options.slideSpeed, self.options.easing, function() {

        // Set scrollOffset to scrollTop
        // (not to scrollTarget since on iPad those sometimes differ)
        self.scrollOffset = self.$snapContainer.scrollTop();
        self.isSnapping = false;

        // Call callback
        self.options.onSnapFinish.call(self, $target);
        self.$container.trigger('panelsnap:finish', [$target]);

        self.activatePanel($target);
      });

    },

    activatePanel: function($target) {

      var self = this;

      self.getPanel('.ps-active').removeClass('ps-active');
      $target.addClass('ps-active');

      if(self.options.$menu !== false) {
        var activeItemSelector = self.options.menuSelector + '.ps-active';
        $(activeItemSelector, self.options.$menu).removeClass('ps-active');

        var attribute = '[data-panel="' + $target.data('panel') + '"]';
        var itemSelector = self.options.menuSelector + attribute;
        var $itemToActivate = $(itemSelector, self.options.$menu);
        $itemToActivate.addClass('ps-active');
      }

      var nav = self.options.navigation;

      if(!nav.wrapAround) {
        var $panels = self.getPanel();
        var index = $panels.index(self.getPanel('.ps-active'));

        if (nav.buttons.$nextButton !== false ) {
          $target = $panels.eq(index + 1);
          if($target.length < 1) {
            $(nav.buttons.$nextButton).attr('aria-disabled', 'true');
            $(nav.buttons.$nextButton).addClass('disabled');
          } else {
            $(nav.buttons.$nextButton).attr('aria-disabled', 'false');
            $(nav.buttons.$nextButton).removeClass('disabled');
          }
        }

        if (nav.buttons.$prevButton !== false ) {
          if(index < 1) {
            $(nav.buttons.$prevButton).attr('aria-disabled', 'true');
            $(nav.buttons.$prevButton).addClass('disabled');
          } else {
            $(nav.buttons.$prevButton).attr('aria-disabled', 'false');
            $(nav.buttons.$prevButton).removeClass('disabled');
          }
        }
      }

      self.options.onActivate.call(self, $target);
      self.$container.trigger('panelsnap:activate', [$target]);

    },

    getPanel: function(selector) {

      var self = this;

      if(typeof selector === 'undefined') {
        selector = '';
      }

      return $(self.options.panelSelector + selector, self.$container);

    },

    snapTo: function(target, wrap) {

      var self = this;

      if(typeof wrap !== 'boolean') {
        wrap = true;
      }

      var $panels = self.getPanel();
      var index = $panels.index(self.getPanel('.ps-active'));
      var $target;

      switch(target) {
        case 'prev':

          $target = $panels.eq(index - 1);
          if(index < 1 && !wrap)
          {
            $target = []; // Clear target, because negative indexes wrap automatically
          }
          break;

        case 'next':

          $target = $panels.eq(index + 1);
          if($target.length < 1 && wrap)
          {
            $target = $panels.filter(':first');
          }
          break;

        case 'first':

          $target = $panels.filter(':first');
          break;

        case 'last':

          $target = $panels.filter(':last');
          break;
      }

      if($target.length > 0) {
        self.snapToPanel($target);
      }

    },

    enable: function() {

      var self = this;

      // Gather scrollOffset for next scroll
      self.scrollOffset = self.$snapContainer.scrollTop();

      self.enabled = true;

    },

    disable: function() {

      var self = this;

      self.enabled = false;

    },

    toggle: function() {

      var self = this;

      if(self.enabled) {
        self.disable();
      } else {
        self.enable();
      }

    }

  };

  $.fn[pluginName] = function(options) {

    var args = Array.prototype.slice.call(arguments);

    return this.each(function() {

      var pluginInstance = $.data(this, storageName);
      if(typeof options === 'object' || options === 'init' || ! options) {
        if(!pluginInstance) {
          if(options === 'init') {
            options = args[1] || {};
          }

          pluginInstance = Object.create(pluginObject).init(options, this);
          $.data(this, storageName, pluginInstance);
        } else {
          $.error('Plugin is already initialized for this object.');
          return;
        }
      } else if(!pluginInstance) {
        $.error('Plugin is not initialized for this object yet.');
        return;
      } else if(pluginInstance[options]) {
        var method = options;
        options = args.slice(1);
        pluginInstance[method].apply(pluginInstance, options);
      } else {
        $.error('Method ' +  options + ' does not exist on jQuery.panelSnap.');
        return;
      }

    });

  };

  $.fn[pluginName].options = {
    $menu: false,
    menuSelector: 'a',
    panelSelector: '> section',
    namespace: '.panelSnap',
    onSnapStart: function(){},
    onSnapFinish: function(){},
    onActivate: function(){},
    directionThreshold: 50,
    slideSpeed: 200,
    delay: 0,
    easing: 'linear',
    offset: 0,
    navigation: {
      keys: {
        nextKey: false,
        prevKey: false
      },
      buttons: {
        $nextButton: false,
        $prevButton: false
      },
      wrapAround: false
    }
  };

})(jQuery, window, document);

/*!
 * Special flavoured jQuery Mobile scrollstart & scrollstop events.
 * Version 0.1.3
 *
 * Requires:
 * - jQuery 1.7.1 or higher (no jQuery.migrate needed)
 *
 * Copyright 2013, Guido Bouman
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * Date: Wed Feb 13 16:05:00 2013 +0100
 */
(function($) {

  // Also handles the scrollstop event
  $.event.special.scrollstart = {

    enabled: true,

    setup: function() {

      var thisObject = this;
      var $this = $(thisObject);
      var scrolling;
      var timer;
      var isTouching;

      $this.data('scrollwatch', true);

      function trigger(event, scrolling) {

        event.type = scrolling ? 'scrollstart' : 'scrollstop';
        $this.trigger(event);

      }

      $this.on('touchstart', function(event) {
        isTouching = true;
      });

      $this.on('touchleave touchcancel touchend', function(event) {
        isTouching = false;
        setTimeout(function () {
          clearTimeout(timer);
        }, 50);
      });

      $this.on('touchmove scroll', function(event) {

        if (isTouching) {
          return;
        }

        if(!$.event.special.scrollstart.enabled) {
          return;
        }

        if(!$.event.special.scrollstart.scrolling) {
          $.event.special.scrollstart.scrolling = true;
          trigger(event, true);
        }

        clearTimeout(timer);
        timer = setTimeout(function() {
          $.event.special.scrollstart.scrolling = false;
          trigger(event, false);
        }, 50);

      });

    }

  };

  // Proxies scrollstart when needed
  $.event.special.scrollstop = {

    setup: function() {

      var thisObject = this;
      var $this = $(thisObject);

      if(!$this.data('scrollwatch')) {
        $(this).on('scrollstart', function(){});
      }

    }

  };

})(jQuery);

/*!
 * Resizestart and resizestop events.
 * Version 0.0.1
 *
 * Requires:
 * - jQuery 1.7.1 or higher (no jQuery.migrate needed)
 *
 * Copyright 2013, Guido Bouman
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * Date: Fri Oct 25 15:05:00 2013 +0100
 */
(function($) {

  // Also handles the resizestop event
  $.event.special.resizestart = {

    enabled: true,

    setup: function() {

      var thisObject = this;
      var $this = $(thisObject);
      var resizing;
      var timer;

      $this.data('resizewatch', true);

      function trigger(event, resizing) {

        event.type = resizing ? 'resizestart' : 'resizestop';
        $this.trigger(event);

      }

      $this.on('resize', function(event) {

        if(!$.event.special.resizestart.enabled) {
          return;
        }

        if(!$.event.special.resizestart.resizing) {
          $.event.special.resizestart.resizing = true;
          trigger(event, true);
        }

        clearTimeout(timer);
        timer = setTimeout(function() {
          $.event.special.resizestart.resizing = false;
          trigger(event, false);
        }, 200);

      });

    }

  };

  // Proxies resizestart when needed
  $.event.special.resizestop = {

    setup: function() {

      var thisObject = this;
      var $this = $(thisObject);

      if(!$this.data('resizewatch')) {
        $(this).on('resizestart', function(){});
      }

    }

  };

})(jQuery);

/*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.6
 *
 * Requires: 1.2.2+
 */
(function($) {

  var types = ['DOMMouseScroll', 'mousewheel'];

  if ($.event.fixHooks) {
    for ( var i=types.length; i; ) {
      $.event.fixHooks[ types[--i] ] = $.event.mouseHooks;
    }
  }

  $.event.special.mousewheel = {
    setup: function() {
      if ( this.addEventListener ) {
        for ( var i=types.length; i; ) {
          this.addEventListener( types[--i], handler, false );
        }
      } else {
        this.onmousewheel = handler;
      }
    },

    teardown: function() {
      if ( this.removeEventListener ) {
        for ( var i=types.length; i; ) {
          this.removeEventListener( types[--i], handler, false );
        }
      } else {
        this.onmousewheel = null;
      }
    }
  };

  $.fn.extend({
    mousewheel: function(fn) {
      return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
    },

    unmousewheel: function(fn) {
      return this.unbind('mousewheel', fn);
    }
  });

  function handler(event) {
    var orgEvent = event || window.event,
        args = [].slice.call( arguments, 1 ),
        delta = 0,
        returnValue = true,
        deltaX = 0,
        deltaY = 0;

    event = $.event.fix(orgEvent);
    event.type = 'mousewheel';

    // Old school scrollwheel delta
    if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta/120; }
    if ( orgEvent.detail     ) { delta = -orgEvent.detail/3; }

    // New school multidimensional scroll (touchpads) deltas
    deltaY = delta;

    // Gecko
    if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
      deltaY = 0;
      deltaX = -1*delta;
    }

    // Webkit
    if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY/120; }
    if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = -1*orgEvent.wheelDeltaX/120; }

    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);

    return ($.event.dispatch || $.event.handle).apply(this, args);
  }

})(jQuery);

define("jquery.panelsnap", ["jquery"], function(){});

define('view-product',[
    'jquery',
    'module-oneSwatches',
    'module-oneZoom',
    'module-oneTab',
    'module-oneDrawer',
    'module-oneContact',
    'module-oneCustomScroll',
    'jquery.scrolltofixed',
    'jquery.waypoints',
    'jquery.panelsnap',
    'slick'
], function ($,OneSwatches,OneZoom,OneTab,OneDrawer,OneContact,OneCustomScroll) {

    "use strict";

    var ViewProduct = Backbone.View.extend({

        initialize: function(opts){
            var self = this,
                selectors = {
                    addToCart: '[data-add-to-cart]',
                    addToCartText: '[data-add-to-cart-text]',
                    availabilityJson: '[data-availability-json]',
                    comparePrice: '[data-compare-price]',
                    comparePriceText: '[data-compare-text]',
                    originalSelectorId: '[data-product-select]',
                    priceWrapper: '[data-price-wrapper]',
                    productFeaturedImage: '[data-product-featured-image]',
                    productJson: '[data-product-json]',
                    productPrice: '[data-product-price]',
                    productThumbs: '[data-product-single-thumbnail]',
                    singleOptionSelector: '[data-single-option-selector]'
                };

            self.$content = self.$el;
            self.$body = $('body');
            self.$productInfo = self.$content.find('.product-info');
            self.$media = self.$content.find('.product-media');
            self.$relatedProducts = self.$content.find('.related-products');
            self.$mainImage = self.$media.find('#ProductPhoto');
            self.$thumbImage = self.$media.find('#ProductThumbs');
            self.$mediaSlider = self.$mainImage.find('.images-wrapper');
            self.$socialIcons = self.$content.find('.one-social');
            self.$productBottom = self.$content.find('.product-bottom');
            self.$inquireForm = self.$body.find('.inquire-contact-form');
            self.$sizeChart = self.$content.find('.size-chart');
            self.$availabilityList = self.$content.find('.pickup-availabilities-modal');

            self.isGiftCard = self.$content.hasClass('gift-card');
            self.productJSON = $(selectors.productJson).length ? JSON.parse($(selectors.productJson).html()) : false;
            self.availabilityJSON = {};
            self.latitude;
            self.longitude;
			self.availabilityDistanceLimit = Number($('[data-pickup-distance-limit]').val()); // Uses miles as unit

            self.swatches();
            self.productMedia();

            if (!self.isGiftCard) {
                self.tabs();
                // self.productInfoFix();
                self.zoom();
                self.social();
                self.inquire();
                self.sizeChart();
                self.availabilityList();
            } else {
              self.zoom()
            }

            self.$designerTab = self.$productBottom.find('[data-tab="more-by-designer"]');
            self.$relatedProducts = self.$productBottom.find('[data-tab="recommended"]');
            if(self.$designerTab.length > 0){
                self.$productBottom.removeClass("hide");
                self.$designerTab.removeClass("hide");
            }
            if(self.$relatedProducts.length > 0){
                self.$productBottom.removeClass("hide");
                self.$relatedProducts.removeClass("hide");
            }

            self.productBottom();
            //self.fastSimonCrossSell();
        },

        events: {

        },

        availabilityList: function() {
            let self = this;

            let events = {
                'click #SwitchToShipping': function(e) {
                    e.preventDefault();

                    self.updateStoreSelection();

                    // Update local storage with store selection data
                    self.updateStoredVariantData(self.availabilityJSON);    
                },
                'click #SelectStore': function(e) {
                    e.preventDefault();
                    const selectedStoreId = Number($('.pickup-availabilities-list input[type="radio"][name="selected_store"]:checked').val());

                    self.updateStoreSelection(selectedStoreId);

                    // Update local storage with store selection data
                    self.updateStoredVariantData(self.availabilityJSON);    
                }
            };

            // Needs to wait for call to section rendering API to complete in ShopifyAPI.selectCallback
            document.addEventListener('availability-update', e => {
                console.log('Custom event trigger: availability-update');
                self.availabilityJSON = $('[data-availability-json]').length ? JSON.parse($('[data-availability-json]').html()) : false;
                const storedVariantAvailability = JSON.parse(localStorage.getItem('variantAvailability'));

                // Store availability data to be used in other pages
                if (!storedVariantAvailability) {
                    localStorage.setItem('variantAvailability', JSON.stringify([self.availabilityJSON]));
                } else {
                    let variantHasBeenStored = false;
                    storedVariantAvailability.forEach(variant => {
                        if (variant.variant_id === self.availabilityJSON.variant_id) {
                            variantHasBeenStored = true;
                        }
                    })
                    if (!variantHasBeenStored) {
                        localStorage.setItem('variantAvailability', JSON.stringify([...storedVariantAvailability, self.availabilityJSON]));
                    }
                }
                
                self.$availabilityList = OneDrawer.init({
                    el: self.$body,
                    drawerElem: '#availability-list',
                    triggerEvent: 'click',
                    triggerElem: '[data-pickup-availability-modal-open]',
                    openCallback: function(){}
                });  
                
                if (self.latitude && self.longitude) {
                    self.updateAvailabilityDistance();
                    const closestAvailableStore = self.availabilityJSON.stores.find(store => (store.available.toLowerCase() === "true" && (store.distance < self.availabilityDistanceLimit || self.availabilityDistanceLimit === 0)));
                    if (closestAvailableStore) {
                        self.updateAvailabilitySummary(closestAvailableStore.location.name);
                    } else {
                        self.updateAvailabilitySummary();
                    }                
                }
            });

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        // Marks the passed-in store as selected for pick-up. Deselects all stores when no ID is passed in.
        updateStoreSelection: function(selectedStoreId) {
            console.log('updateStoreSelection() start', selectedStoreId)
            let self = this;

            if(selectedStoreId) {
                self.availabilityJSON.stores.forEach(store => {
                    if (store.location.id === selectedStoreId) {
                        Object.assign(store, {selected: true});
                        document.querySelector(`.pickup-availability-list__item[data-location-id="${selectedStoreId}"] input`).checked = true;
                        self.updateAvailabilitySummary(store.location.name);
                    } 
                    else {
                        Object.assign(store, {selected: false});
                    }
                });
            } else {
                self.availabilityJSON.stores.forEach(store => {
                    Object.assign(store, {selected: false});
                });
                self.updateAvailabilitySummary("reset");
            }

            // Clear any store selections made from cart
            $.ajax({
				type: "POST",
				async: false,
				url: window.Shopify.routes.root + 'cart/update.js',
				data: {attributes: {
                    collection_method: "InstorePickup",
                    selected_store: null,
                    selected_store_id: null
                }},
				dataType: 'json',
				success: function(data) {
				},
				error: function(jqXHR, textStatus, errorThrown) {
					  console.error("Error, status = " + textStatus + ", " +
							"error thrown: " + errorThrown
					  );
				}
			});
        },

        // Updates availability data with distances from user and updates modal list item elements
        updateAvailabilityDistance: function() {
            console.log('updateAvailabilityDistance() start')
            let self = this;

            function getDistance(lat1, lon1, lat2, lon2) {
                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                }
                else {
                    let radlat1 = Math.PI * lat1/180;
                    let radlat2 = Math.PI * lat2/180;
                    let theta = lon1-lon2;
                    let radtheta = Math.PI * theta/180;
                    let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180/Math.PI;
                    dist = dist * 60 * 1.1515;
                    return dist;
                }
            }

            // Update availability data with distances
            self.availabilityJSON.stores.forEach(store => {
                const storeLatitude = store.location.latitude;
                const storeLongitude = store.location.longitude;

                Object.assign(store, {distance: getDistance(self.latitude, self.longitude, storeLatitude, storeLongitude)});
            });

            // Hide any store options that exceed the pickup distance limit
            self.availabilityJSON.stores.forEach(store => {
                if (store.distance > self.availabilityDistanceLimit && self.availabilityDistanceLimit !== 0) {
                    $(`[data-location-id="${store.location.id}"]`).hide();
                } else {
                    $(`[data-location-id="${store.location.id}"]`).show();
                }
            })


            // Sort availability data by distance and update availability modal list item elements
            self.availabilityJSON.stores.sort((store1, store2) => store1.distance - store2.distance);
            self.availabilityJSON.stores.forEach(store => {
                let $listItem = document.querySelector(`[data-location-id="${store.location.id}"]`);
                // If store is not being displayed due to unavailablity, do not append
                if ($listItem) {
                    document.querySelector('.pickup-availabilities-list').appendChild($listItem);
                }
            })

            // Update local storage with distance data
            self.updateStoredVariantData(self.availabilityJSON);
        },

        // Update the current variant's data in local storage
        updateStoredVariantData: function(newVariantData) {
            let self = this;
            const storedVariantAvailability = JSON.parse(localStorage.getItem('variantAvailability'));
            
            const newStoredVariantAvailability = storedVariantAvailability.map(variant => {
                if (variant.variant_id === self.availabilityJSON.variant_id) {
                    return newVariantData;
                } else {
                    return variant;
                }
            })

            localStorage.setItem('variantAvailability', JSON.stringify(newStoredVariantAvailability));
        },

        updateAvailabilitySummary: function(storeName) {
            console.log('updateAvailabilitySummary() start', storeName)
            const $summaryWrapper = $('.pickup-availability-information-container');
            const $locationText = $('[data-pickup-availability-title]');
            const $storeName = $('[data-pickup-availability-title] span');
            const $modalTrigger = $('[data-pickup-availability-modal-open');

            if (!storeName) {
                $summaryWrapper.hide();
                return;
            }

            if (storeName.toLowerCase() === 'reset'){
                $summaryWrapper.show();
                $locationText.hide();
                $modalTrigger.text('Select A Store For Pickup');
                $summaryWrapper.removeClass('show-store-name');
            } else if(storeName) {
                $summaryWrapper.show();
                $storeName.text(storeName);
                $modalTrigger.text('Change Store');
                $summaryWrapper.addClass('show-store-name');
                $locationText.show();
            } 
        },

        sizeChart: function(){
            var self = this;
            var $tabContainer = self.$sizeChart.find('.tab-container');
            var $tabs = $tabContainer.find('.tabs-content > div');

            if(self.$sizeChart.length > 0){
                OneTab.init({
                    el: $tabContainer,
                    afterTab: function(){

                    }
                });
                self.$sizeChart = OneDrawer.init({
                    el: self.$body,
                    drawerElem: '#size-chart',
                    triggerEvent: 'click',
                    triggerElem: '.size-chart-toggle',
                    openCallback: function(){}
                });

                // $('.size-chart-toggle').click(function (e) {
                //     e.stopPropagation();

                // })

                _.each($tabs, function(tab,index){
                    OneCustomScroll.init({
                        el: tab, // HTML object (required), not a jQuery object,
                        margin: 0 // Number (optional), margin off of the containers bounds.
                    });
                });

            }
        },

        social: function(){
            var self = this;
            var events = {
                'click .share-title':function(e){
                    self.$socialIcons.toggleClass('active');
                },
            };

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        swatches: function(){
            var self = this;
            // Init Shopify option selector
            // Option init and Swatch init needed to be separated
            new Shopify.OptionSelectors('productSelect', {
                product: self.productJSON,
                onVariantSelected: ShopifyAPI.selectCallback,
                enableHistoryState: true
            });
            OneSwatches.init({ el: self.$content, preSelect: false, product: self.productJSON });
        },

        productInfoFix: function(){
            var self = this;
            var marginOffset = 0;
            var $elemToFix = self.$productInfo.find('.product-info-wrapper');

            self.$currentFixItems = false;

            // if (!self.isMobile()) {
            //     self.$currentFixItems = $elemToFix.scrollToFixed({
            //         removeOffsets: true,
            //         spacerClass: 'fixed',
            //         fixed: function(){
            //             $(this).removeClass('unFixed');
            //             $(this).addClass('isFixed');
            //         },
            //         unfixed: function() {
            //             $(this).removeClass('isFixed');
            //             $(this).addClass('unFixed');
            //         },
            //         limit: function() {
            //             var limit = $('#fix-stopper').offset().top - $elemToFix.outerHeight() - marginOffset;
            //             // console.log('limit at ' + limit);
            //             if (!limit) {
            //                 limit = 0.01;
            //             }
            //             return limit;
            //         },
            //         zIndex: 1,
            //     });
            // }

        },

        productMedia: function(){
            var self = this;
            // var buildNav = function($images){
            //     if ($images.length) {
            //         // rebuild
            //         var $nav = self.$media.find('.image-nav');
            //         var html = '';
            //         if (!$nav.length) {
            //             $nav = $('<div class="image-nav"></div>');
            //             $nav.appendTo(self.$media);
            //             $nav.scrollToFixed({
            //                 removeOffsets: true,
            //                 spacerClass: 'fixed',
            //                 //dontSetWidth: 'not set',
            //                 limit: function() {
            //                     var limit = $('#fix-stopper').offset().top - $nav.outerHeight();
            //                     if (!limit) {
            //                         limit = 0.01;
            //                     }
            //                     return limit;
            //                 },
            //                 zIndex: 1,
            //             });
            //         }
            //         _.each($images, function(image,index){
            //             var $image = $(image),
            //                 num = index + 1;
            //             html += '<div class="item" data-index="' + $image.data('index') + '">0' + num + '</div>';
            //         });
            //         $nav.html(html);

            //         // Scroll to top after select since Image got updated
            //         $('html, body').animate({
            //             scrollTop: 0
            //         }, 0);

            //         $images.waypoint({
            //             handler: function (direction) {
            //                 if (direction === 'down') {
            //                     var $image = $(this.element);
            //                     var $currNav = $nav.find('[data-index="' + $image.data('index') + '"]');
            //                     if ($currNav.length) {
            //                         $currNav.siblings('.item').removeClass('active');
            //                         $currNav.addClass('active');
            //                     }
            //                 }
            //             },
            //             offset: 0
            //         });

            //         $images.waypoint({
            //             handler: function (direction) {
            //                 if (direction === 'up') {
            //                     var $image = $(this.element);
            //                     var $currNav = $nav.find('[data-index="' + $image.data('index') + '"]');
            //                     if ($currNav.length) {
            //                         $currNav.siblings('.item').removeClass('active');
            //                         $currNav.addClass('active');
            //                     }
            //                 }
            //             },
            //             offset: -20
            //         });

            //     } else {
            //         // build
            //         // self.$media.append('<div class="image-nav"></div>');
            //     }
            // }
            var updateNavi = function(selectedValue){
                selectedValue = selectedValue.replace(/\-| |\_|\//g,'').toLowerCase();
                var $filteredResult = self.$thumbImage.find('li').filter(function(index){
                    return $(this).data('option') == selectedValue;
                });
                // console.log($filteredResult);
                // buildNav($filteredResult);
            }
            var filterSlider = function(selectedValue){
                selectedValue = selectedValue.replace(/\-| |\_|\//g,'').toLowerCase();
                var $filteredResult = self.$thumbImage.find('li').filter(function(index){
                    return $(this).data('option') == selectedValue;
                });
                // console.log($filteredResult);
                //akd check
                if ($filteredResult.length) {
                    self.$mediaSlider.slick('slickUnfilter');
                    self.$mediaSlider.slick('slickFilter', '[data-option="' + selectedValue + '"]');
                    self.slick.setPosition();
                }
            }
            var events = {
                'change .single-option-selector' : function(e){
                    // Update slider
                    filterSlider($(e.currentTarget).val().toLowerCase());
                    updateNavi($(e.currentTarget).val().toLowerCase());
                },
                'click .image-nav .item' : function(e){
                    var $curr = $(e.currentTarget);
                    $('html, body').animate({
                        scrollTop: self.$thumbImage.find('li[data-index="' + $curr.data('index') + '"]').offset().top
                    }, 1000);
                }
            };
            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();

            // Mobile Image Slider
            self.$mediaSlider.on('init', function(event, slick, direction){
                self.slick = slick;
            });

            self.$mediaSlider = self.$mediaSlider.slick({
                dots: true,
                infinite: false,
                speed: 600,
                slidesToShow: 1,
                arrows: false,
                asNavFor: '#ProductThumbs',
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: ORW.responsiveSizes.large,
                        settings: {
                            dots: false
                        }
                    }
                ]
            });

            self.$thumbImage.on('init', function(event, slick, direction){
                self.$thumbImage.css('height', self.$mediaSlider.height());
            });

            var thumbNavigation = function(slider,i) {
                slider.slick('slickGoTo', i);
            };

            self.$thumbImage = self.$thumbImage.slick({
                dots: false,
                infinite: false,
                speed: 600,
                slidesToShow: 4,
                vertical: true,
                arrows: true,
                asNavFor: '#ProductPhoto .images-wrapper',
                // onAfterChange: thumbNavigation,
                mobileFirst: true,
                slidesToScroll: 1,
                responsive: [
                    {
                      breakpoint: 1100,
                      settings: {
                        slidesToShow: 5
                      }
                    },
                    {
                      breakpoint: 1250,
                      settings: {
                        slidesToShow: 6
                      }
                    },
                    {
                      breakpoint: 1450,
                      settings: {
                        slidesToShow: 7
                      }
                    },
                    {
                      breakpoint: 1600,
                      settings: {
                        slidesToShow: 8
                      }
                    }
                ]
            });

            var events = {
                'click #ProductThumbs .slide': function(e){
                    var $slide = $(e.currentTarget);
                    var index = $slide.data('slick-index');
                    self.$thumbImage.find('.slick-slide').removeClass('slick-current');
                    $slide.addClass('slick-current');
                    self.$thumbImage.slick('slickGoTo', index);
                    thumbNavigation(self.$mediaSlider,index);
                }
            };

            _.extend(self.events, events);
            self.delegateEvents();

            // Update Desktop Image Scroll Navigation
            if (!self.isGiftCard) {
                // buildNav(self.$thumbImage.find('li.active'));
            }

            // Update Mobile Image slider when loaded
            filterSlider(self.$mediaSlider.data('selected').toString());
        },

        zoom: function(){
            var self = this;
            OneZoom.init({
                el: self.$media,
                mainImage: self.$mainImage,
                thumbImage: self.$thumbImage
            });
        },

        tabs: function(){
            var self = this;
            if(self.isMobile()){
                $('.tab-container').find('.tab-titles > div').removeClass('active');
            }
            var tabSwitch = function($elem, className){
                $elem.addClass(className);
                $elem.siblings().removeClass(className);
            };
            var tabUpdate = function(e){
                var $curr = $(e.currentTarget);
                var $tabContainer = $curr.parents('.tab-container');
                var tabVal = $curr.attr('data-tab');
                var $activeTab  = $tabContainer.find('.tabs-content [data-tab="' + tabVal + '"]');

                tabSwitch($curr, 'active');
                tabSwitch($activeTab, 'active');
            };
            var accordion = function(e){
                var $tabWrap = $(e.currentTarget).closest('.tab-columns');
                var $accordion = $tabWrap.find('.accordion-tab');
                var $icon = $tabWrap.find('.toggle-icon');
                var height = $tabWrap.outerHeight(true) + $accordion.outerHeight(true);
                $tabWrap.toggleClass('active');
                if($tabWrap.hasClass('active')){
                    $tabWrap.css('height', height + 'px');
                    $icon.text('-');
                }else{
                    $tabWrap.css('height', '');
                    $icon.text('+');
                }
            };
            var events = {
                'click .tab-toggle' : function(e){
                    accordion(e);
                    // if(self.isMobile()){
                    //     accordion(e);
                    // }else{
                    //     tabUpdate(e);
                    // }
                }
            };
            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
        },

        responsive: function (flag) {
			// For window resize on Desktop
			var self = this,
			id = '',
            marginOffset = 0;

			function responsive(){
			    var $fixItems = self.$currentFixItems || false;
                if ($fixItems && $fixItems.css('position') == 'absolute') {
                    var limit = $('#fix-stopper').offset().top - $fixItems.outerHeight() - marginOffset;
                    var itemTop = $fixItems.offset().top;
                    // console.log('limit: ' + limit + ' / itemTop: ' + itemTop);
                    if (itemTop > limit) {
                        $fixItems.css({ top: limit });
                    }
                }
			};

			responsive();
            $(window).resize(function() {
                clearTimeout(id);
                id = setTimeout(function(){
                    console.log('window resized');
                    responsive();
                }, 400);
            });

        },

        productBottom: function(){
            var self = this;

            OneTab.init({
                el: self.$productBottom.find('.tab-container'),
                afterTab: function(){

                }
            });
        },

        inquire: function() {
            var self = this;
            var events = {
                'click .add-to-cart-btn.inquire' : function(e){
                    e.preventDefault();
                    self.$inquireForm.removeClass('fade');
                    self.$inquireForm.addClass('opened');
                },
                'click .contact-form-container .cancel' : function(e){
                    e.preventDefault();
                    self.$inquireForm.removeClass('opened');
                    self.$inquireForm.addClass('fade');
                    self.$inquireForm.find('[data-form-message]').addClass('hide')
                    self.$inquireForm.find('[data-form-elements]').removeClass('hide')
                }
            };

            OneContact.init({
                el: self.$inquireForm,
                submitType: 'json',
                successCallback: function(data) {
                    self.inquireSubmitCallBack(true,data);
                },
                errorCallback: function(err) {
                    self.inquireSubmitCallBack(false,err);
                }
            });

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();

            if (location.search.indexOf('contact_posted=true') > -1 && document.body.classList.contains('template-product')) {
              setTimeout(() => {
                $('.add-to-cart-btn.inquire').click()
              }, 300)
            }
        },

        inquireSubmitCallBack: function(isSuccess,data){
            var self = this;
            var successMsg = '<p class="global-message">Thank you for your interest!<br>We will be in touch soon.</p>';

            if (isSuccess && self.$inquireForm.length) {
              self.$inquireForm.find('form').html(successMsg);
            }
        },

        fastSimonCrossSell: function() {
            let self = this;

            const currencyFormatter = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: 'USD'
            });

            for(let id in ISP_RELATED_PRODUCTS) {
                const product = ISP_RELATED_PRODUCTS[id];
                const tags = product.att[1][1];
                const price = currencyFormatter.format(parseFloat(product.p)).replace('.00','');
                const price_compare = currencyFormatter.format(parseFloat(product.p_c)).replace('.00','');
                const vendor = product.v;

                tags.forEach(function(tag) {
                    if(tag.includes('badge_')) {
                        const badgeText = tag.replace('badge_','');
                        $(`div.isp_related_product[isp_product_id="${product.id}"] .isp_related_product_info .badge`).remove();
                        $(`div.isp_related_product[isp_product_id="${product.id}"] .isp_related_product_info`).append('<p class="badge">'+badgeText+'</p>');
                    }
                })

                $(`div.isp_related_product[isp_product_id="${product.id}"] .isp_compare_at_price`).text(price_compare);
                $(`div.isp_related_product[isp_product_id="${product.id}"] .isp_product_price`).text(price);
    
                $(`div.isp_related_product[isp_product_id="${product.id}"] .isp_product_info .designer-name`).remove();
                $(`div.isp_related_product[isp_product_id="${product.id}"] .isp_related_product_info`)
                    .prepend('<p class="designer-name">'+vendor+'</p>');
            }
        },

        // crossSell: function(e){
        //     var self = this;
        //     var $crossSell = $('#cross-sell .cross-sell');
        //     $crossSell.slick({
        //         dots: false,
        //         infinite: true,
        //         speed: 600,
        //         slidesToShow: 1,
        //         arrows: true,
        //         centerMode: true,
        //         centerPadding: '20%',
        //         prevArrow: '<button class="slick-arrow slick-prev"></button>',
        //         nextArrow: '<button class="slick-arrow slick-next"></button>'
        //     });
        // },

        // relatedProducts: function () {
        //     var self = this;
        //     var $scrollCta = self.$content.find('.scroll-to').addClass('active');
        //     var events = {
        //         'click .scroll-to' : function(e){
        //             $('html, body').animate({
        //                 scrollTop: self.$relatedProducts.offset().top
        //             }, 500);
        //         }
        //     }
        //     $scrollCta.scrollToFixed({
        //         removeOffsets: true,
        //         spacerClass: 'fixed',
        //         //dontSetWidth: 'not set',
        //         limit: function() {
        //             var limit = $('#fix-stopper').offset().top - self.$productInfo.find('.scroll-to').outerHeight();
        //             return limit;
        //         },
        //         zIndex: 1,
        //     });
        //     // Update and delegate adding events
        //     _.extend(self.events, events);
        //     self.delegateEvents();
        // },

        isDesktop: function () {
            var self = this;
            var w = $(window).width();
            if (w > ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        },

        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.medium) {
                return true;
            }
            return false;
        }

    });

    return ViewProduct;

});
define('page-product',[
    "view-product",
    "domReady",
    "jquery"
], function (ViewProduct, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
      setTimeout(() => {
        generateSwatchList();          
      }, 1000);      
      new ViewProduct({el: $('.product-single')});
    });

    async function fetchTaggedProducts(tag) {
      const res = await fetch(`/collections/all/${tag}?view=json`);
      return await res.json();
    }
    
  async function generateSwatchList() {
    const $list = document.querySelector('.swatch-list');
    const groupTag = $list?.dataset.swatchGroup;
    const products = await fetchTaggedProducts(groupTag);
    const colorSource = document.querySelector('.current-color');
    const currentColor = colorSource?.dataset.currentColor;
    if (products.items && products.items.length > 1) {
      products.items.forEach((product) => {
        if(product.available && $list != null) {
          const $item = document.createElement('div');  
          let color =  product.variants[0].option1;
          let colorClass = color.toLowerCase();
          colorClass = colorClass.replace(/\s/g, '');
          let swatchStyle = '';
          const colorSwatch = product.color_swatch;
          if (colorSwatch != null && colorSwatch.color_name != null && colorSwatch.color_name.toLowerCase().replace(/\s/g, '') == colorClass) {
            if (colorSwatch.image != null) {
              swatchStyle = `style="background: url(${colorSwatch.image}) no-repeat center;background-size: contain;"`
            } else if (colorSwatch.gradient != null) {
              swatchStyle = `style="background: ${colorSwatch.gradient}"`
            } else if (colorSwatch.hex_code != null) {
              swatchStyle = `style="background-color: ${colorSwatch.hex_code}"`
            }
          }

          $item.classList.add('swatch-list__item');
          $item.innerHTML = `
              <li>
                <a href="/products/${product.handle}"
                  class="swatch-list__link color-${colorClass}${colorClass == currentColor ? " active" : ""}"
                  ${swatchStyle}>
                </a>
              </li>
            `;
          $list.appendChild($item);
        }
      });
      if ($list) {
        $list.addClass('active')
      }
    }
  }    

});

define('module-oneGoogleForm',[
	"jquery",

	], function ($) {

	"use strict";

	/*
		OneGoogleForm 1.0.0 Usage
		Patrick @onerockwell

        Form source must be copied directly from google form page (input names are most important, structure can change).
        Example in snippets/google-form.liquid uses source from https://docs.google.com/forms/d/e/1FAIpQLSfJae4_I0aNee61pCCai6S_ZfJXl6XHDn60-Uim0zw9YY8P7A/viewform
        We post form data directly to google but we cannot get error handling in response.
        You cannot submit a file upload field with this module, violates CORS.
        TODO: add support for multiple choice radios and checkboxes. Currently only supports input[type="text"] and textarea.
        
        OneGoogleForm.init({
            el: $('.google-form')
        });
        
  	*/

  	var OneGoogleFormView = Backbone.View.extend({
		
		initialize: function (settings) {
			var self = this;
            self.$googleForm = self.$el;
            self.$submitButton = self.$googleForm.find('.submit-google-form');
            if (!self.$googleForm.length) {
                return false;
            }
            console.log("init oneGoogleForm");
		},

		events: {
            'click .submit-google-form': function(e) {
                e.preventDefault();
                var self = this;
                self.googleFormSubmit();
            }
		},

        googleFormSubmit: function(){
            var self = this;
            $.ajax({
                type: "POST",
                dataType: "xml",
                url: self.$googleForm.attr('action'),
                data: self.$googleForm.serialize(),
                statusCode: {
                    0: function() {
                        //Success message
                        console.log("status code 0");
                        self.$googleForm.addClass('submitted');
                        self.$googleForm.next('.form-success-message').removeClass('hide');
                    }
                }
            });
        }

	});

	var OneGoogleForm = {
		init: function (settings) {
			return new OneGoogleFormView(settings);
		}
	}

	return OneGoogleForm;

});
define('view-cms',[
    'jquery',
    'module-oneGoogleForm'
], function ($, OneGoogleForm) {

    "use strict";

    var ViewCms = Backbone.View.extend({

        initialize: function(opts){
            var self = this;

            OneGoogleForm.init({
                el: $('.google-form')
            });
        },

        events: {
            
        },
        
        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        }

    });

    return ViewCms;

});
define('page-cms',[
    "view-cms",
    "domReady",
    "jquery"
], function (ViewCms, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
        console.log('init cms');
        new ViewCms({el: $('#MainContent')});

        $('#isp_refine_nevigation').append('<i class="dropdown-chevron icon-chevron-down-small"></i>')
        $('#isp_refine_nevigation').append('<i class="dropdown-chevron icon-chevron-up-small"></i>')

        $('.dropdown-toggle-isp .caret').remove();
        $('.dropdown-toggle-isp').append('<i class="dropdown-chevron icon-chevron-down-small"></i>')
        $('.dropdown-toggle-isp').append('<i class="dropdown-chevron icon-chevron-up-small"></i>')
    });

});

if ($(document.body).hasClass('template-page')) {
    window.addEventListener('fs-serprender', function(event) {

        var currencyFormatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: 'USD'
        });

        // Append search query
        var searchQuery = $('#isp_results_search_text').text();
        $('#MainContent h1:first-child').text('Search Results for "'+searchQuery+'"');
    
        for(var id in ISP_PRODUCTS) {
            var product = ISP_PRODUCTS[id];
            var tags = product.att[1][1];
            var price = currencyFormatter.format(parseFloat(product.p)).replace('.00','');
            var price_compare = currencyFormatter.format(parseFloat(product.p_c)).replace('.00','');
            var vendor = product.v;
    
            tags.forEach(function(tag) {
                if(tag.includes('badge_')) {
                    var badgeText = tag.replace('badge_','');
                    $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info .badge').remove();
                    $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info').append('<p class="badge">'+badgeText+'</p>');
                }
            })

            $('li.isp_grid_product[product_id="'+product.id+'"] .isp_compare_at_price').text(price_compare);
            $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_price').text(price);
    
            $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info .designer-name').remove();
            $('li.isp_grid_product[product_id="'+product.id+'"] .isp_product_info')
                .prepend('<p class="designer-name">'+vendor+'</p>');
        }
    })
    
    window.addEventListener('fs-noresults', function(event) {
        $('.isp_center_container_header').hide();
        $('#isp_search_results_container').empty();
        $('#isp_search_results_container')
        .text('Your search did not yield any results.\nIf you require assistance with your search, please contact customerservice@kirnazabete.com. Give us a call at (212) 941-9656')
        .css({
            'padding': '50px',
            'justify-content': 'center'
        })
    })
}
;
/*! Copyright 2012, Ben Lin (http://dreamerslab.com/)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Version: 1.0.19
 *
 * Requires: jQuery >= 1.2.3
 */
;( function ( factory ) {
if ( typeof define === 'function' && define.amd ) {
    // AMD. Register module depending on jQuery using requirejs define.
    define( 'jquery.actual',['jquery'], factory );
} else {
    // No AMD.
    factory( jQuery );
}
}( function ( $ ){
  $.fn.addBack = $.fn.addBack || $.fn.andSelf;

  $.fn.extend({

    actual : function ( method, options ){
      // check if the jQuery method exist
      if( !this[ method ]){
        throw '$.actual => The jQuery method "' + method + '" you called does not exist';
      }

      var defaults = {
        absolute      : false,
        clone         : false,
        includeMargin : false,
        display       : 'block'
      };

      var configs = $.extend( defaults, options );

      var $target = this.eq( 0 );
      var fix, restore;

      if( configs.clone === true ){
        fix = function (){
          var style = 'position: absolute !important; top: -1000 !important; ';

          // this is useful with css3pie
          $target = $target.
            clone().
            attr( 'style', style ).
            appendTo( 'body' );
        };

        restore = function (){
          // remove DOM element after getting the width
          $target.remove();
        };
      }else{
        var tmp   = [];
        var style = '';
        var $hidden;

        fix = function (){
          // get all hidden parents
          $hidden = $target.parents().addBack().filter( ':hidden' );
          style   += 'visibility: hidden !important; display: ' + configs.display + ' !important; ';

          if( configs.absolute === true ) style += 'position: absolute !important; ';

          // save the origin style props
          // set the hidden el css to be got the actual value later
          $hidden.each( function (){
            // Save original style. If no style was set, attr() returns undefined
            var $this     = $( this );
            var thisStyle = $this.attr( 'style' );

            tmp.push( thisStyle );
            // Retain as much of the original style as possible, if there is one
            $this.attr( 'style', thisStyle ? thisStyle + ';' + style : style );
          });
        };

        restore = function (){
          // restore origin style values
          $hidden.each( function ( i ){
            var $this = $( this );
            var _tmp  = tmp[ i ];

            if( _tmp === undefined ){
              $this.removeAttr( 'style' );
            }else{
              $this.attr( 'style', _tmp );
            }
          });
        };
      }

      fix();
      // get the actual value with user specific methed
      // it can be 'width', 'height', 'outerWidth', 'innerWidth'... etc
      // configs.includeMargin only works for 'outerWidth' and 'outerHeight'
      var actual = /(outer)/.test( method ) ?
        $target[ method ]( configs.includeMargin ) :
        $target[ method ]();

      restore();
      // IMPORTANT, this plugin only return the value of the first element
      return actual;
    }
  });
}));
/*
	Onemodal 3.0.0 
	Adding Magento 2.0 compatibility
	Adding Responsive ( Large to Small )
	Yang@onerockwell
*/

define('module-oneModal',[
	"jquery",
	'text!' + ORW.appUrl + '/app-template-oneModalFrame.html' + ORW.appUrlHash,
	'text!' + ORW.appUrl + '/app-template-oneModalInnermessage.html' + ORW.appUrlHash,
	'text!' + ORW.appUrl + '/app-template-oneModalDefault.html' + ORW.appUrlHash,
	'text!' + ORW.appUrl + '/app-template-oneModalMessage.html' + ORW.appUrlHash,
	'text!' + ORW.appUrl + '/app-template-oneModalMessagebox.html' + ORW.appUrlHash,
	'text!' + ORW.appUrl + '/app-template-oneModalVideo.html' + ORW.appUrlHash,
	'text!' + ORW.appUrl + '/app-template-oneModalLoadingtext.html' + ORW.appUrlHash,
	'text!' + ORW.appUrl + '/app-template-oneModalQuickshop.html' + ORW.appUrlHash,
	'jquery.actual'
	], function ($, FrameTemp, InnermessageTemp, DefaultTemp, MessageTemp, MessageBoxTemp, VideoTemp, LoadingTextTemp, QuickShopTemp) {

	var OnemodalView = Backbone.View.extend({

		initialize: function (settings) {
			this.$onemodal = this.$el;
			this.$overlay = this.$el.find('.overlay');
			this.$modalContent = this.$el.find('.box-content');
			this.$close = this.$el.find('.close');
			this.$modalContentInner = this.$el.find('.box-content .box-inner').html(settings.contentHtml);
			this.$innerLoadingContainer = this.$el.find('.inner-loading-container');
			this.$videobox = this.$modalContent.find('.video');

			this.animation = settings.animate;
			this.theme = settings.theme;
			this.modalClass = settings.modalClass;
			this.width = settings.width ? settings.width : 0;
			this.height = settings.height ? settings.height : 0;
			this.callback = settings.callback;
			this.showOverLay = settings.overlay != 'none' ? true : false;
			this.overlayOpacity = 0.65;
			this.fadeSpeed = 300;
			this.openSpeed = 250;
			this.pageWidth = 974;
			this.engageFlag = false;

			return this;
		},

		update: function (settings) {
			var self = this;
			var html = settings.contentHtml;
			var margin = settings.margin;
			var mh = 2;
			
			self.engageFlag = true;
			self.theme = settings.theme;
			self.animation = settings.animate;
			self.modalClass = settings.modalClass;

			// Update and delegate adding events
			_.extend(self.events, settings.events);
			self.delegateEvents();

			if ( self.animation == 'fade' ) {
				self.$modalContentInner.transition({ 'opacity': 0 }, self.fadeSpeed, 'ease', function () {

					var $newInner = self.$modalContentInner.html(html);
					var w = settings.width ? settings.width : self.$modalContentInner.actual('width', { absolute : true, includeMargin : true });
					var h = settings.height ? settings.height : self.$modalContentInner.actual('height', { absolute : true, includeMargin : true });

					if (self.$modalContentInner.find('.video').length) {
						self.$videobox = self.$modalContentInner.find('.video');
					};
					
					if (self.$onemodal.hasClass('loader')) {
						self.$onemodal.removeClass('loader').addClass(self.modalClass);
						self.$modalContent.css({
							'opacity': 0,
							'width': w,
							'height': 'auto',
							'transform': 'translate(-50%,-50%)'
						}).transition({ 'opacity': 1 }, self.fadeSpeed, 'ease', function(){
							self.$modalContent.css({ 'overflow': 'visible' });
							self.$modalContentInner.transition({ 'opacity': 1 }, self.fadeSpeed, 'ease', function(){
								self.engageFlag = false;
								self.$modalContent.css({
									'width' : 'calc(100% - ' + margin + 'px)',
									'maxWidth' : w,
									'height' : 'auto',
								});
							});
							self.theme != 'loader' && self.$close.css({ 'opacity' : 1 });
							
							settings.callback();
						});
					} else {
						self.$modalContent.transition({
							'width': w,
							}, self.openSpeed, 'ease', function(){
								self.$modalContent.transition({
									'height': 'auto',
								}, self.openSpeed, 'ease', function () {
									self.$modalContent.css({ 'overflow': 'visible' });
									self.$modalContentInner.transition({ 'opacity': 1 }, self.fadeSpeed, 'ease', function(){
										self.engageFlag = false;
										self.$modalContent.css({
											'width' : 'calc(100% - ' + margin + 'px)',
											'maxWidth' : w,
											'height' : 'auto',
										});
									});
									self.theme != 'loader' && self.$close.css({ 'opacity' : 1 });
									
									settings.callback();
								});
						});
					}

				});
			} else {
				self.$modalContentInner.transition({ 'opacity': 0 }, self.fadeSpeed, 'ease', function () {
					self.$modalContent.transition({
						'height': mh,
						// 'marginTop': -mh/2
					}, self.openSpeed, 'ease', function(){
						self.$modalContent.transition({
							'width': 0,
							// 'marginLeft': 0,
						}, self.openSpeed, function(){

							var $newInner = self.$modalContentInner.html(html);
							self.$onemodal.removeClass('loader');
							self.theme != 'loader' && self.$modalContent.css({ 'transform': 'translateY(0)' });
							
							var w = settings.width ? settings.width : self.$modalContentInner.actual('width', { absolute : true, includeMargin : true });
							var h = settings.height ? settings.height : self.$modalContentInner.actual('height', { absolute : true, includeMargin : true });
							if (self.$modalContentInner.find('.video').length) {
								self.$videobox = self.$modalContentInner.find('.video');
							};

							self.$modalContent.transition({
								'width': w,
								// 'marginLeft': -w/2,
								}, self.openSpeed, 'ease', function(){
									self.$modalContent.transition({
										'height': h,
										// 'marginTop': -h/2
									}, self.openSpeed, 'ease', function () {
										self.$modalContent.css({ 'overflow': 'visible' });
										self.$modalContentInner.transition({ 'opacity': 1 }, self.fadeSpeed, 'ease', function(){
											self.engageFlag = false;
											self.$modalContent.css({
												'width' : 'calc(100% - ' + margin + 'px)',
												'maxWidth' : w,
												'height' : 'auto',
											});
										});
										self.theme != 'loader' && self.$close.css({ 'opacity' : 1 });
										
										settings.callback();
									});
							});
						});
					});
				});
			}

			return this;
		},

		show: function () {
			var self = this;

			self.engageFlag = true;
			self.$onemodal.addClass(self.modalClass).show();
			self.callback();

			var w = self.width ? self.width : self.$modalContentInner.actual('outerWidth', { absolute : true, includeMargin : true });
			var h = self.height ? self.height : self.$modalContentInner.actual('outerHeight', { absolute : true, includeMargin : true });
			var mh = 2;
			var margin = 0;

			if(self.animation == "openshow") {
				self.$overlay.transition({opacity: self.overlayOpacity}, self.fadeSpeed, 'ease', function(){
					self.$modalContent.css({
						'width': 0,
						'height': mh,
						// 'marginTop': -mh/2,
						// 'marginLeft': 0,
						'opacity': 1,
					}).transition({
						'width': w,
						// 'marginLeft': -w/2
						}, self.openSpeed, 'ease', function(){
							self.$modalContent.transition({
								'height': h,
								// 'marginTop': -h/2,
							}, self.openSpeed, 'ease', function () {
								self.$modalContent.css({ 'overflow': 'visible' });
								self.$modalContentInner.transition({ 'opacity': 1 }, self.fadeSpeed, 'ease', function(){
									self.engageFlag = false;
								});
								self.theme != 'loader' && self.$close.css({ 'opacity' : 1 });
							});
					});
				});
			}else {
				if (self.showOverLay){
					self.$overlay.transition({opacity: self.overlayOpacity}, self.fadeSpeed, 'ease', function(){
						self.$modalContentInner.css({ 'opacity': 1 });
						self.$modalContent.css({
							'width': w,
							'height': 'auto',
							'transform': 'translate(-50%,-50%)'
						}).transition({ 'opacity': 1, 'transform': 'translate(-50%,-50%)', }, self.fadeSpeed, 'ease', function(){
							self.$modalContent.css({ 'overflow': 'visible' });
							self.engageFlag = false;
							self.theme != 'loader' && self.$close.css({ 'opacity' : 1 });
						});
					});
				} else {
					self.$modalContentInner.css({ 'opacity': 1 });
					self.$modalContent.css({
						'width': w,
						'height': 'auto',
						'transform': 'translate(-50%,-50%)'
					}).transition({ 'opacity': 1, 'transform': 'translate(-50%,-50%)', }, self.fadeSpeed, 'ease', function(){
						self.$modalContent.css({ 'overflow': 'visible' });
						self.engageFlag = false;
						self.theme != 'loader' && self.$close.css({ 'opacity' : 1 });
					});
				}
			};

			return this;
		},

		hide: function (forceClose) {
			var self = this;
			var mh = 3;

			if (self.engageFlag && self.theme != 'loader') return false;

			if (self.theme != 'loader' || forceClose) {

				self.$close.css({ 'opacity' : 0 });

				// Hide inner message/loader box before close the modal
				if (self.$innerLoadingContainer.is(':visible')) {
					self.$innerLoadingContainer.hide();
				}

				if (self.animation == 'openshow') {
					self.$modalContentInner.transition({ 'opacity': 0 }, self.fadeSpeed, 'ease', function () {
						self.$modalContent.css({ 'overflow': 'hide' });
						self.$modalContent.transition({
							'height': mh,
							// 'marginTop': -mh/2,
						}, self.openSpeed, 'ease', function(){
							self.$modalContent.transition({
								'width': 0,
								// 'marginLeft': 0,
								'height': 0,
								// 'marginTop': 0
							}, self.openSpeed, function(){
								self.$overlay.transition({opacity: 0}, self.fadeSpeed, 'ease', function(){
									self.$onemodal.remove();
									self.destory();
								})
							});
						});
					});

				} else {
					self.$modalContent.css({ 'overflow': 'hide' });
					self.$modalContent.transition({ 'opacity': 0, 'transform': 'translate(-50%,-50%)', }, self.fadeSpeed, 'ease', function(){
						self.$overlay.transition({opacity: 0}, self.fadeSpeed, 'ease', function(){
							self.$onemodal.remove();
							self.destory();
						})
					});
				};
			}

			
			return this;
		},

		resize: function () {
			var self = this;
			return self;
		},

		destory: function() {
			this.undelegateEvents();
		}
	});

	var Onemodal = {
		/*
			Settings

			content = {
				type: '',		// *Accept 'success', 'error', 'video' ...
				content: ''		// Accept content string or html
				w: 300,			// Video width
				h: 200,			// Video height
				url: '',		// *Video link
				videoType: 'vm' // Video type, Accept 'yt' and 'vm'
			}

			settings = {
				theme : '', 	// *Accept NA, 'loader' and 'dark', this controls the layout of modal box
				type : '', 		// *Accept any title and title class for modal content
				animate : '', 	// Accept 'fade' or 'openshow'
				width : '',		// Accept new window width, shouldn't be used while set video width
				height : '', 	// Accept new window height, shouldn't be used while set video height
				content : content,
			}
		*/

		buildBox: function (settings) {
			
			// Old _.template return string has been deprecated since _.1.7.0 @yang
			var frame = _.template(FrameTemp);  
			frame = frame({content: settings});
			var e = {};
			e = {
				'click .overlay' : function (e) { e.stopPropagation(); this.hide(); },
				'click .box-content > .close'   : function (e) { e.stopPropagation(); this.hide(); },
				'click .confirm' : function (e) { e.stopPropagation(); this.hide(); },
				'click .cancel'  : function (e) { e.stopPropagation(); this.hide(); },
			};
			

			// Extend default events with adding events, e holds the final events
			_.extend(e, settings.events);
			settings.events = e;

			// Build up frame for alert box
			if ($('body').find('.onemodal').length) {
				$('body').find('.onemodal').remove();
			};
			settings.el = $(frame).appendTo("body");

			return new OnemodalView(settings);
		},

		showMessage: function(settings) {
			settings.theme = settings.theme ? settings.theme : '';
			settings.modalClass = settings.modalClass ? settings.modalClass : '';
			settings.animate = settings.animate ? settings.animate : 'openshow';
			settings.contentHtml = this.buildTemplate(settings.type, settings.content);
			settings.callback = settings.callback ? settings.callback : function(){};
			var box = this.buildBox(settings);
			this.currentBox = box.show();
			return this;
		},

		updateMessage: function(settings) {
			settings.theme = settings.theme ? settings.theme : '';
			settings.modalClass = settings.modalClass ? settings.modalClass : '';
			settings.animate = settings.animate ? settings.animate : 'openshow';
			settings.contentHtml = this.buildTemplate(settings.type, settings.content);
			settings.callback = settings.callback ? settings.callback : function(){};
			if (this.currentBox) {
				var self = this;
				setTimeout(function() {
					self.currentBox.update(settings); // Update including auto reposition for new loaded content
				}, 300);
			};
			return this;
		},

		showLoading: function (settings) {
			var settings = settings || {};

			settings = { 'theme': 'loader', 'modalClass': 'loader-class', 'animate': 'fade', 'loadingtext': settings.loadingtext, 'events': settings.events, 'overlay': settings.overlay };
			settings.callback = settings.callback ? settings.callback : function(){};
			if (settings.loadingtext) {
				settings.contentHtml = this.buildTemplate('loadingtext', { content: settings.loadingtext });
			}

			var box = this.buildBox(settings);
			this.currentBox = box.show();
			return this;
		},

		hideLoading: function () {
			if (this.currentBox) {
				this.currentBox.hide(true);
			};
			return this;
		},
		
		close: function () {
			if (this.currentBox) {
				this.currentBox.hide(true);
			};
			return this;
		},


		// For inner loading and message box
		showInnerMessage: function(d){
			var self = this;
			self.updateInnerMessage(d, true)
		},

		updateInnerMessage: function(d, ctl){
			var self = this;
			ctl = ctl || false
			if (self.currentBox) {
				var innerHtml = self.buildTemplate('innermessage', d);
				var $innerLoader = self.currentBox.$el.find('.inner-loading-container');
				var $loader = $innerLoader.find('.loading');
				var $messageBox = $innerLoader.find('.message').html(innerHtml);

				if (!ctl) {
					$loader.transition({ "opacity": 0 }, 150, 'ease', function () {
						$messageBox.transition({ "opacity": 1 }, 150, 'ease');
					});
				}else {
					$messageBox.transition({ "opacity": 1 }, 150, 'ease');
					$innerLoader.show().transition({ "opacity": 1 }, 250, 'ease');
				};


				$innerLoader.on('click', function () {
					self.hideInnerLoading();
				});
			};
		},

		showInnerLoading: function () {
			var self = this;
			if (self.currentBox) {
				var $innerLoader = self.currentBox.$el.find('.inner-loading-container');
				var $loader = $innerLoader.find('.loading').css({ "opacity": 1 });
				var $messageBox = $innerLoader.find('.message').css({ "opacity": 0 });

				if ($innerLoader.length) {
					if (!$innerLoader.is(':visible')) {
						$innerLoader.show().transition({ "opacity": 1 }, 250, 'ease');
					};
				};

				$innerLoader.on('click', function () {
					self.hideInnerLoading();
				});
			};

			return this;
		},

		hideInnerLoading: function () {
			var self = this;
			if (self.currentBox) {
				var $innerLoader = self.currentBox.$el.find('.inner-loading-container');
				var $loader = $innerLoader.find('.loading');
				var $messageBox = $innerLoader.find('.message');

				if ($innerLoader.length) {
					if ($innerLoader.is(':visible')) {
						$innerLoader.transition({ "opacity": 0 }, 250, 'ease', function(){
							$(this).hide();
							$loader.css({ "opacity": 1 });
							$messageBox.css({ "opacity": 0 });
						});
					};
				};
			};

			return this;
		},

		buildTemplate: function (type, innercontent) {
			var typeTemplate;
			var data = {};

			switch(type) {
				case '':
					typeTemplate = DefaultTemp;
					break;
				case 'default':
					typeTemplate = DefaultTemp;
					break;
				case 'message':
					typeTemplate = MessageTemp;
					break;
				case 'messagebox':
					typeTemplate = MessageBoxTemp;
					break;
				case 'video':
					typeTemplate = VideoTemp;
					break;
				case 'quickshop':
					typeTemplate = QuickShopTemp;
					break;
				case 'loadingtext':
					typeTemplate = LoadingTextTemp;
					break;
				case 'innermessage':
					typeTemplate = InnermessageTemp;
					break;
			};
			
			var compiled = _.template(typeTemplate);
			return compiled({content: innercontent});

			// return _.template( typeTemplate, {content: innercontent}, {escape: false} ); Deprecated since _.1.7.0 @yang
			
			
		}
	}

	return Onemodal;
});

define('view-styleGuide',[
    'jquery',
    'module-oneModal'
], function ($, Onemodal) {

    "use strict";

    var ViewStyleGuide = Backbone.View.extend({

        // Styleguide Init Function
		initialize: function (opts) {
			console.log('init styleguide view !');
			var self = this;
            			
			self.initGrid();
			
			$(document).on('click', function(){
				self.$el.find('.grid-col').removeClass('show-frame');
			});
			
		},
		
		events: {
			'click .bleeding-ctl' : function(e){
				var self = this;
				e.preventDefault();
				e.stopPropagation();
				self.$el.toggleClass('full-bleed');
			},
			'click .frame-ctl' : function(e){
				var self = this;
				e.preventDefault();
				e.stopPropagation();
				self.$el.find('.grid-system').toggleClass('show-frame');
			},
			'click .grid-col' : function(e){
				var self = this,
				$curr = $(e.currentTarget);
				e.preventDefault();
				e.stopPropagation();
				self.$el.find('.grid-col').not(e.currentTarget).removeClass('show-frame');
				$curr.toggleClass('show-frame');
			}
		},
		
		initGrid: function () {
			var self = this,
			html = '';
			self.$grid = self.$el.find('.grid-system');
			if (self.$grid.length && gridConfig) {
				_.each(gridConfig, function(row, index){
					html += '<div class="grid-row" title="row: ' + (index+1) +'">';
					if (row.col && row.col.length > 0) {
						_.each(row.col, function(col){
							
							switch (col.style) {
								case 'padding':
									html += '<div class="grid-col grid-padding grid-col-' + col.value + '"></div>';
									break;
								case 'margin':
									html += '<div class="grid-col grid-col-with-margin-' + col.value + '"></div>';
									break;
								default:
									html += '<div class="grid-col grid-col-' + col.value + '"></div>';
							}
							
						});
					} else if (row.col) {
						var temp = '<div class="grid-col grid-col-with-margin-1"></div>';
						html += temp.repeat(12);
					}
					html += '</div>'
				})
				self.$grid.append(html);
			}
		},
		
		destroy: function () {
			this.undelegateEvents();
		}

    });

    return ViewStyleGuide;

});
define('page-styleGuide',[
    "view-styleGuide",
    "domReady",
    "jquery"
], function (ViewStyleGuide, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
        console.log('init style guide');
        new ViewStyleGuide({el: $('.style-guide-wrapper')});
    });

});

define('view-login',[
    'jquery',
], function ($) {

    "use strict";

    var ViewLogin = Backbone.View.extend({

		recoverPassword: '#RecoverPassword',
		recoverPasswordForm: '#RecoverPasswordForm',
		hideRecoverPasswordLink: '#HideRecoverPasswordLink',
		customerLoginForm: '#CustomerLoginForm',
		resetSuccess: '#ResetSuccess',
		resetSuccessMessage: '.reset-password-success',
		recoverHash: '#recover',

        // Login Init Function
		initialize: function (opts) {
			var self = this;
			if ($(self.recoverPassword).length > 0) {
				self.formInit();
			}
		},

        events: {

        },

		formInit: function(){
			// The contents of this form js are taken from /src/scripts/templates/customers-login.js
			// It has been refactored to fit within the onerockwell js framework.
			var self = this;

			self.checkUrlHash();
			self.resetPasswordSuccess();

			var events = {
                'click #RecoverPassword' : function(e){
					console.log('recover password');
					e.stopPropagation();
	                self.onShowHidePasswordForm(e);
	            },
	            'click #HideRecoverPasswordLink' : function(e){
					console.log('hide recover');
	                self.onShowHidePasswordForm(e);
	            }
            }

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();
		},

		onShowHidePasswordForm: function(e) {
			var self = this;
			e.preventDefault();
			self.toggleRecoverPasswordForm();
		},

		checkUrlHash: function() {
			var self = this;
			var hash = window.location.hash;

			// Allow deep linking to recover password form
			if (hash === self.recoverHash) {
				self.toggleRecoverPasswordForm();
			}
		},

		toggleRecoverPasswordForm: function(){
			/**
			*  Show/Hide recover password form
			*/
			var self = this;
			$(self.recoverPasswordForm).toggleClass('hide');
			$(self.customerLoginForm).toggleClass('hide');
		},

		resetPasswordSuccess: function(){
			/**
			*  Show reset password success message
			*/
			var self = this;
			var $formState = $(self.resetSuccessMessage);

			// check if reset password form was successfully submited.
			if (!$formState.length) {
				return;
			}

			// show success message
			$(self.resetSuccess).removeClass('hide');
		}

    });

    return ViewLogin;

});
define('page-login',[
    "view-login",
    "domReady",
    "jquery"
], function (ViewLogin, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
        console.log('init login page');
        new ViewLogin({el: $('.login-box')});
    });

});

define('view-account',[
	'jquery',
	"module-oneTab"
], function ($, OneTab) {

	"use strict";

	var ViewAccount = Backbone.View.extend({
		addressForms: '.address-form',
		newAddressForm: '#AddressNewForm',
		newAddressShow: '.address-new-show',
		newAddressHide: '.address-new-hide',
		newAddressPrimaryToggle: '.address-new-toggle.main-toggle',
		editAddressHide: '.address-edit-hide',
		editAddressShow: '.address-edit-show',
		editAddressDelete: '.address-delete',
		editAddressId: '#EditAddress_',
		addressContainer: '.address-list',
		addressList: '.address-list .address',
		addressDetails: '.address-list .address-details',
		addressCountryOption: '.address-country-option',
		addressCountryNew: 'AddressCountryNew', //no '.' or '#'
		addressProvinceNew: 'AddressProvinceNew', //no '.' or '#'
		addressProvinceContainerNew: 'AddressProvinceContainerNew', //no '.' or '#'

		// Login Init Function
		initialize: function (opts) {
			var self = this;
			self.$body = $('body');

			if ($('body').hasClass('template-customers-addresses')) {
				self.addresses();
			}

			if ($('body').hasClass('template-customers-account') || $('body').hasClass('template-customers-addresses') || $('body').hasClass('template-customers-order')) {
				self.navTabs();
			}
		},

		events: {

		},

		bodyClassCtl : function(){
			// Please prevent operation on more then one drawer at the same time
			var self = this;
			self.$body.toggleClass('show-overlay');
			console.log('TOGGLE CLASS: ', self.$body);
		},

		addresses: function () {
			var self = this;

			var $addressForms = $(self.addressForms);
			var $newAddressForm = $(self.newAddressForm);

			if (!$newAddressForm.length) {
				return;
			}

			// Initialize observers on address selectors, defined in shopify_common.js
			if (Shopify) {
				new Shopify.CountryProvinceSelector(self.addressCountryNew, self.addressProvinceNew, {
					hideElement: self.addressProvinceContainerNew
				});
			}

			// Initialize each edit form's country/province selector
			$(self.addressCountryOption).each(function () {
				var formId = $(this).data('form-id');
				var countrySelector = 'AddressCountry_' + formId;
				var provinceSelector = 'AddressProvince_' + formId;
				var containerSelector = 'AddressProvinceContainer_' + formId;

				new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
					hideElement: containerSelector
				});
			});

			function hideAddressForm() {
				$addressForms.addClass('hiding');
				setTimeout(function() {
					$addressForms.removeClass('hiding').addClass('hide');
				}, 300);
				self.$body.removeClass('show-overlay');
			}

			self.$body.on('click', function () {
				$(this).removeClass('show-overlay');
				hideAddressForm();
			});

			$('.address-form').click(function (e) {
				e.stopPropagation();
			});

			// Toggle new/edit address forms
			$(self.newAddressShow).on('click', function (e) {
				e.stopPropagation();
				$newAddressForm.removeClass('hide');
				$(self.newAddressPrimaryToggle).removeClass('hide');
				$(self.addressDetails).removeClass('hide');
				$(self.addressContainer).removeClass('hide');
				self.$body.addClass('show-overlay');
			});

			$(self.newAddressHide).on('click', function (e) {
				e.stopPropagation();
				hideAddressForm();
			});

			console.log('CLICK ON SHOW ', $(self.editAddressShow));
			$(self.editAddressShow).on('click', function (e) {
				e.stopPropagation();
				var formId = $(this).data('form-id');
				$(self.editAddressId + formId).removeClass('hide');
				$(self.newAddressPrimaryToggle).removeClass('hide');
				$(self.addressDetails).removeClass('hide');
				$(self.addressList).removeClass('open');
				self.$body.addClass('show-overlay');
			});

			$(self.editAddressHide).on('click', function (e) {
				e.stopPropagation();
				var formId = $(this).data('form-id');
				hideAddressForm();
			});

			$(self.editAddressDelete).on('click', function () {
				var $el = $(this);
				var formId = $el.data('form-id');
				var confirmMessage = $el.data('confirm-message');
				if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
					Shopify.postLink('/account/addresses/' + formId, {
						parameters: {
							_method: 'delete'
						}
					});
				}
			});
		},

		navTabs: function () {
			var self = this;
			var $navigationTabs = self.$el.find('.tab-container.container');

			OneTab.init({
				el: $navigationTabs
			});

			var events = {

			};

			// Update and delegate adding events
			_.extend(self.events, events);
			self.delegateEvents();

		}

	});

	return ViewAccount;

});
define('page-account',[
    "view-account",
    "domReady",
    "jquery"
], function (ViewAccount, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
    	console.log('init account');
        new ViewAccount({el: $('#MainContent')});
    });

});

define('view-article',[
	'jquery',
	'module-oneDrawer'
], function ($, OneDrawer) {

	"use strict";

	var ViewArticle = Backbone.View.extend({

		initialize: function () {
			console.log('init article');
			var self = this;
			self.$body = $('body');
			self.initModal();
		},

		events: {

		},

		initModal: function () {
			var self = this;
			OneDrawer.init({
				el: self.$body,
				drawerElem: '#press-modal',
				triggerEvent: 'click',
				triggerElem: '.press-modal-toggle',
				// openCallback: function(e){
				// 	console.log("open callback");
				// },
				// closeCallback: function(e){
				// 	console.log("close callback");
				// }
			});
		}
	});

	return ViewArticle;
});
define('page-article',[
  "view-article",
  "domReady",
  "jquery"
], function (ViewArticle, domReady, $) {

  "use strict";

  // Global requires
  domReady(function(){
    console.log('init article');
      new ViewArticle({el: $('#MainContent')});
  });

});

define('view-about',[
    'jquery',
    'module-oneVideo',
    'slick'
], function ($, OneVideo) {

    "use strict";

    var ViewAbout = Backbone.View.extend({

        initialize: function(opts){
            var self = this;
            self.$content = self.$el;
            self.$sliders = self.$content.find('.product-slider');
            self.$infoDropdowns = self.$content.find('.info-dropdown');
            self.$aboutUsHero = self.$content.find('#about-us-hero');

            console.log(self.$aboutUsHero, "herer");
           
            if(self.$aboutUsHero.length > -1){
                self.initVideo();
            }
            // if(self.$sliders.length > -1){
            //     self.productSlider();
            // }
            // if(self.$infoDropdowns.length > -1){
            //     self.infoDropdowns();
            // }
        },

        events: {
            
        },

        initVideo: function() {
            console.log("init video");
            var self = this;
            self.$videoBoxes = self.$aboutUsHero.find('.video-box');

			OneVideo.init({
                el: self.$videoBoxes
            });
        },

        productSlider: function(){
            var self = this;

            self.$sliders.slick({
                dots: false,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows: true,
                centerMode: true,
                centerPadding: '20%',
                prevArrow: '<button class="slick-arrow slick-prev"></button>',
                nextArrow: '<button class="slick-arrow slick-next"></button>'
            });
        },

        infoDropdowns: function(){
            var self = this;
            console.log("infodropdowns");

            function slideToggle($dropdown){
                var $content = $dropdown.find('.dropdown-content');
                var height = $content.children().outerHeight();
                if($dropdown.hasClass('open')){
                    $content.css('height', height);
                }else{
                    $content.css('height', 0);
                }
            }

            var events = {
                'click .info-dropdown': function(e){
                    console.log("infodropdowns click");
                    $(e.currentTarget).toggleClass('open');
                    slideToggle($(e.currentTarget));
                }
            };

            _.extend(self.events, events);
            self.delegateEvents();

        },
        
        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w < ORW.responsiveSizes.medium) {
                return true;
            }
            return false;
        }

    });

    return ViewAbout;

});
define('page-about',[
    "view-about",
    "domReady",
    "jquery"
], function (ViewAbout, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
    	console.log('init about');
        new ViewAbout({el: $('#MainContent')});
    });

});

define('view-stores',[
  'jquery',
  'slick'
], function ($) {
  var ViewStores = Backbone.View.extend({
    initialize: function (opts) {
      var self = this;
      self.$slider = $('.slick-store-slider');

      console.log('SLIDER: ', self.$slider);
      if (self.$slider.length > 0) {
        self.initSlider();
      }
    },

    initSlider: function () {
      var self = this;
      self.$slider.slick({
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 5000,
        lazyLoad: 'ondemand'
      });
    }
  });

  return ViewStores;
});
define('page-stores',[
  'view-stores',
  'domReady',
  'jquery'
], function (ViewStores, domReady, $) {
  'use strict';

  domReady(function () {
    console.log('init stores');
    new ViewStores({ el: $('#MainContent') });
  });
});
define('view-cart',[
    'jquery',
	'module-oneDrawer',
], function ($,OneDrawer) {

    "use strict";

    var ViewCart = Backbone.View.extend({

        // Cart Init Function
		initialize: function (opts) {
			var self = this;
			if (self.cookiesEnabled()) {
				document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
			}
			self.$content = self.$el;
			self.$body = $('body');
			self.$availabilityList = self.$content.find('.pickup-availabilities-modal');
			self.cartJSON = $('[data-cart-json]').length ? JSON.parse($('[data-cart-json]').html()) : false;
			self.availabilityJSON = [];
			self.firstSelectedStoreId;
			self.latitude;
            self.longitude;
			self.availabilityDistanceLimit = Number($('[data-pickup-distance-limit]').val()); // Uses miles as unit
			self.initCart();
			self.initCollectionMethods();
			self.initWishlist();

            // self.responsiveQty();
		},

		events: {
			'change select.update-qty': 'submitCart'
		},

		initCart: function () {
			// ajaxCart.init({
            //     formSelector: '#cart-form',
            //     addToCartSelector: '.add-to-cart-btn',
            //     cartContainer: '#CartContainer',
            //     cartCountSelector: '.minicart-count',
            //     cartCostSelector: '#CartCost',
            //     moneyFormat: theme.moneyFormat
			// });

			// setTimeout(function () {
			// 	console.log($('.js-qty__num'));
			$('body').on('change input', '.js-qty__num', function () {
				console.log('QTY CHAGNE')
			});
		},

		submitCart: function(e){
			var self = this;
			self.$cartForm.submit();
		},

		initWishlist: function() {
      $(document).on("click", "a.iWishAdd" , function() {
        console.log('wish add')
				e.preventDefault();
				const variantId = $(this).data('product').toString();

				iwish_add($(this), variantId);
        $(this).parent().remove();
      });
		},

		/**
		* Browser cookies are required to use the cart. This function checks if
		* cookies are enabled in the browser.
		*/
		cookiesEnabled: function() {
			var cookieEnabled = navigator.cookieEnabled;

			if (!cookieEnabled){
				document.cookie = 'testcookie';
				cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
			}
			return cookieEnabled;
		},

		// Author: Pat McNamara
		// Description: js-qty selector js does not like to have a mobile and desktop specific input,
		// so we clone it and remove the original for screens larger than mobile.
		responsiveQty: function(){
			var self = this;
			if($(window).width() < ORW.responsiveSizes.large){
				self.$cartRow.each(function(){
					var mobileQty = $(this).find('.qty-mobile');
					var desktopQty = $(this).find('.qty-desktop');
                    var $clone = desktopQty.clone(true);
                    $clone.removeClass('qty-desktop').addClass('cloned-qty');
					mobileQty.html($clone);
					desktopQty.remove();
				});
			}
		},

		initCollectionMethods: function() {
			let self = this;
			const storedVariantAvailability = JSON.parse(localStorage.getItem('variantAvailability'));

			// Get availability data
			$('[data-line-item-id]').each(function() {
				const lineItemId = $(this).data('lineItemId');
				const variantId = $(this).data('variantId');
				
				storedVariantAvailability.forEach(variant => {
					if (variant.variant_id === variantId) {
						variant.line_item_id = lineItemId;
						self.availabilityJSON.push(variant);
					} 
				})

			})

			// Update store selection with first line item's selected store, if any
			for (let lineItem of self.availabilityJSON) {
				self.firstSelectedStoreId = lineItem.stores.find(store => store.selected) ? lineItem.stores.find(store => store.selected).location.id : undefined;
				if(self.firstSelectedStoreId !== undefined) break;
			}

      // Initialize availability modal
			self.$availabilityList = OneDrawer.init({
				el: self.$body,
				drawerElem: '#availability-list',
				triggerEvent: 'click',
				triggerElem: '#ChangePickupLocation',
				openCallback: function(){
				}
			});

			$('#HomeDelivery').on('click', function(e) {
				e.preventDefault();

				self.switchToShipping();
			});

			$('#InstorePickup').on('click', function(e) {
				e.preventDefault();


				// Don't run if pickup is already active
				if ($('#InstorePickup').hasClass('active')){
					return;
				}

				if (self.cartJSON.selected_store_id) {
					self.updateStoreSelection(self.cartJSON.selected_store_id);
				} else if (self.firstSelectedStoreId) {
					self.updateStoreSelection(self.firstSelectedStoreId);
				} else { // If there's no previously selected store, use the first store instead
					self.availabilityJSON.forEach(lineItem => {
						if (lineItem.stores.length > 0) {
							self.updateStoreSelection(lineItem.stores[0].location.id)
						}
					})
				}
			});

			$('#ChangePickupLocation').on('click', function(e) {
				e.preventDefault();
			});

			$('#SwitchToShipping').on('click', function(e) {
				e.preventDefault();
				self.switchToShipping();
			})
			
			$('#SelectStore').on('click', function(e) {
				e.preventDefault();
				const selectedStoreId = Number($('.pickup-availabilities-list input[type="radio"][name="selected_store"]:checked').val());

				self.updateStoreSelection(selectedStoreId);
			})

			self.buildAvailabilityModal();

			if (self.cartJSON.selected_store_id) {
				self.updateStoreSelection(self.cartJSON.selected_store_id);
			} else if (self.firstSelectedStoreId) {
				self.updateStoreSelection(self.firstSelectedStoreId);
			} else {
				self.switchToShipping();
			}
		},

		buildAvailabilityModal: function() {
			let self = this;
			const storeOptions = [];
			const storeOptionsIds = [];

			// Get all potential store options
			self.availabilityJSON.forEach(line_item => {
				line_item.stores.forEach(store => {
					if (!storeOptionsIds.includes(store.location.id)) {
						storeOptions.push(Object.assign({}, store));
						storeOptionsIds.push(store.location.id);
					}
					// Set availability to false if any line item has a store with no availability
					if (store.available.toLowerCase() === 'false') {
						storeOptions.forEach(storeOption => {
							if (storeOption.location.id === store.location.id) Object.assign(storeOption, {available: "false"});
						})
					}
				})
			});
			
			function getDistance(lat1, lon1, lat2, lon2) {
                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                }
                else {
                    let radlat1 = Math.PI * lat1/180;
                    let radlat2 = Math.PI * lat2/180;
                    let theta = lon1-lon2;
                    let radtheta = Math.PI * theta/180;
                    let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180/Math.PI;
                    dist = dist * 60 * 1.1515;
                    return dist;
                }
            }

			// Update availability data with distances
			storeOptions.forEach(storeOption => {
				const storeLatitude = storeOption.location.latitude;
				const storeLongitude = storeOption.location.longitude;

				Object.assign(storeOption, {distance: getDistance(self.latitude, self.longitude, storeLatitude, storeLongitude)});
			});



			// Set availability to false if a line item doesn't have data for a store
			// Shopify only provides store data if the store stocks the line item product, so it is not available for pickup at a store if there is no data for it
			// storeOptions.forEach(storeOption => {
			// 	self.availabilityJSON.forEach(line_item => {
			// 		let hasStoreData = false;

			// 		line_item.stores.forEach(store => {
			// 			if (store.location.id === storeOption.location.id) hasStoreData = true;
			// 		})

			// 		if (!hasStoreData) {
			// 			Object.assign(storeOption, {available: "false"});
			// 		}
			// 	})
			// })

			$('.pickup-availabilities-list').empty();

			storeOptions.forEach(storeOption => {
				if (storeOption.distance > self.availabilityDistanceLimit && self.availabilityDistanceLimit !== 0) return;

				const $storeOption = `
				<li>
				<label class="pickup-availability-list__item" data-location-id="${storeOption.location.id}">
					<input 
					for="${storeOption.location.name}" 
					type="radio" id="${storeOption.location.name}" 
					name="selected_store" 
					value="${storeOption.location.id}"
					>
					<div class="pickup-availability-list__container">
					<img class="pickup-availability-list__image" src="${storeOption.image_url}" alt="Image of the ${storeOption.location.name} location storefront" />
					<div class="pickup-availability-list__info">
						<h3 class="pickup-availability-list__location">
						${storeOption.location.name}
						</h3>
						<address class="pickup-availability-list__address">
							<p>${storeOption.location.address.street}</p>
							<p>${storeOption.location.address.city}, ${storeOption.location.address.province_code} ${storeOption.location.address.zip}</p>
						</address>
					</div>
					</div>
				</label>
				</li>`

				$('.pickup-availabilities-list').append($storeOption);
			});

			// Disable in-store pickup option if there are no remaining store options
			if ($('.pickup-availabilities-list').children().length < 1) {
				$('#InstorePickup').text('No Stores Nearby').prop('disabled', true);
				$('#HomeDelivery').trigger('click');
			} else {
				$('#InstorePickup').prop('disabled', false);
			}
		},

		switchToShipping: function() {
			let newSubtotal = 0; 

			$('#HomeDelivery').addClass('active');
			$('#InstorePickup').removeClass('active');
			$('.cart-pickup-display').hide();
			$('.item-availability').hide();

			$('#cart-table-unavailable .responsive-table-row').each(function() {
				$(this).appendTo('#cart-table-available tbody');
			});

			if ($('#cart-table-unavailable .responsive-table-row').length < 1) {
				$('.cart-items-unavailable').hide();
			}

			// Update subtotal text
			$('#cart-table-available [data-line-item-id]').each(function() {
				const lineItemSubtotal = Number($(this).data('lineItemSubtotal'));
				newSubtotal += lineItemSubtotal;
			})
			newSubtotal = Shopify.formatMoney(newSubtotal).replace('.00','');
			$('#cart-totals .subtotal p:nth-child(2)').text(newSubtotal);

			// Set cart attribute
			$.ajax({
				type: "POST",
				async: false,
				url: window.Shopify.routes.root + 'cart/update.js',
				data: {attributes: {collection_method: 'HomeDelivery'}},
				dataType: 'json',
				success: function(data) {},
				error: function(jqXHR, textStatus, errorThrown) {
					  console.error("Error, status = " + textStatus + ", " +
							"error thrown: " + errorThrown
					  );
				}
			  });
		},

		updateStoreSelection: function(selectedStoreId) {
			let self = this;
			let newSubtotal = 0; 
			let selectedStoreName;
			selectedStoreId = Number(selectedStoreId);

			self.availabilityJSON.forEach(lineItem => {
				lineItem.stores.forEach(store => {
					if (store.location.id === selectedStoreId) {
						selectedStoreName = store.location.name;
					}
				})
			})

			// If a previously selected store is no longer an option, clear the selected store cart attributes
			if (!selectedStoreName) {
				const newCartJSON = {
					collection_method: "InstorePickup",
					selected_store: null,
					selected_store_id: null
				};
				
				// Clear any store selections made from cart
				$.ajax({
					type: "POST",
					async: false,
					url: window.Shopify.routes.root + 'cart/update.js',
					data: {attributes: newCartJSON},
					dataType: 'json',
					success: function(data) {
						self.cartJSON = newCartJSON
					},
					error: function(jqXHR, textStatus, errorThrown) {
							console.error("Error, status = " + textStatus + ", " +
								"error thrown: " + errorThrown
							);
					}
				});
				$('#HomeDelivery').trigger('click');
				return;
			}

			$('#InstorePickup').addClass('active');
			$('#HomeDelivery').removeClass('active');

			if ($('.cart-pickup-display').css('display') === 'none'){
				$('.cart-pickup-display').show();
			}

			$('.cart-pickup-location-text span').text(selectedStoreName);

			// Check for line item availability at store
			self.availabilityJSON.forEach(lineItem => {
				const $lineItem = $(`[data-line-item-id="${lineItem.line_item_id}"]`);
				const $lineItemAvailability = $lineItem.find('.item-availability');
				const lineItemStoreIds = lineItem.stores.map(store => store.location.id);

				// If line item's availability does not contain the selected store, it's unavailable
				if (!lineItemStoreIds.includes(selectedStoreId)) {
					const lineItemAvailabilityText = `UNAVAILABLE FOR PICKUP AT <span>${selectedStoreName}</span>`;

					$lineItemAvailability.html(lineItemAvailabilityText);
					$lineItemAvailability.show();
					$lineItem.appendTo('#cart-table-unavailable tbody');
					$('.cart-items-unavailable').show();
					return;
				}
				lineItem.stores.forEach(store => {
					if(store.location.id === selectedStoreId) {
						if (store.available.toLowerCase() === 'false') {
							const lineItemAvailabilityText = `UNAVAILABLE FOR PICKUP AT <span>${selectedStoreName}</span>`;

							$lineItemAvailability.html(lineItemAvailabilityText);
							$lineItemAvailability.show();
							$lineItem.appendTo('#cart-table-unavailable tbody');

							$('.cart-items-unavailable').show();
						} else {
							const lineItemAvailabilityText = `AVAILABLE FOR PICKUP AT <span>${selectedStoreName}</span>`;

							$lineItemAvailability.html(lineItemAvailabilityText);
							$lineItemAvailability.show();
							$lineItem.appendTo('#cart-table-available tbody');
						}
					}
				})
			});

			if ($('#cart-table-unavailable .responsive-table-row').length < 1) {
				$('.cart-items-unavailable').hide();
			}

			// Update subtotal text
			$('#cart-table-available [data-line-item-id]').each(function() {
				const lineItemSubtotal = Number($(this).data('lineItemSubtotal'));
				newSubtotal += lineItemSubtotal;
			})
			newSubtotal = Shopify.formatMoney(newSubtotal).replace('.00','');
			$('#cart-totals .subtotal p:nth-child(2)').text(newSubtotal);

			// Show warning text
			if ($('#cart-table-unavailable tbody .responsive-table-row').length > 0) {
				$('.cart-pickup-warning').show();
			} else {
				$('.cart-pickup-warning').hide();
			}

			// Select in modal
			$(`.pickup-availability-list__item[data-location-id="${selectedStoreId}"] input`).prop('checked',true);

			// Set cart attribute
			$.ajax({
				type: "POST",
				async: false,
				url: window.Shopify.routes.root + 'cart/update.js',
				data: {attributes: {
					collection_method: 'InstorePickup',
					selected_store: selectedStoreName,
					selected_store_id: selectedStoreId
				}},
				dataType: 'json',
				success: function(data) {
					self.cartJSON = data.attributes;
				},
				error: function(jqXHR, textStatus, errorThrown) {
					  console.error("Error, status = " + textStatus + ", " +
							"error thrown: " + errorThrown
					  );
				}
			});
		}

    });

    return ViewCart;

});
define('page-cart',[
    "view-cart",
    "domReady",
    "jquery"
], function (ViewCart, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
        console.log('init cart page');
        new ViewCart({el: $('.cart-wrap')});
    });

});

define('view-iwish',[ 'jquery' ], function ($) {

  'use strict';

  var ViewIWish = Backbone.View.extend({

    initialize: function () {
      this.initSocialShareIcons();
    },

    initSocialShareIcons: function () {
      var $icons = $('.iwishShareBtn');
      $icons.text('');
    },

  });

  return ViewIWish;

});


define('page-iwish',[ 'jquery', 'view-iwish', 'domReady!' ], function ($, ViewIWish) {

  'use strict';
  
  console.log('init app-iwish');
  (new ViewIWish({ el: $('#MainContent') })).initialize();

});

define('view-appointment',[
    'jquery',
    'module-oneDrawer'
], function ($, OneDrawer) {

    "use strict";

    var ViewAppointment = Backbone.View.extend({

        initialize: function(){
            var self = this;
            self.$body = $('body');

            self.appointmentModal();
            self.stylistAppointmentModal();
            self.sectionBackToTop();

        },

        events: {
            
        },

        appointmentModal: function(){
            var self = this;
            OneDrawer.init({
                el: self.$body,
                drawerElem: '#bookAppointmentModal',
                triggerEvent: 'click',
                triggerElem: '[data-book-app-cta]',
                // openCallback: function(e){
                //  console.log("open callback");
                // },
                // closeCallback: function(e){
                //  console.log("close callback");
                // }
            }); 

        },

        stylistAppointmentModal: function(){
            var self = this;

            $('.book-app-stylist-cta').on('click', function (e) {
                var stylist = $(e.currentTarget).attr('data-stylist');
                $('#bookAppointmentStylistModal .drawer-inner h3').after(stylist);
            });

            OneDrawer.init({
                el: self.$body,
                drawerElem: '#bookAppointmentStylistModal',
                triggerEvent: 'click',
                triggerElem: '.book-app-stylist-cta',
                // openCallback: function(e){
                //  console.log("open callback");
                // },
                closeCallback: function(e){
                 console.log("close callback");
                 $('#bookAppointmentStylistModal .drawer-inner iframe').remove();
                }
            }); 

        },

        sectionBackToTop: function(){
            var self = this;
            var events = {
                'click .section-back-to-top': function(e){
                    e.preventDefault();
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            };

            _.extend(self.events, events);
            self.delegateEvents();
        },
        
        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w < ORW.responsiveSizes.medium) {
                return true;
            }
            return false;
        }

    });

    return ViewAppointment;

});
define('page-appointment',[
    "view-appointment",
    "domReady",
    "jquery"
], function (ViewAppointment, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
    	console.log('init appointment page');
        new ViewAppointment({el: $('#MainContent')});
    });

});

}());

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('[data-wishlist-size-selector]');
  const sizeWrap = document.querySelector('[data-wishlist-button-wrap]');
  if (btn && sizeWrap) {
    document.addEventListener('click', (e) => {
      if (e.target.closest('button') != btn) {
        document.body.classList.remove('select-product-size');
      } else {
        const sizeOption = document.querySelector('[name="option-size"]');
        if (sizeOption && (sizeOption.value == 'Choose a size' || sizeOption.value == 'Select size')) {
          // If no size selected
          document.body.classList.remove('product-size-selected');
          document.body.classList.add('select-product-size');
  
          setTimeout(() => {
            document.body.classList.remove('select-product-size');
          }, 2000)
        } else {
          document.body.classList.remove('select-product-size');
          document.body.classList.add('product-size-selected');
        }
      }
    })
  }
})